import {
  useState,
  useEffect,
  useCallback,
  useLayoutEffect,
  useRef,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";

import PendingIcon from "@mui/icons-material/Pending";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SendIcon from "@mui/icons-material/Send";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import Box from "@mui/material/Box";
import {
  fcheck_null_undefine_replace_empty,
  fcovertToNumber,
  OpenPdfInDefaultApp,
} from "../../Utility/Utilitys";
import GCDiscountPercentage from "../../Component/Common/ReuseableComponent/GCDiscountPercentage";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import GCBatch from "../../Component/Common/ReuseableComponent/GCBatch";
//file
// import sliderRigh from '../../Image/sliderRigh.png'
import GCSimpleSearch from "../../Component/Common/ReuseableComponent/GCSimpleSearch";
import GCSearchBtn from "../../Component/Common/ReuseableComponent/GCSearchBtn";
import {
  fAlertToast,
  fCalculate_Detail,
  GetGitterColumns,
} from "../../Utility/Utilitys";
import { fExecuteAPI } from "../../Server/Apis";
import {
  fKeyTabInput,
  fFocusInput,
  GetLinkDocument,
} from "../../Utility/Utilitys";

import {
  WmsInboundOutletRo,
  KernCAConfig,
  vRdxUserInfo,
} from "../../Redux/roStore";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import Footer from "./processComponent/Footer";
import GCEmployee from "../../Component/Common/ReuseableComponent/GCEmployee";
import GCVanMaster from "../../Component/Common/ReuseableComponent/GCVanMaster";
import GCReverse from "../../Component/Common/ReuseableComponent/GCReverse";
import {
  Set_HeadObject_Set,
  Set_HeadObject_Init,
} from "./SliceWmsInboundOutlet";
import "./WmsInboundOutlet.css";
import {
  Set_HeadObject_TaxType,
  Set_HeadObject_A_DocStat,
  Wms_HeadObject_New_Set,
  Wms_HeadObject_RefNo_ExactSearch_Set,
} from "./SliceWmsInboundOutlet";

import {
  CmpButton,
  CmpButtonKIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import GCLandedCost from "../../Component/Common/ReuseableComponent/GCLandedCost";
import {
  fRightClick,
  fLeftClick,
  sFocFlagArr,

  //GCLOADECOST
  sLoadedCostAccountArr,
  sLoadedCostToggleData,
  Loaded_Cost_Freight_Init,
  Get_LoadedCost,
  Get_Loaded_Cost_WMINV03D_GetRow,
  sPaymode,
  sTax,
  sFrom,
  sTrnTyp,
  TypeArr,
  sStatusArr,
  fKey,
  fKeyContent,
  GetSalesGroups,
  GetDefaultDrCrAccount,
  GetRefDocInbound,
  GetUnitArr,
 
  GetUnitRateArr,
  GetItemFullSearchArr,
  ItemSearchData,
  GetSearchItem,
  fItemCodeDependency,
  ErrorMsg,
  ErrorMsgDetail,
  BatchDetail_ErrorMsg_Init,
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fSaveHead,
  fDisplay,
  //refdoc
  fRefDocRowClick,
  fCloseRefDocSearchModal,
  vHeaderSearchInit,
  //reverse
  fCloseReverseTransactionModal,
  fReverse,
  GetTransTaxType,
  fDefaultPayload,
  //batch
  fValidationBatch_Client,
  GetSaveDetailBatch,
  GetDeleteDetailBatch,
  GetBatchDetail,
  //Approve

  //ref doc
  fReset_Linewise_Rebate,
  fBuyer_or_SalesMan,
  fBuyer_or_SalesMan_Arr,
  fDiscFlagDependency,
  GetDefcustomersetting,

  //GC customer
  Get_ToggleDropDown_Load,
  // xGC_Toggle_Head_Customer_GridColumns,
  xGC_Toggle_Head_Customer_DropDown_Arr,
  Get_GCSearchBtn,
  // xGCSearchBtn_Columns_DropdownSearch,
  getQtyViewDetails,
  GetAttributes,
  getTransItemStockUOM,
  GetMSPUpdate,
  GetPengingPo,
  GetPallet,
  getRcvngPost,
  GetdRefNoV2,
  GetReason,
  Unit_Onchange_001,
} from "./WmsInboundOutletAction";
// import { set } from 'date-fns/esm';
import { fCheck_Doc_Rights_001 } from "../../Utility/Utilitys";
import { FShortCutKey } from "../../Utility/Utilitys";
import GCAccountDetail from "../../Component/Common/ReuseableComponent/GCAccountDetail";
import { GetAccountPostingDetail } from "../../Utility/Utilitys";
import GCMenuBtn from "../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCMSPUpdate from "./processComponent/GCMSPUpdate";
import GCLinkDocument from "../../Component/Common/ReuseableComponent/GCLinkDocument";
import {
  ApproveWMINV03_Outlet_GETROW,
  ApproveWMINV03confirm_Outlet,
  deleteDetailWMINV03_Outlet,
  deleteHeadWMINV03_Outlet,
  RSPUpdate_OUTLET,
  TaxAddRemove_OUTLET,
  TaxConvertUpdate_OUTLET,
  updateInvTransManualListing_OUTLET,
  validationWMINV03_Outlet_GETROW,
  WMSIInbound_WMINV03MSPSave_API,
  WMSInbound_ConfirmWMINV03LineItem_GETROW,
  WMSInbound_ReverseWMINV03_GETROW,
} from "../../Server/ApiV2";
import GCPendingStock from "./processComponent/GCPendingStock";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import GCPallet from "./processComponent/GCPallet";
import GCAuditTblCard from "../../Component/Common/ReuseableComponent/GCAuditTblCard";
import { DetailTblCard } from "./processComponent/DetailTblCard";
import GCHead from "./processComponent/GCHead";
import GCContent from "./processComponent/GCContent";
import GcReferenceUpdate from "./processComponent/GcReferenceUpdate";
import GCLoadFromPo from "./processComponent/GCLoadFromPo";
import GCNAV from "../../Component/Common/ReuseableComponent/GCNAV";

export default function WmsInboundOutlet() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const FocusOnLoad = useRef(null);
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value
  const [sRigntClick, setRigntClick] = useState(false); // nav bar arrow input value

  const location = useLocation();

  //if GRNDocTyp, GrnDocNo is not empty then it is from notification page
  // so redirect to notification page in mobile screen
  const { GRNDocTyp, GrnDocNo, RefNo, RefVocNo, RefVocTyp } =
    !!location.state
      ? location.state
      : {
          GRNDocTyp: "",
          GrnDocNo: "",
          RefNo: "",
          RefVocNo: "",
          RefVocTyp: "",
          RefVocName: "",
        };

  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxWmsHead = useSelector(
    (state) => state.SliceWmsInboundOutlet.value.HeadObject
  );

  const vRdxDBBranchList = useSelector(
    (state) => state.SliceDB.value.DBBranchList
  );
  const vRdxGRNtax1 = useSelector((state) => state.SliceGRN.value.tax.tax1);
  const vRdxGRNtax2 = useSelector((state) => state.SliceGRN.value.tax.tax2);
  const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);
   const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [xWMS_AUTO_BATCH, setxMS_AUTO_BATCH] = useState("N");
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value
  const [sCheckboxRights, SetCheckboxRights] = useState({
    A_PutAway: true,
    A_AutoBatch: true,
  });
  
  const [sRoundingVal, setRoundingVal] = useState(vRdxDBKernObj.DIGIT_ROUNDING?.Val||2);  
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });
  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });

  const [sStockObj, setStockObj] = useState({
    BalanceQty: 0,
    POQty: 0,
    GRNQty: 0,
  });
  const [sTransItemStockObj, setTransItemStockObj] = useState({
    RPStock: 0,
    MSP: 0,
    CostPr: 0,
    LPRate: 0,
  });
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);
 
  const [sArr, setArr] = useState([]);
  const [sGCSeachSalesGroupSearch, setGCSeachSalesGroupSearch] = useState([]); //GCSeachSalesGroupSearch Select

  //HEAD
   const [sVehicleType, setVehicleType] = useState([{ UId: "", Name1: "" }]);
    const [sVehicleCapacity, setVehicleCapacity] = useState([{ UId: "", Name1: "" }]);
  const [sTeleUser, setTeleUser] = useState([{ UId: "", Name1: "" }]);
  const [sDocLoading, setDocLoading] = useState([]);
  const [sVirtualBin, setVirtualBin] = useState([]);
  const [sUnloading, setUnloading] = useState([]);
  const [sCurrency, setCurrency] = useState([]);
  const [sPalletType, setPalletType] = useState([]);
  const [sReason, setReason] = useState([]);
  const [sBuyer, setBuyer] = useState([]); //sBuyer Select
  const [sSalesGroupData, setSalesGroupData] = useState([]); //sSalesGroup Select
  const [sErrorMsg, setErrorMsg] = useState(ErrorMsg);
  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);
  const [sPaymodeEnable, setPaymodeEnable] = useState(true); //to set paymode enable or disable
  const initialFooterState = {
    A_GrossAmt: (0).toFixed(sRoundingVal),
    A_TDiscAmt: (0).toFixed(sRoundingVal),
    A_LDiscAmt: (0).toFixed(sRoundingVal),
    A_FocAmt: (0).toFixed(sRoundingVal),
    A_NetExcise: (0).toFixed(sRoundingVal),
    A_Tax: (0).toFixed(sRoundingVal),
    A_Tax2: (0).toFixed(sRoundingVal),
    A_AddCess: (0).toFixed(sRoundingVal),
    A_LandVal: (0).toFixed(sRoundingVal),
    A_SplDiscAmt1: (0).toFixed(sRoundingVal),
    A_NetAmt: (0).toFixed(sRoundingVal),
  };
  const [sFooterObj, setFooterObj] = useState(initialFooterState);

  //DETAIL
  const [sUnit, setUnit] = useState([]);
  const [isSaveLoaded, setSaveLoaded] = useState(false);
  const [sDetailGridData, setDetailGridData] = useState([]); //DetailGridData Select
  const [sIncentiveGroups, SetIncentiveGroups] = useState([]); //IncentiveGroups Select
  const [sSupervisorSlabs, setSupervisorSlabs] = useState([]); //SupervisorSlabs Select
  const [sOtherSlabs, setOtherSlabs] = useState([]); //OtherSlabs Select

  let vBufferObjInit = {
    B_Srno: 0, // int

    B_RefDocTyp: "",
    B_RefDocTypName: "",
    B_RefDocNo: "",
    SuppRefNo1: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_Barcode: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_CI: "",
    B_Unit: "",
    B_UnitName: "",
    PalletType: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_BaseQty: (0).toFixed(sRoundingVal), //Decimal
    PackDesc: "",
    B_URateFc: (0).toFixed(sRoundingVal), //Decimal
    B_URateLc: (0).toFixed(sRoundingVal), //Decimal
    B_GrossAmt: (0).toFixed(sRoundingVal), //Decimal
    B_LDiscPerc: (0).toFixed(sRoundingVal), //Decimal
    B_LDiscAmt: (0).toFixed(sRoundingVal), //Decimal
    B_TDiscPerc: (0).toFixed(sRoundingVal), //Decimal
    B_TDiscAmt: (0).toFixed(sRoundingVal), //Decimal
    B_FocFlag: "N",
    B_AprmtFlag: sFocFlagArr[0],
    B_FocAmt: (0).toFixed(sRoundingVal), //Decimal
    B_ExciseTaxAmt: (0).toFixed(sRoundingVal), //Decimal
    B_ExciseTaxNetAmt: (0).toFixed(sRoundingVal), //Decimal
    B_NetAmt: (0).toFixed(sRoundingVal), //Decimal
    B_Base_Rate: (0).toFixed(sRoundingVal), //Decimal
    B_TaxDept: vRdxGRNtax1[0].UId,
    B_TaxPerc: vRdxGRNtax1[0].Perc, //Decimal
    B_TaxAmt: (0).toFixed(sRoundingVal), //Decimal
    B_TaxDept2: vRdxGRNtax2[0].UId,
    B_TaxPerc2: vRdxGRNtax2[0].Perc, //Decimal
    B_TaxAmt2: (0).toFixed(sRoundingVal), //Decimal
    B_Ad_CessAmt: (0).toFixed(sRoundingVal), //Decimal
    B_Ad_PCQty: (0).toFixed(sRoundingVal), //Decimal
    AddCess: (0).toFixed(sRoundingVal), //Decimal
    B_NetAddCess: (0).toFixed(sRoundingVal), //Decimal
    B_Total: (0).toFixed(sRoundingVal), //Decimal
    B_HSN: "",
    B_HighCost: "N",
    B_PR: "N",
    B_ExpDt: new Date(),
    B_Narr: "",
    B_X_URateLc: (0).toFixed(sRoundingVal), //Decimal
    B_X_DiffAmt: (0).toFixed(sRoundingVal), //Decimal
    B_X_NetDiffAmt: (0).toFixed(sRoundingVal), //Decimal
    RebateType: TypeArr[0].Uid,
    ReduceCost: "N",
    SplDiscPerc: (0).toFixed(sRoundingVal),
    SplDiscAmt: (0).toFixed(sRoundingVal),
    SplDisc: (0).toFixed(sRoundingVal),
    Narration: "",
    //ExtraAdded
    B_LandVal: "",
    B_IncGroup: "",
    B_SuprvPerc: (0).toFixed(sRoundingVal),
    B_OthersPerc: (0).toFixed(sRoundingVal),
    B_SLANSuprv: "",
    B_SlabAmtSuprv: (0).toFixed(sRoundingVal),
    B_SLANOther: "",
    B_SlabAmtOther: (0).toFixed(sRoundingVal),
  };

  const [sBufferObj, setBufferObj] = useState(vBufferObjInit);

  //Modal

  //Reverse
  const [sReverseTransactionModal, setReverseTransactionModal] =
    useState(false);
  const [sRevNarr, setRevNarr] = useState(""); //for Reverse API

  const [sDiscountPercentageModal, setDiscountPercentageModal] =
    useState(false);

  const fCloseDiscountPercentageModal = (e) => {
    setDiscountPercentageModal(false);
    setErrorMsgDiscountModal((obj) => ({
      ...obj,
      A_TDiscAmt: "",
      A_DiscPerc: "",
    }));
  };

  const fOpenDiscountPercentageModal = (e) => {
    setDiscPerModelObj({
      A_TDiscAmt: sFooterObj.A_TDiscAmt,
      A_DiscPerc: vRdxWmsHead.A_DiscPerc,
    });
    setDiscountPercentageModal(true);
  };

  const [sDiscPerModelObj, setDiscPerModelObj] = useState({
    A_TDiscAmt: sFooterObj.A_TDiscAmt,
    A_DiscPerc: vRdxWmsHead.A_DiscPerc,
  });
  const [sErrorMsgDiscountModal, setErrorMsgDiscountModal] = useState({
    A_TDiscAmt: "",
    A_DiscPerc: "",
  });
  let vErrorMsgDiscountModalInit = {
    A_TDiscAmt: "",
    A_DiscPerc: "",
  };
  const fonChangeInputDiscountModal = (event) => {
    let vTDiscAmt =
      (fcovertToNumber(event.target.value) / 100) *
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    setDiscPerModelObj((obj) => ({
      ...obj,
      A_DiscPerc: Number(event.target.value),
      A_TDiscAmt: vTDiscAmt,
    }));
  };

  //DiscountAmt modal
  const fOnChangeTDiscAmtModal = (e) => {
    let vCheckValue =
      fcovertToNumber(sFooterObj.A_GrossAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt);
    let vTDiscPer =
      (fcovertToNumber(e.target.value) * 100) /
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    setDiscPerModelObj((obj) => ({
      ...obj,
      A_DiscPerc: vCheckValue === 0 ? 0 : fcovertToNumber(vTDiscPer),
      A_TDiscAmt: Number(e.target.value),
    }));
  };

  const fvalidateDiscount = () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    let iResp = true;
    if (sDiscPerModelObj.A_DiscPerc != 0 && sDiscPerModelObj.A_TDiscAmt == 0) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_TDiscAmt: "Check discount percentage",
      }));
      iResp = false;
    } else if (
      sDiscPerModelObj.A_DiscPerc == 0 &&
      sDiscPerModelObj.A_TDiscAmt != 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc: "Check discount percentage",
      }));
      iResp = false;
    } else if (
      Number(sDiscPerModelObj.A_DiscPerc > 100) ||
      Number(sDiscPerModelObj.A_DiscPerc) < 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc:
          "DiscPerc  must be greater than 0 and less than or equal to 100",
      }));
      iResp = false;
    }
    return iResp;
  };

  const GetApplyTDiscount = async () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    if (fvalidateDiscount()) {
      let vApplyTDiscountObj = {
        B_VocTyp: vRdxWmsHead.A_VocTyp,
        B_VocNo: vRdxWmsHead.A_VocNo,
        TDiscPerc: sDiscPerModelObj.A_DiscPerc,
      };
      const vApplyTDiscount = await fExecuteAPI(
        "Inbound_applyTDiscount_GETROW",
        vApplyTDiscountObj
      );
      if (vApplyTDiscount.Type?.toUpperCase() === "SUCCESS") {
        dispatch(
          Set_HeadObject_Set({
            ...vRdxWmsHead,
            A_DiscPerc: sDiscPerModelObj.A_DiscPerc,
          })
        );
        fCloseDiscountPercentageModal();
        fNewDetail(
          vRdxWmsHead.A_VocNo,
          vRdxWmsHead.A_Rounding,
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.TaxType
        );
        setTimeout(() => {
          document.getElementsByName("B_ItmName")[0]?.focus();
        }, 100);
      } else {
        fAlertToast(
          "FAILED",
          !!vApplyTDiscount.Message
            ? vApplyTDiscount.Message
            : vApplyTDiscount.response.data.message
        );
      }
    }
  };

  //HEAD FUNCTION
  const fGrnType = async (event) => {
    var vGrnType = sDocLoading?.find((obj, index) => {
      return obj.VocTyp === event.target.value;
    });

    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp: vGrnType?.VocTyp,
        A_VocTypName: vGrnType?.VocName,
      })
    );
    let { currentPayMode, PaymodeEnable } = fDefaultPayload(
      vGrnType.Paymode,
      dispatch
    );
    setPaymodeEnable(PaymodeEnable);
    GetDefaultDrCrAccount(
      vGrnType?.VocTyp,
      currentPayMode,
      vRdxWmsHead.A_Party,
      dispatch
    );
  };

  const fGrnDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: "",
        })
      );
    } else {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: event?.$d,
        })
      );
    }
  };

  const fInvNo = (event) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_RefNo: event.target.value,
      })
    );
  };

  const fInvDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: "",
        })
      );
    } else {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: event?.$d,
        })
      );
    }
  };

  const fForm = (event) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        InboundType: event.target.value,
        A_Party: "",
        A_PartyName: "",
        salesGroup: "",
        TeleUser: "",
      })
    );
    fDiscFlagDependency(event.target.value, dispatch);
    fBuyer_or_SalesMan(
      event.target.value,
      setBuyer,
      dispatch,
      vRdxWmsHead.A_Loc,
      vRdxWmsHead.A_VocTyp,
      vRdxWmsHead.A_VocNo
    );
    GetDefaultDrCrAccount(
      vRdxWmsHead.A_VocTyp,
      "CREDIT", //vRdxWmsHead.A_PayMode,
      vRdxWmsHead.A_Party,
      dispatch
    );
  };

  const fPaymode = (event) => {
    // dispatch(
    //   Set_HeadObject_Set({
    //     ...vRdxWmsHead,
    //     A_PayMode: event.target.value,
    //   })
    // );
    // GetDefaultDrCrAccount(
    //   vRdxWmsHead.A_VocTyp,
    //   event.target.value,
    //   vRdxWmsHead.A_Party,
    //   dispatch
    // );
  };

  const fInvAmt = (event) => {
    // dispatch(
    //   Set_HeadObject_Set({
    //     ...vRdxWmsHead,
    //     VendorInvAmount: event.target.value,
    //   })
    // );
  };

  const fTax = async (event) => {
    var vUnloading = sTax.find((option, index) => {
      return option.Uid === event.target.value;
    });
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        TaxType: vUnloading.Uid,
        A_CUSTFIELD3Name: vUnloading.Name,
      })
    );
    //if inter.comp then tax group should be 0
    if (vUnloading.Uid == "INTRN002" || vUnloading.Uid == "INTRN003") {
      InterCompanyDependency(vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val, vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val);
    } else {
      if (sBufferObj.B_Itmcd === "") {
        InterCompanyDependency(vRdxGRNtax1[0].UId, vRdxGRNtax2[0].UId);
      } else {
        let vItemSearchFull = await GetItemFullSearchArr(
          sBufferObj.B_Itmcd,
          vRdxWmsHead.A_Loc
        );
        if (vItemSearchFull.length > 0) {
          fItemCodeDependency(
            vItemSearchFull,
            vRdxWmsHead,
            sBufferObj,
            setBufferObj,
            setUnit,
            SetIncentiveGroups,
            setOtherSlabs,
            setSupervisorSlabs,
            vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
            vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
          );
        }
      }
    }
  };

  const fAutoBatch = (event) => {
    if (event.target.checked) {
      dispatch(Set_HeadObject_Set({ ...vRdxWmsHead, A_AutoBatch: "Y" }));
    } else {
      dispatch(Set_HeadObject_Set({ ...vRdxWmsHead, A_AutoBatch: "N" }));
    }
  };

  const fSourceDocNo = (e) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_RefDocNo: e.target.value,
      })
    );
  };

  const fUnloading = (event) => {
    var vUnloading = sUnloading.find((option, index) => {
      return option.UId === event.target.value;
    });
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        UnloadingBay: vUnloading?.UId,
        UnloadingBayName: vUnloading?.Name1,
      })
    );
  };

  const fvirtualBin = (event) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        virtualBin: event.target.value,
      })
    );
  };

  const fCurrency = (event) => {
    var vCurrency = sCurrency?.find((option, index) => {
      return option.Uid === event.target.value;
    });

    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_Curr: vCurrency.Uid,
        A_Currname: vCurrency.Name1,
        A_ExRate: vCurrency?.Rate,
      })
    );
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vCurrency?.Rate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vRdxGRNtax1[0].Perc,
      vRdxGRNtax2[0].Perc,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );
    // setsSelectedCurrency(event.target.value);
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };

  const fLocation = async (e) => {
    const vSalesGroup = await GetSalesGroups(e.target.value);
    setSalesGroupData(vSalesGroup);
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_Loc: e.target.value,
        salesGroup: !!vSalesGroup[0]?.UId ? vSalesGroup[0].UId : "",
      })
    );
    GetDefcustomersetting(
      vRdxWmsHead.Party,
      e.target.value,
      vRdxWmsHead.InboundType,
      dispatch
    );
    GetDefaultDrCrAccount(
      vRdxWmsHead.A_VocTyp,
      "CREDIT", // vRdxWmsHead.A_PayMode,
      vRdxWmsHead.A_Party,
      dispatch
    );
  };

  //GCCustomer Search

  const xfGC_Toggle_Head_Customer_Name = (e) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_PartyName: e.target.value,
      })
    );
  };

  const [
    sGC_Toggle_Head_Customer_SearchDropdownObj,
    setGC_Toggle_Head_Customer_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });

  const [
    sGC_Toggle_Head_Customer_GridData,
    setGC_Toggle_Head_Customer_GridData,
  ] = useState([]);
  const [
    sGC_Toggle_Head_Customer_ToggleDropDowm,
    setGC_Toggle_Head_Customer_ToggleDropDowm,
  ] = useState(false);

  const xfGC_Toggle_Head_Customer_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);
      setItemToggleDropdown(false);
      setGC_Toggle_Head_Customer_GridData([]);
      setGC_Toggle_Head_Customer_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_Customer_ToggleDropDowm(true);
      setItemToggleDropdown(false);
    }
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm]);

  //2nd call
  const fGC_Toggle_Head_Customer_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
        ...obj,
        Data: vRdxWmsHead.A_PartyName,
      }));
      if (vRdxWmsHead.A_PartyName != "") {
        const vExactSearch = await Get_ToggleDropDown_Load(
          vRdxWmsHead.A_PartyName,
          "Any",
          "C",
          "N",
          dispatch
        );
        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_Customer_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_Customer_GridData([]);
        }
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGC_Toggle_Head_Customer_Toggle();
    }
  };

  //1stcall
  const fGC_Toggle_Head_Customer_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        vRdxWmsHead.A_PartyName,
        "Any",
        "C",
        "Y",
        dispatch
      );

      if (vExactSearch.length > 0) {
        let vDefaultTaxType = sTax[0].Uid;
        let iDefaultTaxType = await GetTransTaxType(
          vRdxWmsHead.A_Loc,
          vExactSearch[0]?.AcCd,
          dispatch
        );
        if (Object.keys(iDefaultTaxType).length != 0) {
          vDefaultTaxType = iDefaultTaxType?.TaxType;
        }
        //if inter.comp then tax group should be 0
        if (vDefaultTaxType == sTax[1].Uid || vDefaultTaxType == sTax[2].Uid) {
          InterCompanyDependency(vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val, vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val);
        }
        dispatch(
          Set_HeadObject_Set({
            ...vRdxWmsHead,
            A_Party: vExactSearch[0]?.AcCd,
            A_PartyName: vExactSearch[0]?.Name1,
            TaxType: vDefaultTaxType,
          })
        );

        GetDefaultDrCrAccount(
          vRdxWmsHead.A_VocTyp,
          "CREDIT",
          vRdxWmsHead.A_PayMode,
          vExactSearch[0]?.AcCd,
          dispatch
        );
        setTimeout(() => {
          fKeyTabInput(e, "B_ItmName");
        }, 500);
      } else {
        fGC_Toggle_Head_Customer_Dropdown_SearchModalKey(e);
      }
      if (vRdxWmsHead.A_Party != "") {
        setTimeout(() => {
          fKeyTabInput(e, "B_ItmName");
        }, 500);
      }
    }
    if (e.key === "Backspace") {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_Party: "",
          A_PartyName: e.target.value,
        })
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-dropdown");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGC_Toggle_Head_Customer_Dropdown_onChange = (e) => {
    setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        sGC_Toggle_Head_Customer_SearchDropdownObj.Data,
        sGC_Toggle_Head_Customer_SearchDropdownObj.Type,
        "C",
        "N",
        dispatch
      );
      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_Customer_GridData(vExactSearch);
      } else {
        setGC_Toggle_Head_Customer_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGC_Toggle_Head_Customer_OnRowClick = async (e) => {
    let vDefaultTaxType = sTax[0].Uid;
    let iDefaultTaxType = await GetTransTaxType(
      vRdxWmsHead.A_Loc,
      e?.row?.AcCd,
      dispatch
    );
    if (Object.keys(iDefaultTaxType).length != 0) {
      vDefaultTaxType = iDefaultTaxType?.TaxType;
    }
    //if inter.comp then tax group should be 0
    if (vDefaultTaxType == sTax[1].Uid || vDefaultTaxType == sTax[2].Uid) {
      InterCompanyDependency(vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val, vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val);
    }
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_Party: e?.row?.AcCd,
        A_PartyName: e?.row?.Name1,
        TaxType: vDefaultTaxType,
      })
    );

    GetDefaultDrCrAccount(
      vRdxWmsHead.A_VocTyp,
      "CREDIT", //vRdxWmsHead.A_PayMode,
      e?.row?.AcCd,
      dispatch
    );

    xfGC_Toggle_Head_Customer_Toggle();
  };

  const fGC_Toggle_Head_Customer_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGC_Toggle_Head_Customer_OnRowClick(newSelectionModel);
    }
  };

  //GC CustomerSearch End
  //FOOTER FUNCTION
  const fBuyer = (e) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_Buyer: e.target.value,
      })
    );
  };
  const fFreight = (e) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_LC: e.target.value,
      })
    );
  };

  const fFreight_onFocus = (e) => {
    if (vRdxWmsHead.A_LC == 0) {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_LC: "",
        })
      );
    }
  };
  const fFreight_onBlur = (e) => {
    if (vRdxWmsHead.A_LC == "") {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_LC: 0,
        })
      );
    }
  };

  const fCustomer = (e) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_Charges1: e.target.value,
      })
    );
  };
  const fCustomer_onFocus = (e) => {
    if (vRdxWmsHead.A_LC == 0) {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_Charges1: "",
        })
      );
    }
  };
  const fCustomer_onBlur = (e) => {
    if (vRdxWmsHead.A_LC == "") {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_Charges1: 0,
        })
      );
    }
  };

  const fLoadedCost = (e) => {
    if (
      e._reactName == "onClick" &&
      vRdxWmsHead.A_VocNo != 0 &&
      !!vRdxWmsHead.A_VocNo
    ) {
      fOpenLandedCostModal();
    }
  };

  const fHeadNarration = (e) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_Narr: e.target.value,
      })
    );
  };

  const fLandValueCalc = (event) => {
    let iLandVal =
      fcovertToNumber(sFooterObj.A_GrossAmt) +
      fcovertToNumber(sFooterObj.A_SplDiscAmt1) -
      fcovertToNumber(sFooterObj.A_TDiscAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt) -
      fcovertToNumber(sFooterObj.A_FocAmt) +
      fcovertToNumber(sFooterObj.A_NetExcise) +
      fcovertToNumber(sFooterObj.A_Tax) +
      fcovertToNumber(sFooterObj.A_Tax2) +
      fcovertToNumber(sFooterObj.A_AddCess) +
      fcovertToNumber(Number(event.target.value));

    setFooterObj((obj) => ({
      ...obj,
      A_LandVal: iLandVal.toFixed(2),
    }));
  };

  const fFooter_Rounding_Blur = (e) => {
    const iRounding = fcovertToNumber(e.target.value);
    if (iRounding == 0) {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_Rounding: (0).toFixed(4),
        })
      );
      fLandValueCalc(e);
    }
  };

  const fFooter_Rounding_Focus = (e) => {
    if (e.target.value == 0) {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_Rounding: "",
        })
      );
    }
  };

  const fRounding = (e) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_Rounding: e.target.value,
      })
    );
    fLandValueCalc(e);
  };

  const fDiscFlag = (e) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_DiscFlag: e.target.checked ? "Y" : "N",
      })
    );
  };
  const fSalesGroup = (event) => {
    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        salesGroup: event.target.value,
      })
    );
  };

  //DETAIL  FUNCTION

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };

  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      PackDesc: vUnitvalue?.PackDesc,
    }));

      await Unit_Onchange_001(
                vUnitvalue?.Unit,
                vUnitvalue,
                 sBufferObj.B_Itmcd,
              sBufferObj.B_TaxPerc,
                sBufferObj.B_TaxPerc2,
                 setBufferObj,
                 sBufferObj
              );
  };
  const fPalletType = async (e) => {
    setBufferObj((obj) => ({
      ...obj,
      PalletType: e.target.value,
    }));
  };
  const Reason = async (e) => {
    setBufferObj((obj) => ({
      ...obj,
      Reason: e.target.value,
    }));
  };

  const fUnitRate = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_URateFc: e.target.value,
    }));

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      Number(e.target.value),
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };

  const fGrossAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_GrossAmt: event.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      // B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
      B_URateFc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc,
      Number(event.target.value),
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      // B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
      B_URateFc,
    }));
  };

  const fUnitRateSave_onKeyUp = (e) => {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (
        e.key === "Enter" &&
        // !isSaved &&
        vRdxWmsHead.A_DocStat == "ENTER" &&
        !isSaveLoaded
      ) {
        setSaveLoaded(true);
        document.getElementsByName("B_URateFc")[0]?.blur();
        // setIsSaved(true);
        fSave();
      }
    }, 1000);
  };

  const fFoc = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_FocFlag: e.target.checked ? "Y" : "N",
    }));
    let isChecked = e.target.checked ? "Y" : "N";
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      isChecked,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };

  const fFocFlag = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_AprmtFlag: e.target.value,
    }));
  };

  const fExcise = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ExciseTaxAmt: e.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      e.target.value,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };

  const fNetExcise = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ExciseTaxNetAmt: e.target.value,
    }));
  };

  const fTaxGroup = (e) => {
    let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
      return obj.UId == e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_TaxDept: vtaxGroupValue?.UId,
      B_TaxPerc: vtaxGroupValue?.Perc,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vtaxGroupValue?.Perc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };
  //if inter.comp then tax group should be 0
  const InterCompanyDependency = (xTaxID, xCessID) => {
    let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
      return obj.UId == xTaxID;
    });
    let vCessGroupValue = vRdxGRNtax2.find((obj) => {
      return obj.UId == xCessID;
    });
    if (vtaxGroupValue) {
      setBufferObj((obj) => ({
        ...obj,
        B_TaxDept: vtaxGroupValue?.UId,
        B_TaxPerc: vtaxGroupValue?.Perc,
        B_TaxDept2: vCessGroupValue?.UId,
        B_TaxPerc2: vCessGroupValue?.Perc,
      }));
    }

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vtaxGroupValue?.Perc,
      vCessGroupValue?.Perc,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
    return {
      B_TaxPerc: vtaxGroupValue?.Perc,
      B_TaxPerc2: vCessGroupValue?.Perc,
    };
  };
  const fCessGroup = (e) => {
    let vCessGroupValue = vRdxGRNtax2.find((obj) => {
      return obj.UId == e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_TaxDept2: vCessGroupValue?.UId,
      B_TaxPerc2: vCessGroupValue?.Perc,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      vCessGroupValue?.Perc,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };

  const fIncGroup = (event) => {
    var vSelectedObj = sIncentiveGroups?.find((option, index) => {
      const keys = Object.keys(option);
      return option[keys[0]] == event.target.value;
    });

    const selectObj = Object.keys(vSelectedObj);
    setBufferObj((obj) => ({
      ...obj,
      B_IncGroup: vSelectedObj[selectObj[0]],
      B_SuprvPerc: vSelectedObj[selectObj[2]],
      B_OthersPerc: vSelectedObj[selectObj[3]],
    }));
  };

  const fSupervisorSlab = (event, selectArr) => {
    setBufferObj((obj) => ({
      ...obj,
      B_SLANSuprv: event.target.value,
    }));
  };

  const fonChangeInputOtherAmtSc = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
  };

  const fOnChangeSelectOtherSlab = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_SLANOther: event.target.value,
    }));
  };

  const fType = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      RebateType: e.target.value,
      SplDiscPerc: 0,
      SplDiscAmt: 0,
    }));
    if (e.target.value == "" || e.target.value == "Linewise Rebate") {
      setBufferObj((obj) => ({
        ...obj,
        ReduceCost: "N",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        ReduceCost: "Y",
      }));
    }
  };

  const fDiscPer = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      SplDiscPerc: e.target.value,
    }));

    if (!!e.target.value && sBufferObj.B_GrossAmt != 0) {
      let DiscAmt =
        (fcovertToNumber(e.target.value) / 100) *
        fcovertToNumber(sBufferObj.B_GrossAmt);
      setBufferObj((obj) => ({
        ...obj,
        SplDiscAmt: DiscAmt.toFixed(sRoundingVal),
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        SplDiscAmt: Number(0),
      }));
    }
  };

  const fDiscAmt = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      SplDiscAmt: e.target.value,
    }));
    if (!!e.target.value && sBufferObj.B_GrossAmt != 0) {
      let DiscPerc =
        (fcovertToNumber(e.target.value) * 100) /
        fcovertToNumber(sBufferObj.B_GrossAmt);
      setBufferObj((obj) => ({
        ...obj,
        SplDiscPerc: DiscPerc.toFixed(4),
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        SplDiscPerc: 0,
      }));
    }
  };

  const fLDiscPer = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_LDiscPerc: e.target.value,
    }));
    if (e.target.value <= 100) {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
        SplDiscAmt,
      } = fCalculate_Detail(
        sBufferObj.B_Qty,
        sBufferObj.B_PackQty,
        vRdxWmsHead.A_ExRate,
        sBufferObj.B_URateFc,
        e.target.value,
        sBufferObj.B_TDiscPerc,
        sBufferObj.B_FocFlag,
        sBufferObj.B_ExciseTaxAmt,
        sBufferObj.B_TaxPerc,
        sBufferObj.B_TaxPerc2,
        sBufferObj.AddCess,
        0,
        sBufferObj.SplDiscPerc
      );

      setBufferObj((obj) => ({
        ...obj,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
        SplDiscAmt,
      }));
    }
  };

  const fonChangeInputLDiscAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_LDiscAmt: event.target.value,
    }));

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      // B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
      B_LDiscPerc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc,
      sBufferObj.B_GrossAmt,
      false,
      event.target.value,
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      // B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
      B_LDiscPerc,
    }));
  };

  const fItemName = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      e.target.value == "" ? 0 : e.target.value,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));
  };
  const fB_CI = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_CI: e.target.value,
    }));
  };

  const fNetAmt = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_NetAmt: e.target.value,
    }));
  };

  const fNarration = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      Narration: e.target.value,
    }));
  };

  const fReduceCost = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      ReduceCost: e.target.checked ? "Y" : "N",
    }));
  };

  //Source.DocEnter
  const fRefDocSearchModalKey = async (e, ModalName) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      fOpenRefDocSearchModal();
      GetRefDocInbound(vRdxWmsHead?.A_RefDocNo, "", "", setRefDocModalArr);
    }
    if (e.key === "Backspace") {
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDocNo: e.target.value,
          A_RefDocTyp: "",
          A_RefDocTypName: "",
          A_Party: "",
          A_PartyName: "",
          InboundType: "TRANSFER_RETURN", //from vendor initial value
          UnloadingBay: sUnloading[0]?.UId, //payload initial value
          UnloadingBayName: "",
          A_PostDt: new Date(),
          A_RefNo: "",
          A_RefDt: new Date(),
          VendorInvAmount: "",
          A_RefDocVer: "",
        })
      );
      GetDefaultDrCrAccount(
        vRdxWmsHead.A_VocTyp,
        "CREDIT", //vRdxWmsHead.A_PayMode,
        "", //vRdxWmsHead.A_Party on load empty
        dispatch
      );
      fBuyer_or_SalesMan(
        "VENDOR_INV",
        setBuyer,
        dispatch,
        vRdxWmsHead.A_Loc,
        vRdxWmsHead.A_VocTyp,
        vRdxWmsHead.A_VocNo
      );
    }
  };

  //Item Dropdowm
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);

      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
    setGC_Toggle_Head_Customer_ToggleDropDowm(false);
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  //ItemSearch
  const fItemSearchKey = async (e) => {
  
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxWmsHead.A_Loc
      );
      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(
          vItemSearchFull,
          vRdxWmsHead,
          sBufferObj,
          setBufferObj,
          setUnit,
          SetIncentiveGroups,
          setOtherSlabs,
          setSupervisorSlabs,
          vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
          vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
        );
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
        SplDiscAmt,
      } = fCalculate_Detail(
        0, //sBufferObj.B_Qty,
        0, //sBufferObj.B_PackQty,
        vRdxWmsHead.A_ExRate, //exchangeRate
        0, //sBufferObj.B_URateFc,
        0, //sBufferObj.B_LDiscPerc,
        0, //sBufferObj.B_TDiscPerc,
        "N", //sBufferObj.B_FocFlag,
        0, //sBufferObj.B_ExciseTaxAmt,
        vRdxGRNtax1[0].Perc, //tax1%
        vRdxGRNtax2[0].Perc, //tax%2
        0, //sBufferObj.AddCess,
        0, //Rounding,
        0 //splDisPer
      );
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        SuppRefNo1: "",
        B_Barcode: "",
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
        SplDiscAmt,
        Reason: "",
        PackDesc: "",
      }));
      setUnit([]);
    }
  };

  //MODAL HEAD
  const [sRefDocSearchModal, setRefDocSearchModal] = useState(false);
  const [sRefInboundGridData, setRefDocModalArr] = useState([]);

  const [sRefDocModelObj, setRefDocModelObj] = useState({
    AnyData: vRdxWmsHead?.A_RefDocNo,
    Name: "",
    Code: "",
  });

  const fRefDocClearSimpleSearch = () => {
    setRefDocModelObj(vHeaderSearchInit);
    setRefDocModalArr([]);
  };

  const fOpenRefDocSearchModal = () => {
    setRefDocModelObj((obj) => ({
      ...obj,
      AnyData: vRdxWmsHead?.A_RefDocNo,
    }));
    setRefDocSearchModal(true);
  };

  // if anydata value != "" call API
  //GCSimpleSearch

  const fRefDocSearchEnter = async (e) => {
    if (e.key === "Enter") {
      let srcDocNoArr = await GetRefDocInbound(
        sRefDocModelObj?.AnyData,
        sRefDocModelObj.Code,
        sRefDocModelObj.Name,
        setRefDocModalArr
      );
    }

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      setTimeout(() => {
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-5");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }, 200);
    }
  };

  const fonChangeRefDocModal = (event) => {
    setRefDocModelObj({
      ...sRefDocModelObj,
      [event.target.name]: event.target.value,
    });
  };

  //Modal ItemSearch
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(
      e.row.ItmCd,
      vRdxWmsHead.A_Loc
    );
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(
        vItemSearchFull,
        vRdxWmsHead,
        sBufferObj,
        setBufferObj,
        setUnit,
        SetIncentiveGroups,
        setOtherSlabs,
        setSupervisorSlabs,
        vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
        vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
      );
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //Modal GCSearchBtn
  const [sSearchLoactionArr, setSearchLoactionArr] = useState(vRdxDBLocation);
  const addAllInSearchLoactionArr = () => {
    const newObj = {
      UID: "All",
      Name1: "All",
      BranchCode: "All",
      BranchName: "All",
    };

    // Use the spread operator to create a new array with the new object added at the beginning
    setSearchLoactionArr([newObj, ...sSearchLoactionArr]);
  };
  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: "ENTER",
    VocNo: "",
    PostDt: "",
    Loc: "All",
    RefNo: "",
    SalesGroup: "",
    Party: "All",
    PartyName: "All",
  });

  const [sSearchModal, setSearchModal] = useState(false);
  const fSearch = async () => {
    setGCSearchBtn_ToggleDropDowm(false);
    document.getElementById("IdSearch")?.blur();
    setSearchModal(true);
    // SALESGROUPSSEARCH_GETROW
    let iSalesGroupArr = await GetSalesGroupSearch(vRdxWmsHead.A_Loc);
    if (iSalesGroupArr.length > 0) {
      setGCSeachSalesGroupSearch(iSalesGroupArr);
      addAllInSearchLoactionArr();
      setSearchModalObj({
        ...sSearchModalObj,
        SalesGroup: iSalesGroupArr[0]?.UId,
      });
      GetSearchValue("", "APICallSalesGroupModal", iSalesGroupArr[0]?.UId);
    }
    setTimeout(() => {
      document.getElementsByName("VocNo")[0]?.focus();
    }, 100);
  };

  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  //if GRNDocTyp, GrnDocNo is not empty then it is from notification page
  // so redirect to notification page in mobile screen
  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: "",
      Loc: "All",
      RefNo: "",
      SalesGroup: sGCSeachSalesGroupSearch[0]?.UId,
      Party: "All",
      PartyName: "All",
    });
    setGridSearchHeadRowData([]);
  };

  //GCSearchBtn
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo, dispatch, fNewDetail, setBuyer);
    fCloseSearchModal();
  };
  //GCSearchBtn
  const fTrans_Search_Grid_KeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fTrans_Search_Grid_RowClick(newSelectionModel);
    }
  };

  const xfGCSearchBtn_Name = (e) => {
    setGCSearchBtn_ToggleDropDowm(false);
    setSearchModalObj((obj) => ({
      ...obj,
      Party: "",
      PartyName: e.target.value,
    }));
  };

  const [
    sGCSearchBtn_SearchDropdownObj_SearchDropdownObj,
    setGCSearchBtn_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sGCSearchBtn_GridData, setGCSearchBtn_GridData] = useState([]);
  const [sGCSearchBtn_Toggle_ToggleDropDowm, setGCSearchBtn_ToggleDropDowm] =
    useState(false);

  const xfGCSearchBtn_Toggle = useCallback(() => {
    if (sGCSearchBtn_Toggle_ToggleDropDowm) {
      setGCSearchBtn_ToggleDropDowm(false);
      setGCSearchBtn_GridData([]);
      setGCSearchBtn_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGCSearchBtn_ToggleDropDowm(true);
    }
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);

  //2nd call
  const fGCSearchBtn_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGCSearchBtn_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sSearchModalObj.PartyName,
      }));
      if (sSearchModalObj.PartyName != "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          sSearchModalObj.PartyName,
          "Any",
          "N"
        );
        setGCSearchBtn_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGCSearchBtn_Toggle();
    }
  };

  //1stcall
  const fGCSearchBtn_onKeyUp_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match

      if (sSearchModalObj.Party == "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          sSearchModalObj.PartyName,
          "Any",
          "Y"
        );
        if (vLandedCostExactSearch.length > 0) {
          setSearchModalObj((obj) => ({
            ...obj,
            Party: vLandedCostExactSearch[0].AcCd,
            PartyName: vLandedCostExactSearch[0].Name2,
          }));
          GetSearchValue(
            "",
            "APICallPartyModal",
            vLandedCostExactSearch[0].AcCd
          );
        } else {
          fGCSearchBtn_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setSearchModalObj((obj) => ({
        ...obj,
        Party: "",
      }));
    }
  };

  const xGCSearchBtn_Dropdown_onChange = (e) => {
    setGCSearchBtn_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGCSearchBtn__Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_GCSearchBtn(
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Data,
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Type
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setGCSearchBtn_GridData(vLandedCostDropdownSearch);
      } else {
        setGCSearchBtn_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document?.getElementsByClassName("Mui-selected")?.length;
        if (selectedLength === 0) {
          let tabel = document?.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 500);
    }
  };

  const fGCSearchBtn_OnRowClick = (e) => {
    setSearchModalObj((obj) => ({
      ...obj,
      Party: e?.row?.AcCd,
      PartyName: e?.row?.Name2,
    }));
    GetSearchValue("", "APICallPartyModal", e?.row?.AcCd);
    xfGCSearchBtn_Toggle();
  };
  const fGCSearchBtn_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCSearchBtn_OnRowClick(newSelectionModel);
    }
  };
  //GCSearchBtn End

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALL", vSelectedValue);
  };
  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };
  const fonChangeRefNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      RefNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
  };
  const fonChangePartyModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.AcCd == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Party: vSelectedValue.AcCd,
    }));
    GetSearchValue("", "APICallPartyModal", vSelectedValue.AcCd);
  };

  const fonChangeLocModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UID == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: vSelectedValue.UID,
    }));
    GetSearchValue("", "APICallLocModal", vSelectedValue.UID);
  };

  const fonChangeSalesGroupModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UId == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      SalesGroup: vSelectedValue.UId,
    }));
    GetSearchValue("", "APICallSalesGroupModal", vSelectedValue.UId);
  };

  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
   
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALL" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallPartyModal" ||
      xAPICALL === "APICallLocModal" ||
      xAPICALL === "APICallSalesGroupModal"
    ) {
      let vSearchObj = {
        VocNo: sSearchModalObj.VocNo,
        PostDt:
          xAPICALL === "APICALLDATE"
            ? moment(xSTATUS).format("MM/DD/YYYY")
            : !!sSearchModalObj.PostDt
            ? moment(sSearchModalObj.PostDt).format("MM/DD/YYYY")
            : "01/01/1900",
        // PostDt: "01/01/1900",
        RefNo: sSearchModalObj.RefNo,
        Party:
          xAPICALL === "APICallPartyModal"
            ? !!xSTATUS
              ? xSTATUS
              : "All"
            : !!sSearchModalObj.Party
            ? sSearchModalObj.Party
            : "All",
        Type: "",
        Loc: xAPICALL === "APICallLocModal" ? xSTATUS : sSearchModalObj.Loc,
        Status: xAPICALL === "APICALL" ? xSTATUS : sSearchModalObj.Status,
        UserCd: vRdxuserInfo.UserID,
      };
      const vSearch = await fExecuteAPI("searchHead_OUTLET", vSearchObj);
      if (vSearch.Type?.toUpperCase() === "SUCCESS") {
        let vSearchArr = vSearch?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
        
      } else {
        fAlertToast("FAILED", vSearch.Message);
      }
    }
 
  };

  //API SALESGROUP
  const GetSalesGroupSearch = async (xA_Loc) => {
    const vSalesGroupSearchs = await fExecuteAPI(
      "SALESGROUPSSEARCH_GETROW",
      xA_Loc
    );
    if (vSalesGroupSearchs.Type == "SUCCESS") {
      return vSalesGroupSearchs.ResultSet;
    } else {
      fAlertToast("FAILED", vSalesGroupSearchs.Message);
    }
  };
  //Modal Audit

  const [xAuditId, setAuditId] = useState("All");
  const [sAuditModal, setAuditModal] = useState(false);
  const [sAuditSelectArr, setAuditSelectArr] = useState([]);
  const [sGridDataAuditRows, setGridDataAuditRows] = useState([]);
  const fOpenAuditModal = () => {
    setAuditModal(true);
  };
  const fAudit = async (e) => {
    let auditResp = await GetAuditField();
    if (!!auditResp) {
      setAuditId(auditResp[0]?.id);
      GetTransAudit(auditResp[0]?.id);
    }
    fOpenAuditModal();
  };
  const fCloseAuditModal = (e) => {
    setAuditModal(false);
  };
  const fonChangeAuditSelect = (e) => {
    setAuditId(e.target.value);
    GetTransAudit(e.target.value);
  };
  //document
  const [sDocumentModal, setDocumentModal] = useState(false);
  const fDocument = () => {
    fOpenDocumentModal();
  };
  const fOpenDocumentModal = () => {
    setDocumentModal(true);
  };
  const fCloseDocumentModal = (e) => {
    setDocumentModal(false);
  };

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = WmsInboundOutletRo();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );
    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end

  //PendingPo start
  const [sPendingPoModal, setPendingPoModal] = useState(false);
  const [sPendingPoData, setPendingData] = useState(false);

  const fOpenPendingPoModal = () => {
    setPendingPoModal(true);
  };
  const fPendingPo = async (e) => {
    const { HeadObject } = WmsInboundOutletRo();
    await GetPengingPo(
      HeadObject.A_RefDocNo,
      HeadObject.A_RefDocTyp,
      setPendingData
    );
    fOpenPendingPoModal();
  };
  const fClosePendingPoModal = (e) => {
    setPendingPoModal(false);
  };
  //PendingStock end
  //Pallet start
  const [sPalletModal, setPalletModal] = useState(false);
  const [sPalletData, setPalletData] = useState([]);

  const fOpenPalletModal = () => {
    setPalletModal(true);
  };
  const fPallet = async (e) => {
    const { HeadObject } = WmsInboundOutletRo();
    await GetPallet(
      HeadObject.A_RefDocNo,
      HeadObject.A_RefDocTyp,
      setPalletData
    );
    fOpenPalletModal();
  };
  const fClosePalletModal = (e) => {
    setPalletModal(false);
  };
  //PendingStock end

  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = WmsInboundOutletRo();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //MSPUpdate start
  const [sMSPUpdateModal, setMSPUpdateModal] = useState(false);
  const [sGridDataMSPUpdateRows, setGridDataMSPUpdateRows] = useState([]);
  const [sGridDataMSPUpdateColumns, setGridDataMSPUpdateColumns] = useState([
    {
      field: "ItmCd",
      headerName: "Item.Code",
      hide: false,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "ItemName",
      headerName: "Item.Name",
      hide: false,
      width: 210,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "A_LOC",
      headerName: "A_LOC",
      hide: true,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "B_unit",
      headerName: "B_unit",
      hide: true,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "UnitName",
      headerName: "Unit",
      hide: false,
      width: 60,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "TaxDept",
      headerName: "Tax Dept",
      hide: true,
      width: 80,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "StkQty",
      headerName: "Stock",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "TaxPerc",
      headerName: "TaxPerc",
      hide: true,
      width: 80,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "CostPr",
      headerName: "Cost.Pr",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "SellPr1",
      headerName: "RSP",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "TAXRSP",
      headerName: "VAT.RSP",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "GPPerc",
      headerName: "GP.%",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "MSP",
      headerName: "MSP",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "MSPGPPerc",
      headerName: "MSP.GP%",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "TSROH",
      headerName: "OH",
      hide: false,
      width: 70,
      align: "right",
      headerAlign: "right",
    },
  ]);
  const fOpenMSPUpdateModal = () => {
    setMSPUpdateModal(true);
  };
  const fMSPUpdate = async (e) => {
    const { HeadObject } = WmsInboundOutletRo();
    await GetMSPUpdate(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataMSPUpdateRows
    );
    fOpenMSPUpdateModal();
  };
  const fCloseMSPUpdateModal = (e) => {
    setMSPUpdateModal(false);
  };
  //MSPUpdate end

  //GCLandedCost

  const [sLandedCostModal, setLandedCostModal] = useState(false);
  const [sLandedCostDiscAmt, setLandedCostDiscAmtModal] = useState(0);
  const [sLandedCostObjModal, setLandedCostObjModal] = useState({
    Loaded_Cost_Freight_Acc: sLoadedCostAccountArr[0],
    Loaded_Cost_Freight_Code: "",
    Loaded_Cost_Freight_Name: "",
    Loaded_Cost_Customs_Acc: sLoadedCostAccountArr[0],
    Loaded_Cost_Customs_Code: "",
    Loaded_Cost_Customs_Name: "",
    Loaded_Cost_Discount_Code: "",
    Loaded_Cost_Discount_Name: "",
    Loaded_Cost_SplDiscount_Code: "",
    Loaded_Cost_SplDiscount_Name: "",
  });

  const [sLandedCostObjError, setLandedCostObjError] = useState({
    Loaded_Cost_Freight_Acc: "",
    Loaded_Cost_Freight_Code: "",
    Loaded_Cost_Freight_Name: "",
    Loaded_Cost_Customs_Acc: "",
    Loaded_Cost_Customs_Code: "",
    Loaded_Cost_Customs_Name: "",
    Loaded_Cost_Discount_Code: "",
    Loaded_Cost_Discount_Name: "",
    Loaded_Cost_SplDiscount_Code: "",
    Loaded_Cost_SplDiscount_Name: "",
  });
  const fOpenLandedCostModal = async () => {
    const { SplDiscAmt } =
      sDetailGridData.length > 0
        ? sDetailGridData.reduce(
            (iValue, item) => {
              iValue.SplDiscAmt += item?.SplDiscAmt;
              return iValue;
            },
            { SplDiscAmt: 0 }
          )
        : { iSplDiscAmt: 0 };
    setLandedCostDiscAmtModal(SplDiscAmt);
    // WMINV03D_GetRow
    let iLoadecCostRecset = await Get_Loaded_Cost_WMINV03D_GetRow(dispatch);
    if (iLoadecCostRecset.length > 0) {
      let iFreight = iLoadecCostRecset.find(
        (obj) => obj.D_Type?.toUpperCase() === "FREIGHT"
      );
      if (!!iFreight) {
        setLandedCostObjModal((obj) => ({
          ...obj,
          Loaded_Cost_Freight_Acc:
            iFreight.D_CrAcTyp == "C" ? "Vendor" : "G.L A/c",
          Loaded_Cost_Freight_Code: iFreight.D_CrAc,
          Loaded_Cost_Freight_Name: iFreight.D_CrAcName,
        }));
      }
      let iCustoms = iLoadecCostRecset.find(
        (obj) => obj.D_Type?.toUpperCase() === "CHARGES"
      );
      if (!!iCustoms) {
        setLandedCostObjModal((obj) => ({
          ...obj,
          Loaded_Cost_Customs_Acc:
            iCustoms.D_CrAcTyp == "C" ? "Vendor" : "G.L A/c",
          Loaded_Cost_Customs_Code: iCustoms.D_CrAc,
          Loaded_Cost_Customs_Name: iCustoms.D_CrAcName,
        }));
      }
      let iDiscount = iLoadecCostRecset.find(
        (obj) => obj.D_Type?.toUpperCase() === "DISCOUNT"
      );
      if (!!iDiscount) {
        setLandedCostObjModal((obj) => ({
          ...obj,
          Loaded_Cost_Discount_Acc:
            iDiscount.D_CrAcTyp == "C" ? "Vendor" : "G.L A/c",
          Loaded_Cost_Discount_Code: iDiscount.D_CrAc,
          Loaded_Cost_Discount_Name: iDiscount.D_CrAcName,
        }));
      }
      let iSplDiscount = iLoadecCostRecset.find(
        (obj) => obj.D_Type?.toUpperCase() === "SPLDISCOUNT"
      );
      if (!!iSplDiscount) {
        setLandedCostObjModal((obj) => ({
          ...obj,
          Loaded_Cost_SplDiscount_Acc:
            iSplDiscount.D_CrAcTyp == "C" ? "Vendor" : "G.L A/c",
          Loaded_Cost_SplDiscount_Code: iSplDiscount.D_CrAc,
          Loaded_Cost_SplDiscount_Name: iSplDiscount.D_CrAcName,
        }));
      }
    }
    setLandedCostModal(true);
  };
  const fCloseLandedCostModal = (e) => {
    setLandedCostObjModal({
      Loaded_Cost_Freight_Acc: sLoadedCostAccountArr[0],
      Loaded_Cost_Freight_Code: "",
      Loaded_Cost_Freight_Name: "",
      Loaded_Cost_Customs_Acc: sLoadedCostAccountArr[0],
      Loaded_Cost_Customs_Code: "",
      Loaded_Cost_Customs_Name: "",
      Loaded_Cost_Discount_Code: "",
      Loaded_Cost_Discount_Name: "",
      Loaded_Cost_SplDiscount_Code: "",
      Loaded_Cost_SplDiscount_Name: "",
    });
    setLandedCostModal(false);
    setLoaded_Cost_SplDiscount_ToggleDropDowm(false);
    setLoaded_Cost_Freight_ToggleDropDowm(false);
    setLoaded_Cost_Customs_ToggleDropDowm(false);
    setLoaded_Cost_Discount_ToggleDropDowm(false);
    setLandedCostObjError(Loaded_Cost_Freight_Init);
  };

  //freight
  const xfLoaded_Cost_Freight_Acc = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Freight_Acc: e.target.value,
      Loaded_Cost_Freight_Code: "",
      Loaded_Cost_Freight_Name: "",
    }));
  };
  const xfLoaded_Cost_Freight_Name = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Freight_Name: e.target.value,
    }));
  };

  const [
    sLoaded_Cost_Freight_SearchDropdownObj,
    setLoaded_Cost_Freight_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sLoaded_Cost_Freight_GridData, setLoaded_Cost_Freight_GridData] =
    useState([]);
  const [
    sLoaded_Cost_Freight_ToggleDropDowm,
    setLoaded_Cost_Freight_ToggleDropDowm,
  ] = useState(false);

  const xfLoaded_Cost_Freight_Toggle = useCallback(() => {
    if (sLoaded_Cost_Freight_ToggleDropDowm) {
      setLoaded_Cost_Freight_ToggleDropDowm(false);
      setLoaded_Cost_Freight_GridData([]);
      setLoaded_Cost_Freight_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setLoaded_Cost_Freight_ToggleDropDowm(true);
      setLoaded_Cost_Customs_ToggleDropDowm(false);
      setLoaded_Cost_Discount_ToggleDropDowm(false);
      setLoaded_Cost_SplDiscount_ToggleDropDowm(false);
    }
  }, [sLoaded_Cost_Freight_ToggleDropDowm]);

  //2nd call
  const fLoaded_Cost_Freight_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setLoaded_Cost_Freight_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sLandedCostObjModal.Loaded_Cost_Freight_Name,
      }));
      if (sLandedCostObjModal.Loaded_Cost_Freight_Name != "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Freight_Name,
          "Any",
          sLandedCostObjModal.Loaded_Cost_Freight_Acc == "Vendor" ? "C" : "K",
          "N",
          dispatch
        );
        setLoaded_Cost_Freight_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfLoaded_Cost_Freight_Toggle();
    }
  };

  //1stcall
  const fLoaded_Cost_Freight_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sLandedCostObjModal.Loaded_Cost_Freight_Code == "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Freight_Name,
          "Any",
          sLandedCostObjModal.Loaded_Cost_Freight_Acc == "Vendor" ? "C" : "K",
          "Y",
          dispatch
        );
        if (vLandedCostExactSearch.length > 0) {
          setLandedCostObjModal((obj) => ({
            ...obj,
            Loaded_Cost_Freight_Code: vLandedCostExactSearch[0].AcCd,
            Loaded_Cost_Freight_Name: vLandedCostExactSearch[0].Name2,
          }));
        } else {
          fLoaded_Cost_Freight_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setLandedCostObjModal((obj) => ({
        ...obj,
        Loaded_Cost_Freight_Code: "",
      }));
    }
  };

  const fLoaded_Cost_Freight_Dropdown_onChange = (e) => {
    setLoaded_Cost_Freight_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoaded_Cost_Freight_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_LoadedCost(
        sLoaded_Cost_Freight_SearchDropdownObj.Data,
        sLoaded_Cost_Freight_SearchDropdownObj.Type,
        sLandedCostObjModal.Loaded_Cost_Freight_Acc == "Vendor" ? "C" : "K",
        "N",
        dispatch
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setLoaded_Cost_Freight_GridData(vLandedCostDropdownSearch);
      } else {
        setLoaded_Cost_Freight_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fLoaded_Cost_Freight_OnRowClick = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Freight_Code: e?.row?.AcCd,
      Loaded_Cost_Freight_Name: e?.row?.Name2,
    }));
    xfLoaded_Cost_Freight_Toggle();
  };
  const fLoaded_Cost_Freight_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fLoaded_Cost_Freight_OnRowClick(newSelectionModel);
    }
  };
  //Customs

  const xfLoaded_Cost_Customs_Acc = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Customs_Acc: e.target.value,
      Loaded_Cost_Customs_Code: "",
      Loaded_Cost_Customs_Name: "",
    }));
  };
  const xfLoaded_Cost_Customs_Name = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Customs_Name: e.target.value,
    }));
  };

  const [
    sLoaded_Cost_Customs_SearchDropdownObj,
    setLoaded_Cost_Customs_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sLoaded_Cost_Customs_GridData, setLoaded_Cost_Customs_GridData] =
    useState([]);
  const [
    sLoaded_Cost_Customs_ToggleDropDowm,
    setLoaded_Cost_Customs_ToggleDropDowm,
  ] = useState(false);

  const xfLoaded_Cost_Customs_Toggle = useCallback(() => {
    if (sLoaded_Cost_Customs_ToggleDropDowm) {
      setLoaded_Cost_Customs_ToggleDropDowm(false);
      setLoaded_Cost_Customs_GridData([]);
      setLoaded_Cost_Customs_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setLoaded_Cost_Customs_ToggleDropDowm(true);
      setLoaded_Cost_Freight_ToggleDropDowm(false);
      setLoaded_Cost_Discount_ToggleDropDowm(false);
      setLoaded_Cost_SplDiscount_ToggleDropDowm(false);
    }
  }, [sLoaded_Cost_Customs_ToggleDropDowm]);

  //2nd call
  const fLoaded_Cost_Customs_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setLoaded_Cost_Customs_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sLandedCostObjModal.Loaded_Cost_Customs_Name,
      }));
      if (sLandedCostObjModal.Loaded_Cost_Customs_Name != "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Customs_Name,
          "Any",
          sLandedCostObjModal.Loaded_Cost_Customs_Acc == "Vendor" ? "C" : "K",
          "N",
          dispatch
        );
        setLoaded_Cost_Customs_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfLoaded_Cost_Customs_Toggle();
    }
  };

  //1stcall
  const fLoaded_Cost_Customs_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sLandedCostObjModal.Loaded_Cost_Customs_Code == "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Customs_Name,
          "Any",
          sLandedCostObjModal.Loaded_Cost_Customs_Acc == "Vendor" ? "C" : "K",
          "Y",
          dispatch
        );
        if (vLandedCostExactSearch.length > 0) {
          setLandedCostObjModal((obj) => ({
            ...obj,
            Loaded_Cost_Customs_Code: vLandedCostExactSearch[0].AcCd,
            Loaded_Cost_Customs_Name: vLandedCostExactSearch[0].Name2,
          }));
        } else {
          fLoaded_Cost_Customs_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setLandedCostObjModal((obj) => ({
        ...obj,
        Loaded_Cost_Customs_Code: "",
      }));
    }
  };

  const fLoaded_Cost_Customs_Dropdown_onChange = (e) => {
    setLoaded_Cost_Customs_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoaded_Cost_Customs_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_LoadedCost(
        sLoaded_Cost_Customs_SearchDropdownObj.Data,
        sLoaded_Cost_Customs_SearchDropdownObj.Type,
        sLandedCostObjModal.Loaded_Cost_Customs_Acc == "Vendor" ? "C" : "K",
        "N",
        dispatch
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setLoaded_Cost_Customs_GridData(vLandedCostDropdownSearch);
      } else {
        setLoaded_Cost_Customs_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fLoaded_Cost_Customs_OnRowClick = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Customs_Code: e?.row?.AcCd,
      Loaded_Cost_Customs_Name: e?.row?.Name2,
    }));

    xfLoaded_Cost_Customs_Toggle();
  };
  const fLoaded_Cost_Customs_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fLoaded_Cost_Customs_OnRowClick(newSelectionModel);
    }
  };

  //Discount

  const xfLoaded_Cost_Discount_Name = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Discount_Name: e.target.value,
    }));
  };

  const [
    sLoaded_Cost_Discount_SearchDropdownObj,
    setLoaded_Cost_Discount_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sLoaded_Cost_Discount_GridData, setLoaded_Cost_Discount_GridData] =
    useState([]);
  const [
    sLoaded_Cost_Discount_ToggleDropDowm,
    setLoaded_Cost_Discount_ToggleDropDowm,
  ] = useState(false);

  const xfLoaded_Cost_Discount_Toggle = useCallback(() => {
    if (sLoaded_Cost_Discount_ToggleDropDowm) {
      setLoaded_Cost_Discount_ToggleDropDowm(false);
      setLoaded_Cost_Discount_GridData([]);
      setLoaded_Cost_Discount_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setLoaded_Cost_Discount_ToggleDropDowm(true);
      setLoaded_Cost_Freight_ToggleDropDowm(false);
      setLoaded_Cost_Customs_ToggleDropDowm(false);
      setLoaded_Cost_SplDiscount_ToggleDropDowm(false);
    }
  }, [sLoaded_Cost_Discount_ToggleDropDowm]);

  //2nd call
  const fLoaded_Cost_Discount_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setLoaded_Cost_Discount_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sLandedCostObjModal.Loaded_Cost_Discount_Name,
      }));
      if (sLandedCostObjModal.Loaded_Cost_Discount_Name != "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Discount_Name,
          "Any",
          "K",
          "N",
          dispatch
        );
        setLoaded_Cost_Discount_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfLoaded_Cost_Discount_Toggle();
    }
  };

  //1stcall
  const fLoaded_Cost_Discount_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sLandedCostObjModal.Loaded_Cost_Discount_Code == "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_Discount_Name,
          "Any",
          "K",
          "Y",
          dispatch
        );
        if (vLandedCostExactSearch.length > 0) {
          setLandedCostObjModal((obj) => ({
            ...obj,
            Loaded_Cost_Discount_Code: vLandedCostExactSearch[0].AcCd,
            Loaded_Cost_Discount_Name: vLandedCostExactSearch[0].Name2,
          }));
        } else {
          fLoaded_Cost_Discount_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setLandedCostObjModal((obj) => ({
        ...obj,
        Loaded_Cost_Discount_Code: "",
      }));
    }
  };

  const fLoaded_Cost_Discount_Dropdown_onChange = (e) => {
    setLoaded_Cost_Discount_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoaded_Cost_Discount_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_LoadedCost(
        sLoaded_Cost_Discount_SearchDropdownObj.Data,
        sLoaded_Cost_Discount_SearchDropdownObj.Type,
        "K",
        "N",
        dispatch
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setLoaded_Cost_Discount_GridData(vLandedCostDropdownSearch);
      } else {
        setLoaded_Cost_Discount_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fLoaded_Cost_Discount_OnRowClick = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_Discount_Code: e?.row?.AcCd,
      Loaded_Cost_Discount_Name: e?.row?.Name2,
    }));
    xfLoaded_Cost_Discount_Toggle();
  };
  const fLoaded_Cost_Discount_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fLoaded_Cost_Discount_OnRowClick(newSelectionModel);
    }
  };
  //SplDiscount

  const xfLoaded_Cost_SplDiscount_Name = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_SplDiscount_Name: e.target.value,
    }));
  };

  const [
    sLoaded_Cost_SplDiscount_SearchDropdownObj,
    setLoaded_Cost_SplDiscount_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [
    sLoaded_Cost_SplDiscount_GridData,
    setLoaded_Cost_SplDiscount_GridData,
  ] = useState([]);
  const [
    sLoaded_Cost_SplDiscount_ToggleDropDowm,
    setLoaded_Cost_SplDiscount_ToggleDropDowm,
  ] = useState(false);

  const xfLoaded_Cost_SplDiscount_Toggle = useCallback(() => {
    if (sLoaded_Cost_SplDiscount_ToggleDropDowm) {
      setLoaded_Cost_SplDiscount_ToggleDropDowm(false);
      setLoaded_Cost_SplDiscount_GridData([]);
      setLoaded_Cost_SplDiscount_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setLoaded_Cost_SplDiscount_ToggleDropDowm(true);
      setLoaded_Cost_Freight_ToggleDropDowm(false);
      setLoaded_Cost_Customs_ToggleDropDowm(false);
      setLoaded_Cost_Discount_ToggleDropDowm(false);
    }
  }, [sLoaded_Cost_SplDiscount_ToggleDropDowm]);

  //2nd call
  const fLoaded_Cost_SplDiscount_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setLoaded_Cost_SplDiscount_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sLandedCostObjModal.Loaded_Cost_SplDiscount_Name,
      }));
      if (sLandedCostObjModal.Loaded_Cost_SplDiscount_Name != "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_SplDiscount_Name,
          "Any",
          "K",
          "N",
          dispatch
        );
        setLoaded_Cost_SplDiscount_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfLoaded_Cost_SplDiscount_Toggle();
    }
  };

  //1stcall
  const fLoaded_Cost_SplDiscount_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sLandedCostObjModal.Loaded_Cost_SplDiscount_Code == "") {
        const vLandedCostExactSearch = await Get_LoadedCost(
          sLandedCostObjModal.Loaded_Cost_SplDiscount_Name,
          "Any",
          "K",
          "Y",
          dispatch
        );
        if (vLandedCostExactSearch.length > 0) {
          setLandedCostObjModal((obj) => ({
            ...obj,
            Loaded_Cost_SplDiscount_Code: vLandedCostExactSearch[0].AcCd,
            Loaded_Cost_SplDiscount_Name: vLandedCostExactSearch[0].Name2,
          }));
        } else {
          fLoaded_Cost_SplDiscount_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setLandedCostObjModal((obj) => ({
        ...obj,
        Loaded_Cost_SplDiscount_Code: "",
      }));
    }
  };

  const fLoaded_Cost_SplDiscount_Dropdown_onChange = (e) => {
    setLoaded_Cost_SplDiscount_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoaded_Cost_SplDiscount_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_LoadedCost(
        sLoaded_Cost_SplDiscount_SearchDropdownObj.Data,
        sLoaded_Cost_SplDiscount_SearchDropdownObj.Type,
        "K",
        "N",
        dispatch
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setLoaded_Cost_SplDiscount_GridData(vLandedCostDropdownSearch);
      } else {
        setLoaded_Cost_SplDiscount_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fLoaded_Cost_SplDiscount_OnRowClick = (e) => {
    setLandedCostObjModal((obj) => ({
      ...obj,
      Loaded_Cost_SplDiscount_Code: e?.row?.AcCd,
      Loaded_Cost_SplDiscount_Name: e?.row?.Name2,
    }));
    xfLoaded_Cost_SplDiscount_Toggle();
  };

  const fLoaded_Cost_SplDiscount_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fLoaded_Cost_SplDiscount_OnRowClick(newSelectionModel);
    }
  };

  const fLoaded_Cost_Validation = () => {
    let iResp = true;
    if (vRdxWmsHead.A_LC > 0) {
      if (sLandedCostObjModal.Loaded_Cost_Freight_Acc === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Freight_Acc: " Freight account should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_Freight_Code === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Freight_Code: " Freight code should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_Freight_Name === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Freight_Name: " Freight name should not be empty",
        }));
        iResp = false;
      }
    }
    if (vRdxWmsHead.A_Charges1 > 0) {
      if (sLandedCostObjModal.Loaded_Cost_Customs_Acc === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Customs_Acc: " Customs account should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_Customs_Code === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Customs_Code: " Customs code should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_Customs_Name === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Customs_Name: " Customs name should not be empty",
        }));
        iResp = false;
      }
    }
    let idiscount = vRdxWmsHead.A_DiscFlag == "Y" ? 0 : sFooterObj.A_TDiscAmt;
    if (idiscount > 0) {
      if (sLandedCostObjModal.Loaded_Cost_Discount_Code === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Discount_Code: " Discount code should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_Discount_Name === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_Discount_Name: " Discount name should not be empty",
        }));
        iResp = false;
      }
    }
    if (sLandedCostDiscAmt > 0) {
      if (sLandedCostObjModal.Loaded_Cost_SplDiscount_Code === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_SplDiscount_Code: " SplDiscount code should not be empty",
        }));
        iResp = false;
      }
      if (sLandedCostObjModal.Loaded_Cost_SplDiscount_Name === "") {
        setLandedCostObjError((obj) => ({
          ...obj,
          Loaded_Cost_SplDiscount_Name: " SplDiscount name should not be empty",
        }));
        iResp = false;
      }
    }
    return iResp;
  };
  const fLoaded_Cost_Save = async () => {
    setLandedCostObjError(Loaded_Cost_Freight_Init);
    let vLoadedCostArr = [
      {
        VocTyp: vRdxWmsHead.A_VocTyp,
        VocNo: vRdxWmsHead.A_VocNo,
        Type: "Freight",
        CrAc: sLandedCostObjModal.Loaded_Cost_Freight_Code,
        CrAcTyp:
          sLandedCostObjModal.Loaded_Cost_Freight_Acc == "Vendor" ? "C" : "G",
        DrAc: "",
        DrAcTyp: "G",
        Amt: vRdxWmsHead.A_LC,
        TaxPerc: 0,
        TaxAmt: 0,
        NetAmt: 0,
      },
      {
        VocTyp: vRdxWmsHead.A_VocTyp,
        VocNo: vRdxWmsHead.A_VocNo,
        Type: "CHARGES",
        CrAc: sLandedCostObjModal.Loaded_Cost_Customs_Code,
        CrAcTyp:
          sLandedCostObjModal.Loaded_Cost_Customs_Acc == "Vendor" ? "C" : "G",
        DrAc: "",
        DrAcTyp: "G",
        Amt: vRdxWmsHead.A_Charges1,
        TaxPerc: 0,
        TaxAmt: 0,
        NetAmt: 0,
      },
      {
        VocTyp: vRdxWmsHead.A_VocTyp,
        VocNo: vRdxWmsHead.A_VocNo,
        Type: "DISCOUNT",
        CrAc: sLandedCostObjModal.Loaded_Cost_Discount_Code,
        CrAcTyp: "G",
        DrAc: "",
        DrAcTyp: "G",
        Amt: vRdxWmsHead.A_DiscFlag == "Y" ? 0 : sFooterObj.A_TDiscAmt,
        TaxPerc: 0,
        TaxAmt: 0,
        NetAmt: 0,
      },
      {
        VocTyp: vRdxWmsHead.A_VocTyp,
        VocNo: vRdxWmsHead.A_VocNo,
        Type: "SPLDISCOUNT",
        CrAc: sLandedCostObjModal.Loaded_Cost_SplDiscount_Code,
        CrAcTyp: "G",
        DrAc: "",
        DrAcTyp: "G",
        Amt: sLandedCostDiscAmt,
        TaxPerc: 0,
        TaxAmt: 0,
        NetAmt: 0,
      },
    ];
    let vLoadedCostObj = {
      ItemList: vLoadedCostArr,
      v_D_VocTyp: vRdxWmsHead.A_VocTyp,
      v_D_VocNo: vRdxWmsHead.A_VocNo,
    };
    let iValidationLoadedCost = fLoaded_Cost_Validation();
    if (!iValidationLoadedCost) return;

    const vLoadedCostRec = await fExecuteAPI(
      "FreightUpdate_GETROW",
      vLoadedCostObj
    );
    if (vLoadedCostRec.Type?.toUpperCase() === "SUCCESS") {
      console.log(vLoadedCostRec);
    } else {
      fAlertToast("FAILED", vLoadedCostRec.response.data.message);
    }
  };

  //GCLandedCost end

  //API AUDITFIELD_GETROW
  const GetAuditField = async () => {
    // http://localhost:3999/RpDesign/auditFields?trnTyp=WMINV08
    const vAuditField = await fExecuteAPI("AUDITFIELD_GETROW", sTrnTyp);
    if (vAuditField.Type?.toUpperCase() === "SUCCESS") {
      setAuditSelectArr(vAuditField.ResultSet);
      return vAuditField.ResultSet;
    } else {
      fAlertToast("FAILED", vAuditField.Message);
      return vAuditField.ResultSet;
    }
  };
  //API TRANSAUDIT_GETROW
  const GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      vocTyp: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      trnTyp: sTrnTyp,
      field: xid,
    };
    const vTransAudit = await fExecuteAPI("TRANSAUDIT_GETROW", vTransAuditObj);
    if (vTransAudit.Type?.toUpperCase() === "SUCCESS") {
      let vTransAuditRes = vTransAudit.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridDataAuditRows(vTransAuditRes);
    } else {
      fAlertToast("FAILED", vTransAudit.Message);
    }
  };
  //Modal Batch
  const [sBatchModal, setBatchModal] = useState(false);
  const [sBatch_Total_Qty, setBatch_Total_Qty] = useState(0);
  const [sBatchDetailErrorMsg, setBatchDetailErrorMsg] = useState(
    BatchDetail_ErrorMsg_Init
  );

  const [sBatchObj, setBatchObj] = useState({
    SrNo: 0,
    ItemCode: "",
    ItemName: "",
    Qty: 0,
    Unit: "",
    BaseQty: 0,
  });
  const [sBatchUnit, setBatchUnit] = useState([]);
  const [sBatchCurrentEditQty, setBatch_Edit_BaseQty] = useState(0);
  const [sBatch_Load_GridData, setBatch_Load_GridData] = useState([]);
  const [sBatchDetailObj, setBatchDetailObj] = useState({
    BatchDetail_SrNo: 0, //rowId
    BatchDetail_BatchNo: 0,
    BatchDetail_MFDate: new Date(),
    BatchDetail_ExpDate: new Date(),
    BatchDetail_Qty: 0,
    BatchDetail_Unit: "",
    BatchDetail_PackQty: 0,
    BatchDetail_BaseQty: 0,
    BatchDetail_BalanceQty: 0,
  });
  const fOpenBatchModal = (xSrno, xBaseQty, xPackQty) => {
    fBatch_Load_Grid(xSrno, xBaseQty, xPackQty);
    setBatchModal(true);
  };

  const fBatch_CloseModal = (e) => {
    setBatchModal(false);
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_SrNo: 0,
      BatchDetail_BatchNo: 0,
      BatchDetail_MFDate: new Date(),
      BatchDetail_ExpDate: new Date(),
      BatchDetail_Qty: 0,
      BatchDetail_Unit: "",
      BatchDetail_PackQty: "",
    }));
    setBatchObj({
      SrNo: 0,
      ItemCode: "",
      ItemName: "",
      Qty: 0,
      Unit: "",
      BaseQty: 0,
    });
    setBatchUnit([]);
    setBatch_Load_GridData([]);
    setBatch_Total_Qty(0);
    setBatch_Edit_BaseQty(0);
  };

  const fBatch_New = () => {
    setBatchDetailErrorMsg(BatchDetail_ErrorMsg_Init);
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_SrNo: 0,
      BatchDetail_BatchNo: 0,
      BatchDetail_MFDate: new Date(),
      BatchDetail_ExpDate: new Date(),
      BatchDetail_Qty: 0,
      BatchDetail_Unit: sBatchUnit[0].Unit,
      BatchDetail_PackQty: sBatchUnit[0].PackQty,
    }));
    fBatch_BaseQty_Calculation(0, sBatchUnit[0].PackQty);
    fBatch_Load_Grid(sBatchObj.SrNo, sBatchObj.BaseQty, sBatchUnit[0].PackQty);
    setBatch_Edit_BaseQty(0);
  };

  const fBatch_Delete = async () => {
    confirmAlert({
      title: "Delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            fBatch_Delete2();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };
  const fBatch_Delete2 = async () => {
    let iBatchDelete = await GetDeleteDetailBatch(
      sBatchObj.SrNo,
      sBatchDetailObj.BatchDetail_SrNo,
      dispatch
    );
    if (iBatchDelete == "SUCCESS") {
      fBatch_New();
    }
  };

  const fBatch_Save = async () => {
    setBatchDetailErrorMsg(BatchDetail_ErrorMsg_Init);
    let iValidationBatch = fValidationBatch_Client(
      sBatchDetailObj,
      setBatchDetailErrorMsg
    );
    if (!iValidationBatch) return;

    if (
      Number(sBatchDetailObj.BatchDetail_BalanceQty) -
        Number(sBatchDetailObj.BatchDetail_Qty) <
      0
    ) {
      fAlertToast(
        "FAILED",
        "You are trying to save excess batch qty then purchase qty (Avl qty =" +
          sBatchDetailObj.BatchDetail_BalanceQty +
          ")"
      );
    } else {
      let iBatchSave = await GetSaveDetailBatch(
        sBatchObj,
        sBatchDetailObj,
        dispatch
      );
      if (iBatchSave == "SUCCESS") {
        fBatch_New();
      }
    }
  };
  const fBatch_Load_Grid = async (xSrNo, xBaseQty, xPackQty) => {
    let iBatchLoadGrid = await GetBatchDetail(xSrNo, dispatch);
    if (iBatchLoadGrid.length > 0) {
      let GridID = iBatchLoadGrid?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setBatch_Load_GridData(GridID);
      const { iTotalQty } = iBatchLoadGrid.reduce(
        (iValue, item) => {
          iValue.iTotalQty += item.C_BaseQty;
          return iValue;
        },
        { iTotalQty: 0 }
      );
      setBatch_Total_Qty(iTotalQty);
      fBatch_BalanceQty_Calculation(xBaseQty, iTotalQty, xPackQty, 0);
    } else {
      setBatch_Load_GridData([]);
      setBatch_Total_Qty(0);
      fBatch_BalanceQty_Calculation(xBaseQty, 0, xPackQty, 0);
    }
  };

  const fBatch_RowClick_Load_Grid = (item) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_SrNo: item.row.C_RowId, //rowId
      BatchDetail_BatchNo: item.row.C_BatchNo,
      BatchDetail_MFDate: moment(item.row.C_BatchDt, "DD/MM/YYYY")._d,
      BatchDetail_ExpDate: moment(item.row.C_ExpDt, "DD/MM/YYYY")._d,
      BatchDetail_Qty: item.row.C_Qty,
      BatchDetail_Unit: item.row.C_Unit,
      BatchDetail_BaseQty: item.row.C_BaseQty,
    }));
    setBatch_Edit_BaseQty(Number(item.row.C_BaseQty));
    let vItemUnitSet = sBatchUnit.find((obj) => {
      return obj.Unit === item.row.C_Unit;
    });
    let currentPackQty = sBatchUnit[0].PackQty;
    if (!!vItemUnitSet) {
      setBatchDetailObj((obj) => ({
        ...obj,
        BatchDetail_Unit: vItemUnitSet.Unit,
        BatchDetail_PackQty: vItemUnitSet?.PackQty,
      }));
      currentPackQty = vItemUnitSet?.PackQty;
    }
    fBatch_BalanceQty_Calculation(
      sBatchObj.BaseQty,
      sBatch_Total_Qty,
      currentPackQty,
      item.row.C_BaseQty
    );
  };

  const fBatch_BalanceQty_Calculation = (
    xBaseQty,
    xTotalQty,
    xPackQty,
    xExistingQty = 0
  ) => {
    let vBalanceQty =
      Number(xPackQty) === 0
        ? 0
        : (fcovertToNumber(xBaseQty) +
            fcovertToNumber(xExistingQty) -
            fcovertToNumber(xTotalQty)) /
          fcovertToNumber(xPackQty);

    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_BalanceQty: vBalanceQty,
    }));
    return vBalanceQty;
  };

  const fBatch_BaseQty_Calculation = (xQty, xPackQty) => {
    let vBaseQty = fcovertToNumber(xPackQty) * fcovertToNumber(xQty);
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_BaseQty: vBaseQty,
    }));

    return vBaseQty;
  };

  const fBatch_MFDate = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_MFDate: e.$d,
    }));
  };

  const fBatch_ExpDate = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_ExpDate: e.$d,
    }));
  };

  const fBatch_BatchNo = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_BatchNo: e.target.value,
    }));
  };
  const fBatch_Qty = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_Qty: e.target.value,
    }));
    fBatch_BaseQty_Calculation(
      Number(e.target.value),
      sBatchDetailObj.BatchDetail_PackQty
    );
  };
  const fBatch_Focus_Qty = (e) => {
    if (e.target.value == 0) {
      setBatchDetailObj((obj) => ({
        ...obj,
        BatchDetail_Qty: "",
      }));
    }
  };

  const fBatch_Blur_Qty = (e) => {
    if (e.target.value === "") {
      setBatchDetailObj((obj) => ({
        ...obj,
        BatchDetail_Qty: 0,
      }));
    }
  };

  const fBatch_Unit = (e) => {
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_Unit: e.target.value,
    }));
    let vItemUnitSet = sBatchUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_PackQty: vItemUnitSet?.PackQty,
    }));
    fBatch_BaseQty_Calculation(
      sBatchDetailObj.BatchDetail_Qty,
      vItemUnitSet?.PackQty
    );
    fBatch_BalanceQty_Calculation(
      sBatchObj.BaseQty,
      sBatch_Total_Qty,
      vItemUnitSet?.PackQty,
      sBatchCurrentEditQty
    );
  };
  //API DETAIL

  //MAIN BUTTON

  const fMove_First = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[0].A_VocTyp,
      sUser_Doc_Arr[0].A_VocNo,
      dispatch,
      fNewDetail,
      setBuyer
    );
    setNavDocValue(1);
  };

  const fMove_Last = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocNo,
      dispatch,
      fNewDetail,
      setBuyer
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };

  const fMove_Previouse = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].A_VocTyp,
        sUser_Doc_Arr[row - 1].A_VocNo,
        dispatch,
        fNewDetail,
        setBuyer
      );
      setNavDocValue(row);
    }
  };

  const fMove_Next = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);

    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].A_VocTyp,
        sUser_Doc_Arr[row - 1].A_VocNo,
        dispatch,
        fNewDetail,
        setBuyer
      );
      setNavDocValue(row);
    }
  };
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fPrint = useCallback(
    (xPrnTyp) => {
      let vrdl = vRdxDBBranchList.find((obj) => {
        return obj.LocName[0] == vRdxWmsHead.A_Loc;
      });
      let webReport = vRdxDBKernObj.WEB_REPORT_BASE_URL 
      //  /WMS/GRN?trntyp=WMINV03&voctyp=WS001&vocno=WS/0000001&prntyp=PC
      if (vrdl?.InvoiceFile != "") {
        let urlPrint =
          webReport?.Val +
          "WMS/GRN?trntyp=" +
          sTrnTyp +
          "&voctyp=" +
          vRdxWmsHead.A_VocTyp +
          "&vocno=" +
          vRdxWmsHead.A_VocNo +
          "&prnTyp=" +
          xPrnTyp;
        setWebReportUrlModal(urlPrint);
        fWebReport();
      } else {
        let urlPrint =
          webReport?.Val +
          "WMS/GRN?trntyp=" +
          sTrnTyp +
          "&voctyp=" +
          vRdxWmsHead.A_VocTyp +
          "&vocno=" +
          vRdxWmsHead.A_VocNo +
          "&prnTyp=" +
          xPrnTyp +
          "&amountInWord=''";
        setWebReportUrlModal(urlPrint);
        fWebReport();
        console.log(urlPrint);
      }
    },
    [
      vRdxWmsHead.A_Loc,
      vRdxWmsHead.A_VocNo,
      vRdxWmsHead.A_VocTyp,
      vRdxDBKernObj,
      vRdxDBBranchList,
    ]
  );

  const fDetailConfirmation = async () => {
    const { HeadObject } = WmsInboundOutletRo();
    const vRdxUserInfoObj = vRdxUserInfo();

    let obj = {
      v_A_VocTyp: HeadObject.A_VocTyp,
      v_A_VocNo: HeadObject.A_VocNo,
      v_B_Itmcd: sBufferObj.B_Itmcd,
      v_B_Unit: sBufferObj.B_Unit,
      v_A_Loc: HeadObject.A_Loc,
      v_B_BaseQty: sBufferObj?.B_BaseQty,
      v_B_NetAmt: sBufferObj.B_NetAmt,
      v_A_RefDocTyp: HeadObject.A_RefDocTyp,
      v_A_RefDocNo: HeadObject.A_RefDocNo,
      v_A_Party: HeadObject.A_Party,
      v_InboundType: HeadObject.InboundType,
      v_TaxDept: sBufferObj?.B_TaxDept,
      v_TaxDept2: sBufferObj?.B_TaxDept2,
      v_A_RefDocVer: HeadObject.A_RefDocVer,
      v_UserCd: vRdxUserInfoObj.UserID,
    };
    let resp = await WMSInbound_ConfirmWMINV03LineItem_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet?.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet);
      } else {
        await handleSaveOrApprove(true, vRdxWmsHead.A_DocStat);
      }
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
      return false;
    }
  };
  const finalSave = async (
    xSave = true,
    xDocStatus = vRdxWmsHead.A_DocStat
  ) => {
    fSaveHead(
      xSave,
      setUser_Doc_Arr,
      sUser_Doc_Arr,
      dispatch,
      fNewDetail,
      sBufferObj,
      fOpenBatchModal,
      setBatchUnit,
      setBatchObj,
      setBatchDetailObj,
      setBuyer,
      xDocStatus,
      fNavigateToNotification
    );
  };

  //API REVERSETRANSACTION_GETROW
  const GetRevereTransaction = async () => {
    let vRevereTransactionObj = {
      // trnTyp: sTrnTyp,
      A_VocTyp: vRdxWmsHead.A_VocTyp,
      A_VocNo: vRdxWmsHead.A_VocNo,
      A_PostDt: moment(vRdxWmsHead.A_PostDt).format("MM/DD/YYYY"),
      A_Loc: vRdxWmsHead.A_Loc,
      A_Party: vRdxWmsHead.A_Party,
      userCd: vRdxuserInfo.UserID,
      IP: vRdxuserInfo.IP,
      netAmt: sFooterObj.A_LandVal,
      revNarr: "Draft to Enter",
      v_DocStat: vRdxWmsHead.A_DocStat,
    };
    const resp = await WMSInbound_ReverseWMINV03_GETROW(vRevereTransactionObj);
    if (resp?.status === 200) {
      return true;
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
      return false;
    }
  };
  const processResponse = (
    response,
    xsave = true,
    docstatus = vRdxWmsHead.A_DocStat
  ) => {
    console.log("response", response);
    // Step 1: Check if there's any STOP type message
    const stopItem = response.find((item) => item.Type === "STOP");

    if (stopItem) {
      fAlertToast("FAILED", stopItem.Message);
      return false;
    }

    // Step 2: If no STOP, process CONFIRMATION dialogs
    let confirmationIndex = 0;
    console.log("confirmationIndex", confirmationIndex);

    const askConfirmation = async () => {
      if (confirmationIndex >= response.length) {
        // All confirmations processed successfully
        // fAlertToast("SUCCESS", "Saved Successfully");
        await handleSaveOrApprove(xsave, docstatus);
        // return true;
      }

      const currentItem = response[confirmationIndex];
      if (currentItem?.Type === "CONFIRMATION") {
        setTimeout(() => {
          confirmAlert({
            title: "Confirmation",
            message: currentItem.Message,
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  confirmationIndex = confirmationIndex + 1;
                  askConfirmation(); // Proceed to next confirmation
                },
              },
              {
                label: "No",
                onClick: () => {
                  fAlertToast("FAILED", currentItem.Message);
                  return false;
                },
              },
            ],
          });
        }, 200);
      }
    };

    askConfirmation();
  };

  const serverValidation = async () => {
    const { HeadObject } = WmsInboundOutletRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    
    let incentiveGroupAllow = false;

    let obj = {
      v_A_VocTyp: HeadObject.A_VocTyp,
      v_A_VocNo: HeadObject.A_VocNo,
      v_A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_A_Loc: HeadObject.A_Loc,
      v_A_Party: HeadObject.A_Party,
      v_UserCd: vRdxUserInfoObj.UserID,
      v_A_RefDocTyp: HeadObject.A_RefDocTyp,
      v_A_RefDocTypName: HeadObject.A_RefDocTypName,
      v_A_RefDocNo: HeadObject.A_RefDocNo,
      v_A_RefDocVer: parseFloat(vRdxWmsHead.A_RefDocVer),
      v_InboundType: vRdxWmsHead.InboundType,
      // v_Rebate: "N", //false but in sp nee to snd as N
      v_B_Srno: sBufferObj.B_Srno,
      v_B_Itmcd: sBufferObj.B_Itmcd,
      v_B_Qty: sBufferObj.B_Qty,
      v_B_Unit: sBufferObj.B_Unit,
      v_B_GrossAmt: parseFloat(sBufferObj?.B_GrossAmt),
      v_B_LDiscPerc: sBufferObj.B_LDiscPerc,
      v_B_BaseQty: parseFloat(sBufferObj?.B_BaseQty),
      // v_B_NetAmt: parseFloat(sBufferObj.B_NetAmt),
      v_B_TaxPerc: sBufferObj.B_TaxPerc,
      v_TaxDept: sBufferObj?.B_TaxDept,
      v_TaxDept2: sBufferObj?.B_TaxDept2,
      v_B_TaxPerc2: sBufferObj.B_TaxPerc2,
      v_B_CI: sBufferObj.B_CI,
      v_IncentiveGrp: incentiveGroupAllow ? sBufferObj.B_IncGroup : "N",
      v_A_INV_TYPE: "",
      v_TaxType: HeadObject.TaxType,
      // PurchaseBlock:"N",
      v_InvoiceNo: HeadObject.A_RefNo,
      UnloadingBay: HeadObject.UnloadingBay,
      v_PalletType: sBufferObj.PalletType,
    };
    let resp = await validationWMINV03_Outlet_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet?.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet);
      } else {
        return true;
      }
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg || "error in validationWMINV03 "
        );
        const errorField = resp?.response?.data?.message?.field;
        const errorMsg = resp?.response?.data?.message?.msg;
        if (ErrorMsg.hasOwnProperty(errorField)) {
          setErrorMsg((prev) => ({
            ...prev,
            [errorField]: errorMsg,
          }));
        } else if (ErrorMsgDetail.hasOwnProperty(errorField)) {
          setErrorMsgDetail((prev) => ({
            ...prev,
            [errorField]: errorMsg,
          }));
        }
      }
      return false;
    }
  };

  const handleSaveOrApprove = async (
    xsave = true,
    docstatus = vRdxWmsHead.A_DocStat
  ) => {
    if (vRdxWmsHead.A_VocNo == "0" || !xsave) {
      setTimeout(() => {
        confirmAlert({
          title: `${xsave ? "Save" : "Approve"}`,
          message: `Are you want to ${xsave ? "Save" : "Approve"}?`,
          buttons: [
            {
              className: "alertBtn",
              name: "SaveYes",
              label: "Yes",
              onClick: async () => {
                await finalSave(xsave, docstatus);
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {
                return;
              },
            },
          ],
        });
      }, 100);
      setTimeout(() => {
        document.getElementsByName("SaveYes")[0]?.focus();
      }, 150);
    } else if (xsave) {
      await finalSave(xsave, docstatus);
    }
  };

  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fCloseReverseTransactionModal(setReverseTransactionModal);
    fClearErrorMsg();

    timeout = setTimeout(async () => {
      setSaveLoaded(false);
      if (vRdxWmsHead.A_DocStat === "DRAFT") {
        confirmAlert({
          title: "Reverse",
          message: `Are you sure to Reverse.`,
          buttons: [
            {
              className: "alertBtn",
              label: "Yes",
              onClick: async () => {
                let reverseResp = await GetRevereTransaction();
                if (reverseResp) {
                  fClearErrorMsg();
                  dispatch(
                    Set_HeadObject_A_DocStat({
                      A_DocStat: "ENTER",
                    })
                  );
                  fAlertToast("SUCCESS", "SUCCESSFULLY REVERSED");
                }
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {},
            },
          ],
        });
      } else if (vRdxWmsHead.A_DocStat != "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxWmsHead.A_DocStat.toLowerCase() + " mode"
        );
        return;
      } else {
        let validation = fValidationHead_Client(
          vRdxWmsHead,
          setErrorMsg,
          sFooterObj,
          vMediaQuery,
          fSummary
        );

        if (!validation) return;

        let validationDetil = fValidationDetail_Client(
          vRdxWmsHead,
          sBufferObj,
          setErrorMsgDetail,
          sDetailGridData,
          sIncentiveGroups
        );

        if (!validationDetil) return;

        // let server_Validation =true
        let server_Validation = await serverValidation();

        if (!server_Validation) return;

        if (server_Validation) {
          await handleSaveOrApprove(true);
        }
      }
    }, 500);
  };

  const fNavigateToNotification = () => {
    if (vMediaQuery) {
      navigate("/Notification");
      clearLoactionState();
    }
  };
  const processApproveResponse = (response,xbool, docstatus) => {
      console.log("response", response);
      // Step 1: Check if there's any STOP type message
      const stopItem = response.find((item) => item.Type === "STOP");
  
      if (stopItem) {
        fAlertToast("FAILED", stopItem.Message);
        return false;
      }
  
      // Step 2: If no STOP, process CONFIRMATION dialogs
      let confirmationIndex = 0;
      console.log("confirmationIndex", confirmationIndex);
  
      const askConfirmation = () => {
        if (confirmationIndex >= response.length) {
          // All confirmations processed successfully
          // fAlertToast("SUCCESS", "Saved Successfully");
          setTimeout(async () => {
            await fApproveConfirmation(xbool, docstatus);
          }, 100);
          // return true;
        }
  
        const currentItem = response[confirmationIndex];
        if (currentItem?.Type === "CONFIRMATION") {
          setTimeout(() => {
            confirmAlert({
              title: "Confirmation",
              message: currentItem.Message,
              buttons: [
                {
                  label: "Yes",
                  onClick: () => {
                    confirmationIndex = confirmationIndex + 1;
                    askConfirmation(); // Proceed to next confirmation
                  },
                },
                {
                  label: "No",
                  onClick: () => {
                    fAlertToast("FAILED", currentItem.Message);
                    return false;
                  },
                },
              ],
            });
          }, 200);
        }
      };
  
      askConfirmation();
    };
    const fApproveConfirmation = async (xbool=false, docstatus) => {
      const { HeadObject } = WmsInboundOutletRo();
      const vRdxUserInfoObj = vRdxUserInfo();
  
      let obj = {   
     v_A_VocTyp: HeadObject.A_VocTyp,
    v_A_VocNo: HeadObject.A_VocNo,
     v_UserId: vRdxUserInfoObj.UserID, 
     v_InboundType: vRdxWmsHead.InboundType, 
      };
      let resp = await ApproveWMINV03confirm_Outlet(
        fcheck_null_undefine_replace_empty(obj)
      );
      if (resp?.status === 200) {
        console.log(resp);
        if (resp?.data?.ResultSet?.length > 0) {
          //in this case it will ask or confirmation
          processResponse(resp?.data.ResultSet,xbool, docstatus);
        } else {
          await handleSaveOrApprove(xbool,docstatus);
        }
      } else {
        if (resp.response.status == 500) {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg ||
              "error in ValidateInvTransHeadUpdate "
          );
        }
        return false;
      }
    };
  const ValidationApprove = async (xbool, docstatus) => {
    const { HeadObject } = WmsInboundOutletRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    const { SplDiscAmt } =
      sDetailGridData.length > 0
        ? sDetailGridData.reduce(
            (iValue, item) => {
              iValue.SplDiscAmt += item?.SplDiscAmt;
              return iValue;
            },
            { SplDiscAmt: 0 }
          )
        : { iSplDiscAmt: 0 };

    let obj = {
      v_A_VocTyp: HeadObject.A_VocTyp,
      v_A_VocNo: HeadObject.A_VocNo,
      v_A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_A_Loc: HeadObject.A_Loc,
      v_A_Party: HeadObject.A_Party,
      v_UserCd: vRdxUserInfoObj.UserID,
      v_A_RefDocTyp: HeadObject.A_RefDocTyp,
      // v_A_RefDocTypName: HeadObject.A_RefDocTypName,
      v_A_RefDocNo: HeadObject.A_RefDocNo,
      v_InboundType: vRdxWmsHead.InboundType,
      v_A_RefDocVer: parseFloat(vRdxWmsHead.A_RefDocVer),
      UnloadingBay: HeadObject.UnloadingBay,

      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      v_UserId: vRdxUserInfoObj.UserID,

      // v_A_Buyer:HeadObject.A_Buyer,
      v_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_Party: HeadObject.A_Party,
      v_Loc: HeadObject.A_Loc,
      // v_InboundType: vRdxWmsHead.InboundType,
      // v_A_PutAway: vRdxWmsHead?.A_PutAway,
      v_VendorInvAmount: 0, //parseFloat(vRdxWmsHead.VendorInvAmount),
      v_A_LandVal: parseFloat(sFooterObj.A_LandVal),
      RefDocTyp: HeadObject.A_RefDocTyp,
      RefDocNo: HeadObject.A_RefDocNo,
      SalesGrp: "",
      v_Offer: HeadObject.offer,
      v_DiscDistribution: HeadObject.A_DiscFlag,
      v_A_Buyer: HeadObject.A_Buyer,
      v_SplDiscAmt: 0, //by sir bcoz linerebatand spldisc same
      v_FREIGHT: HeadObject.A_LC,
      v_Charges: HeadObject.A_Charges1,

      v_lineRebateAmt: SplDiscAmt, 
       v_InvoiceNo: HeadObject.A_RefNo,
    };
    let resp = await ApproveWMINV03_Outlet_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );

    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet.length > 0) {
        //in this case it will ask or confirmation
        processApproveResponse(resp?.data.ResultSet,xbool, docstatus)
       
        // processResponse(resp?.data.ResultSet, xbool, docstatus);
      } else {
        await fApproveConfirmation(xbool, docstatus)
      }
    } else {
      if (resp.response.status == 500) {
        if (resp?.response?.data?.message?.field == "UNKNOWN") {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg ||
              "error in ValidateInvTransHeadUpdate "
          );
        } else {
          const errorField = resp?.response?.data?.message?.field;
          const errorMsg = resp?.response?.data?.message?.msg;
          if (ErrorMsg.hasOwnProperty(errorField)) {
            setErrorMsg((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else if (ErrorMsgDetail.hasOwnProperty(errorField)) {
            setErrorMsgDetail((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else {
            fAlertToast(
              "FAILED",
              resp.response.data.message.msg ||
                "error in ValidateInvTransHeadUpdate "
            );
          }

          document
            ?.getElementsByName([resp?.response?.data?.message?.field])[0]
            ?.focus();
        }
      }
      return false;
    }
  };

  const fApprove = async (xDocStatus) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd != "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetailGridData.length == 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }

      let validation = fValidationHead_Client(
        vRdxWmsHead,
        setErrorMsg,
        sFooterObj,
        vMediaQuery,
        fSummary
      );

      if (!validation) return;

      let Searver_ValidationApprove = await ValidationApprove(
        false,
        xDocStatus
      );
      // if (!Searver_ValidationApprove) return;

      // if (!!Searver_ValidationApprove) {
      //   setTimeout(() => {
      //     confirmAlert({
      //       title: "Approve",
      //       message: "Are you want to Approve..",
      //       buttons: [
      //         {
      //           className: "alertBtn",
      //           name: "SaveYes",
      //           label: "Yes",
      //           onClick: async () => {
      //             await finalSave(false, xDocStatus);
      //           },
      //         },
      //         {
      //           className: "alertBtn",
      //           label: "No",
      //           onClick: () => {
      //             return;
      //           },
      //         },
      //       ],
      //     });
      //   }, 200);
      // }
    }, 800);
  };

  const clearLoactionState = () => {
    if (!!vMediaQuery) {
    } else {
      location.state = {
        GRNDocTyp: "",
        GrnDocNo: "",
        RefNo: "",
        RefVocNo: "",
        RefVocTyp: "",
        RefVocName: "",
      };
    }
  };

  const fClearErrorMsg = () => {
    setErrorMsg(ErrorMsg);
    setErrorMsgDetail(ErrorMsgDetail);
    setRevNarr("");
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_ItmName == "") {
      setStockObj({
        BalanceQty: 0,
        POQty: 0,
        GRNQty: 0,
      });

      let idefaultTaxTypeValue = "INTRN001";
      let iDefaultTaxType = await GetTransTaxType(
        vRdxDBLocation[0].UID, //locaation
        "", //partyname in new it is empty,
        dispatch
      );

      if (Object.keys(iDefaultTaxType).length != 0) {
        idefaultTaxTypeValue = iDefaultTaxType?.TaxType;
      }

      fNewHead();
      fNewDetail(0, 0, sDocLoading[0]?.VocTyp, idefaultTaxTypeValue);
      document.getElementsByName("A_PostDt")[0]?.focus();
    } else {
      fNewDetail(
        vRdxWmsHead.A_VocNo,
        vRdxWmsHead.A_Rounding,
        vRdxWmsHead.A_VocTyp,
        vRdxWmsHead.TaxType
      );
    }
  };

  const fNewHead = async () => {
    dispatch(Set_HeadObject_Init()); // Head Clearing
    setBatchModal(false);
    let idefaultTaxTypeValue = "INTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxDBLocation[0].UID, //locaation
      "", //partyname in new it is empty,
      dispatch
    );

    if (Object.keys(iDefaultTaxType).length != 0) {
      idefaultTaxTypeValue = iDefaultTaxType?.TaxType;
    }

    // Setting Initial List Box 0th Object
    dispatch(
      Wms_HeadObject_New_Set({
        A_VocTyp: sDocLoading[0]?.VocTyp,
        A_VocTypName: sDocLoading[0]?.VocName,
        A_VocNo: 0,
        A_Loc: vRdxDBLocation[0]?.UID,
        A_Curr: sCurrency[0]?.Uid,
        A_ExRate: sCurrency[0]?.Rate,
        A_Buyer: "", //sBuyer.length > 0 ? sBuyer[0].UId : "", for madina dubai
        TaxType: idefaultTaxTypeValue,
        UnloadingBay: sUnloading[0]?.UId,
        // InboundType: "TRANSFER_RETURN", //sForm
        // offer: "N",
        A_AutoBatch: xWMS_AUTO_BATCH,
      })
    );
    fBuyer_or_SalesMan(
      "VENDOR_INV",
      setBuyer,
      dispatch,
      vRdxDBLocation[0]?.UID,
      sDocLoading[0]?.VocTyp,
      0
    );
    let { currentPayMode, PaymodeEnable } = fDefaultPayload(
      sDocLoading[0]?.Paymode,
      dispatch
    );
    setPaymodeEnable(PaymodeEnable);

    GetDefaultDrCrAccount(
      sDocLoading[0].VocTyp,
      currentPayMode,
      "", //party
      dispatch
    );

    setNavDocValue(1); // nav init 1
    setDetailGridData([]);
    setBufferObj(vBufferObjInit);
    setFooterObj((obj) => initialFooterState);

    // document.getElementsByName("A_RefDocNo")[0]?.focus();
  };

  //vTaxType  vTaxType == "INTRN002" then tax %0
  const fNewDetail = (xVocNo, xRounding, xVocTyp, vTaxType) => {
    setBufferObj(vBufferObjInit);
    const { HeadObject } = WmsInboundOutletRo();
    setBufferObj((obj) => ({
      ...obj,
      B_TDiscPerc: HeadObject?.A_DiscPerc,
      PalletType: sPalletType[0]?.UId,
    }));
    //if inter.comp then tax group should be 0
    let iTaxPerc = 0;
    let iCessPerc = 0;
    if (vTaxType == "INTRN002" || vTaxType == "INTRN003") {
      let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
        return obj.UId == vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val;
      });
      let vCessGroupValue = vRdxGRNtax2.find((obj) => {
        return obj.UId == vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val;
      });
      if (vtaxGroupValue) {
        setBufferObj((obj) => ({
          ...obj,
          B_TaxDept: vtaxGroupValue?.UId,
          B_TaxPerc: vtaxGroupValue?.Perc,
          B_TaxDept2: vCessGroupValue?.UId,
          B_TaxPerc2: vCessGroupValue?.Perc,
        }));
      }
      iTaxPerc = vtaxGroupValue?.Perc;
      iCessPerc = vCessGroupValue?.Perc;
    }
    SetIncentiveGroups([]);
    setUnit([]);
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      0, //sBufferObj.B_Qty,
      0, //sBufferObj.B_PackQty,
      sCurrency[0]?.Rate, //exchangeRate
      0, //sBufferObj.B_URateFc,
      0, //sBufferObj.B_LDiscPerc,
      HeadObject?.A_DiscPerc, //sBufferObj.B_TDiscPerc,
      "N", //sBufferObj.B_FocFlag,
      0, //sBufferObj.B_ExciseTaxAmt,
      vTaxType == "INTRN002" || vTaxType == "INTRN003"
        ? iTaxPerc
        : vRdxGRNtax1[0].Perc, //tax1%
      vTaxType == "INTRN002" || vTaxType == "INTRN003"
        ? iCessPerc
        : vRdxGRNtax2[0].Perc, //tax%2
      0, //sBufferObj.AddCess,
      0, //Rounding
      0 //SplDiscPer
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));

    fLoad_Grid(xVocNo, 0, xRounding, setDetailGridData, setFooterObj, xVocTyp);

    document.getElementsByName("B_ItmName")[0]?.focus();
  };

  const ReceivingPost = (e) => {
    if (sDetailGridData.length == 0) {
      fAlertToast("INFO", "Add atleast one line item");
      return;
    } else {
      const { HeadObject } = WmsInboundOutletRo();
      var vObj = {
        GrnTyp: HeadObject.InboundType,
        NetAmt: sFooterObj.A_LandVal,
        DocTyp: HeadObject.A_VocTyp,
        DocNo: HeadObject.A_VocNo,
        RefDocTyp: HeadObject.A_RefDocTyp,
        RefDocNo: HeadObject.A_RefDocNo,
        Version: HeadObject.A_RefDocVer,
      };
      confirmAlert({
        title: "Receiving Complete",
        message: "Are you want to complete.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: async () => {
              await getRcvngPost(vObj);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };
  const [refUpdate, setRefUpdate] = useState(false);
  const fRefUpdate = () => {
    setRefUpdate(true);
  };
  const fUpdateCurrentRSP = async () => {
    //validation
    //confimation

    confirmAlert({
      title: "UpdateCurrentRSP",
      message: "Are you want to Update?",
      buttons: [
        {
          className: "alertBtn",
          name: "SaveYes",
          label: "Yes",
          onClick: async () => {
            const { HeadObject } = WmsInboundOutletRo();

            let Obj = {
              v_B_VocTyp: HeadObject.A_VocTyp,
              v_B_VocNo: HeadObject.A_VocNo,
            };

            const Resp = await RSPUpdate_OUTLET(Obj);

            if (Resp?.status === 200) {
              fAlertToast("SUCCESS", "Successfully Updated");
              fNewDetail(
                vRdxWmsHead.A_VocNo,
                vRdxWmsHead.A_Rounding,
                vRdxWmsHead.A_VocTyp,
                vRdxWmsHead.TaxType
              );
            }
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => {
            return;
          },
        },
      ],
    });

    // const { HeadObject } = WmsInboundOutletRo();

    // let Obj = {
    //   v_B_VocTyp: HeadObject.A_VocTyp,
    //   v_B_VocNo: HeadObject.A_VocNo,
    // };

    // const Resp = await RSPUpdate_VENDOR(Obj);

    // if (Resp?.status === 200) {
    //   fAlertToast("SUCCESS", "Successfully Updated");
    //   fNewDetail(
    //     vRdxWmsHead.A_VocNo,
    //     vRdxWmsHead.A_Rounding,
    //     vRdxWmsHead.A_VocTyp,
    //     vRdxWmsHead.TaxType
    //   );
    // }
  };
  const fListAllItem = async () => {
    confirmAlert({
      title: "FindAllItems",
      message: "Are you sure you want to ListAllItems..",
      buttons: [
        {
          className: "alertBtn",
          name: "SaveYes",
          label: "Yes",
          onClick: async () => {
            const { HeadObject } = WmsInboundOutletRo();

            let Obj = {
              v_DocTyp: HeadObject.A_VocTyp,
              v_DocNo: HeadObject.A_VocNo,
              v_UserGrp: vRdxuserInfo.UserGroupCode,
            };
            const Resp = await updateInvTransManualListing_OUTLET(Obj);

            if (Resp?.status === 200) {
              fAlertToast("SUCCESS", "Successfully Updated");
              fNewDetail(
                vRdxWmsHead.A_VocNo,
                vRdxWmsHead.A_Rounding,
                vRdxWmsHead.A_VocTyp,
                vRdxWmsHead.TaxType
              );
            }
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => {
            return;
          },
        },
      ],
    });
  };

  const fAddRemoveApi = async (type) => {
    const { HeadObject } = WmsInboundOutletRo();
    let Obj = {
      v_B_TrnTyp: sTrnTyp,
      v_B_VocTyp: HeadObject.A_VocTyp,
      v_B_VocNo: HeadObject.A_VocNo,
      v_Type: type,
    };

    const Resp = await TaxAddRemove_OUTLET(Obj);

    if (Resp?.status === 200) {
      fAlertToast("SUCCESS", "Successfully Updated");
      dispatch(
        Set_HeadObject_Set({
          ...vRdxWmsHead,
          A_Taxable: type == "Add" ? "Y" : "N",
        })
      );
      //dispatch tax
      fNewDetail(
        vRdxWmsHead.A_VocNo,
        vRdxWmsHead.A_Rounding,
        vRdxWmsHead.A_VocTyp,
        vRdxWmsHead.TaxType
      );
    }
  };

  const fTaxAdd = async () => {
    //validation
    if (!sBufferObj.B_ItmName) {
      fAlertToast("FAILED", "Add atleast one current line item");
      return;
    } else {
      confirmAlert({
        title: `Add tax`,
        message: `Are you sure you want to add tax..`,
        buttons: [
          {
            className: "alertBtn",
            name: "Add",
            label: "Yes",
            onClick: async () => {
              fAddRemoveApi("Add");
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => {
              return;
            },
          },
        ],
      });
    }
    // Save current items
    // Are you sure
    //api
  };
  const fTaxRemove = async () => {
    //validation
    if (!sBufferObj.B_ItmName) {
      fAlertToast("FAILED", "Add atleast one current line item");
      return;
    } else {
      confirmAlert({
        title: `Remove tax`,
        message: `Are you sure you want to remove tax..`,
        buttons: [
          {
            className: "alertBtn",
            name: "Add",
            label: "Yes",
            onClick: async () => {
              fAddRemoveApi("Remove");
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => {
              return;
            },
          },
        ],
      });
    }
    // Save current items
    // Are you sure
    //api
  };
  const fTaxConvertUpdate = async () => {
    //validation

    if (!sBufferObj.B_ItmName) {
      fAlertToast("FAILED", "Add atleast one current line item");
      return;
    }

    confirmAlert({
      title: "TaxConvertUpdate",
      message: "Are you sure you want to ConvertTaxUpdate..",
      buttons: [
        {
          className: "alertBtn",
          name: "Convert",
          label: "Yes",
          onClick: async () => {
            const { HeadObject } = WmsInboundOutletRo();
            let Obj = {
              v_Process: sTrnTyp,
              v_VocTyp: HeadObject.A_VocTyp,
              v_VocNo: HeadObject.A_VocNo,
              v_Taxable: vRdxWmsHead.A_TaxGross == "Y" ? "N" : "Y",
            };

            const Resp = await TaxConvertUpdate_OUTLET(Obj);

            if (Resp?.status === 200) {
              fAlertToast("SUCCESS", "Successfully Converted");
              // dispatch
              dispatch(
                Set_HeadObject_Set({
                  ...vRdxWmsHead,
                  A_TaxGross: vRdxWmsHead.A_TaxGross == "Y" ? "N" : "Y",
                })
              );

              fNewDetail(
                vRdxWmsHead.A_VocNo,
                vRdxWmsHead.A_Rounding,
                vRdxWmsHead.A_VocTyp,
                vRdxWmsHead.TaxType
              );
            }
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => {
            return;
          },
        },
      ],
    });

    // Save current items
    // Are you sure
    //api
  };

  //Load From Po start
  const [sLoadPoModal, setLoadPoModal] = useState(false);

  const fOpenLoadPoModal = () => {
    const { HeadObject } = WmsInboundOutletRo();
    if (HeadObject?.A_VocNo === 0) {
      fAlertToast("INFO", "Save Atleast one transaction");
      return;
    } else {
      setLoadPoModal(true);
    }
  };
  const fCloseLoadPoModal = () => {
    setLoadPoModal(false);
  };

  const floadFromPo = async (e) => {
    fOpenLoadPoModal();
  };

  //DMS

  const fDMS = () => {
    const { HeadObject } = WmsInboundOutletRo();

    let VocTyp = HeadObject.A_VocTyp;
    let VocNo = HeadObject.A_VocNo;

    OpenPdfInDefaultApp(VocTyp, VocNo);
  };

  const fDelete =(Srno = sBufferObj.B_Srno)=> {
    if (vRdxWmsHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (Srno === 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              fDeleteHead(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
      setTimeout(() => {
        document.getElementsByName("DeletYes")[0]?.focus();
      }, 100);
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  // DELETESIHEAD_GETROW

  const fDeleteHead = async () => {
    let vDeleteSIHeadObj = {
      A_VocTyp: vRdxWmsHead.A_VocTyp,
      A_VocNo: vRdxWmsHead.A_VocNo,
      IP: vRdxuserInfo.IP,
      UserId: vRdxuserInfo.UserID,
    };

    const vDeleteSIHead = await deleteHeadWMINV03_Outlet(vDeleteSIHeadObj);

    if (vDeleteSIHead?.status === 200) {
      if (sBufferObj.B_Srno == 0) {
        // vocno,srno
        dispatch(
          Set_HeadObject_A_DocStat({
            A_DocStat: "DELETE",
          })
        );
        fDisplay(
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_VocNo,
          dispatch,
          fNewDetail,
          setBuyer
        );

        fAlertToast("SUCCESS", "Successfully Deleted");
      }
    }
  };

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async (Srno=sBufferObj.B_Srno) => {
    let vDeleteSIDetailObj = {
      B_VocTyp: vRdxWmsHead.A_VocTyp,
      B_VocNo: vRdxWmsHead.A_VocNo,
      B_Srno: Srno 
    };

    const vDeleteSIDetail = await deleteDetailWMINV03_Outlet(
      vDeleteSIDetailObj
    );

    if (vDeleteSIDetail?.status == 200) {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail(
        vRdxWmsHead.A_VocNo,
        0,
        vRdxWmsHead.A_VocTyp,
        vRdxWmsHead.TaxType
      );
    }
  };

  const fDetail_Grid_DoubleClick = async (item) => {
    console.log("Doubleclick");

    setBatchObj((obj) => ({
      ...obj,
      SrNo: item.row.B_Srno,
      ItemCode: item.row.B_Itmcd,
      ItemName: item.row.ItmName,
      Qty: item.row.B_Qty,
      Unit: item.row.UnitName,
      BaseQty: item.row.B_BaseQty,
    }));

    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_Qty: 0,
    }));

    let currentUnitArr = await GetUnitArr(item.row.B_Itmcd, setBatchUnit);
    let currentPackQty = 0;

    if (currentUnitArr.length > 0) {
      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === item.row.B_Unit;
      });
      if (!!vItemUnitSet) {
        setBatchDetailObj((obj) => ({
          ...obj,
          BatchDetail_Unit: vItemUnitSet.Unit,
          BatchDetail_PackQty: vItemUnitSet?.PackQty,
        }));
        currentPackQty = vItemUnitSet?.PackQty;
      } else {
        setBatchDetailObj((obj) => ({
          ...obj,
          BatchDetail_Unit: currentUnitArr[0].Unit,
          BatchDetail_PackQty: currentUnitArr[0]?.PackQty,
        }));
        currentPackQty = currentUnitArr[0]?.PackQty;
      }
    }
    fBatch_BaseQty_Calculation(0, currentPackQty);

    fOpenBatchModal(item.row.B_Srno, item.row.B_BaseQty, currentPackQty); //baseqty 0
  };

  const fDetail_Grid_onRowClick = async (item) => {
    console.log("RowClick");
    setTimeout(async () => {
      setBufferObj((obj) => ({
        ...obj,
        B_VocTyp: vRdxWmsHead.A_VocTyp,
        B_VocNo: vRdxWmsHead.A_VocNo,
        B_Srno: item.row.B_Srno,
        B_Itmcd: item.row.B_Itmcd,
        // B_Barcode: "",
        B_ItmName: item.row.ItmName,
        B_Qty: item.row.B_Qty,
        B_CI: item?.row?.B_CI,
        B_Unit: item.row.B_Unit,
        B_UnitName: item.row.UnitName,
        // B_PackQty: item.row.B_PackQty, //not in grid
        B_URateFc: item.row.B_URateFc,
        B_GrossAmt: item.row.B_GrossAmt,
        B_LDiscPerc: item.row.B_LDiscPerc,
        B_LDiscAmt: item.row.B_LDiscAmt,
        B_TDiscPerc: item.row.B_TDiscPerc,
        B_TDiscAmt: item.row.B_TDiscAmt,
        B_FocFlag: item.row.B_FocFlag,
        B_AprmtFlag: item.row.B_AprmtFlag, //foc flag dropdown
        B_FocAmt: item.row.B_FocAmt,
        B_ExciseTaxAmt: item.row.B_ExciseTaxAmt,
        B_ExciseTaxNetAmt: item.row.B_ExciseTaxNetAmt,
        B_NetAmt: item.row.B_NetAmt,
        B_TaxDept: item.row.B_TaxDept,
        B_TaxPerc: item.row.B_TaxPerc,
        B_TaxAmt: item.row.B_TaxAmt,
        B_TaxDept2: item.row.B_TaxDept2,
        B_TaxPerc2: item.row.B_TaxPerc2,
        B_TaxAmt2: item.row.B_TaxAmt2,
        AddCess: item.row.AddCess,
        B_NetAddCess: item.row.B_NetAddCess,
        RebateType: "", //!!item.row.RebateType ? item.row.RebateType : "",
        ReduceCost: "N", // item.row.ReduceCost,
        SplDiscPerc: 0, //item.row.SplDiscPerc.toFixed(4),
        SplDiscAmt: 0, //item.row.SplDiscAmt,
        SplDisc: 0, //item.row.SplDiscAmt1,
        B_IncGroup: item.row.B_IncGroup,
        B_SuprvPerc: item.row.B_SuprvPerc,
        B_OthersPerc: item.row.B_OthersPerc,
        B_SLANSuprv: item.row.B_SLANSuprv,
        B_SlabAmtSuprv: item.row.B_SlabAmtSuprv,
        B_SLANOther: item.row.B_SLANOther,
        B_SlabAmtOther: item.row.B_SlabAmtOther,
        B_Rounding: item.row.B_Rounding ? item.row.B_Rounding : 0,

        B_LandVal: item.row.B_LandVal,
        B_BaseQty: item.row.B_BaseQty,
        B_URateLc: item.row.B_URateLc,
        SuppRefNo: item.row.B_VocNo,
        SuppRefNo1: item?.row?.SuppRefNo1,
        PalletType: item.row?.B_Pallet_Type,
        Reason: item.row?.B_Reason || "",
        B_Barcode: item.row?.B_VocTyp || "", //by sir
        // B_Ad_CessAmt: 0,
        // B_Ad_PCQty: 0,
      }));
      let currentUnitArr = await GetUnitArr(item.row.B_Itmcd, setUnit);
      let vUnitvalue = currentUnitArr.find((obj) => {
        return obj.Unit === item.row.B_Unit;
      });
      let resp = await GetReason(setReason);
      setBufferObj((obj) => ({
        ...obj,
        B_Unit: vUnitvalue?.Unit,
        B_UnitName: vUnitvalue?.Name1,
        B_PackQty: vUnitvalue?.PackQty,
        PackDesc: vUnitvalue?.PackDesc,
      }));
    }, 300);

    fCloseViewModal();
  };

  //Sales Group modal

  //Sales Group Modal
  const [sSaleGroupTypeArr, setSaleGroupTypegArr] = useState([
    { UId: "Supervisor", Name: "Supervisor" },
    { UId: "Driver", Name: "Driver" },
    { UId: "Salesman", Name: "Salesman" },
    { UId: "Helper", Name: "Helper" },
  ]);
  const [sSalesGroupModal, setSalesGroupModal] = useState(false);
  const [sSalesGroupModalObj, setSalesGroupModalObj] = useState({
    Group: "",
    SrNo: "0",
    Type: sSaleGroupTypeArr[0].UId,
    EmployeeID: "",
    EmployeeName: "",
    // Branch: "1",
    Active: "Y",
    // ImageUrl: "",
  });
  var vErrorMsgVanMasterInit = {
    SrNo: "",
    Type: "",
    EmployeeID: "",
    EmployeeName: "",
    Active: "",
  };
  const [sErrorMsgVanMaster, setErrorMsgVanMaster] = useState({
    SrNo: "",
    Type: "",
    EmployeeID: "",
    EmployeeName: "",
    Active: "",
  });

  const [sSalesGroupModalArr, setSalesGroupModalArr] = useState([]);
  const fGetVanMasterSearchEnter = (e) => {
    if (e.key == "Backspace") {
      setSalesGroupModalObj((obj) => ({
        ...obj,
        EmployeeID: "",
      }));
    }
    if (
      e._reactName === "onClick" ||
      (e.key == "Enter" && e.target.name == "EmployeeName")
    ) {
      fOpenSalesGroupEmployeeModal();
      setSalesGroupEmployeeModelObj((obj) => ({
        ...obj,
        AnyData: sSalesGroupModalObj.EmployeeName,
      }));
      if (sSalesGroupModalObj.EmployeeName !== "") {
        GetEmployeeSearchVanGroup(sSalesGroupModalObj.EmployeeName);
      }
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      setTimeout(() => {
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-5");
          // vIsDownKeyPressedSimpleSearch = true;
          // tabel?.getElementsByClassName('MuiDataGrid-row')[0].firstChild.click();
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }, 100);
    }
  };

  //GCSimpleSearch Sales Group Modal
  const fVanMasterRowClick = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      SrNo: e?.row?.Srno,
      Type: e?.row?.Typ,
      EmployeeID: e?.row?.EMPID,
      EmployeeName: e?.row?.EMPNAME,
      Active: e?.row?.Active,
    }));
  };

  // Sales Group Modal
  const fVanMasterRowCellClick = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fVanMasterRowClick(newSelectionModel);
    }
  };
  const fOnVanMasterSrNoModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnVanMasterTypModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnVanMasterActiveModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.checked ? "Y" : "N",
    }));
  };
  const fOnVanMasterEmployeeModal = (e) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      e.target.value.length <
        sSalesGroupModalObj.EmployeeName.toString().length &&
      vMediaQuery &&
      e.target.name === "EmployeeName"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      fGetVanMasterSearchEnter(vBackspaceObj);
    }
  };

  const fOpenSalesGroupModal = async () => {
    // setSalesGroupModal(true);
    if (vRdxWmsHead.A_VocNo !== 0 && vRdxWmsHead.salesGroup !== "") {
      if (vRdxWmsHead.A_DocStat == "ENTER") {
        let vFillVanMaster = await GetFillVanMaster();
        if (vFillVanMaster.toUpperCase() === "SUCCESS") {
          setSalesGroupModal(true);
          GetVANMastItemList();
          setSalesGroupModalObj((obj) => ({
            ...obj,
            Group: vRdxWmsHead.salesGroup,
          }));
          setTimeout(() => {
            document.getElementsByName("EmployeeName")[0]?.focus();
          }, 100);
        } else {
          fAlertToast("FAILED", "FillVanMaster not Saved ");
        }
      }
    } else {
      fAlertToast("FAILED", "VocNo and Sales Group shouldn't be Empty ");
    }
  };

  const fCloseSalesGroupModal = (e) => {
    setSalesGroupModal(false);
    fClearSalesGroupSearch();
  };

  const fClearSalesGroupSearch = () => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      Group: vRdxWmsHead.salesGroup,
      SrNo: "0",
      Type: sSaleGroupTypeArr[0].UId,
      EmployeeID: "",
      EmployeeName: "",
      // Branch: "1",
      Active: "Y",
      // ImageUrl: "",
    }));
    setSalesGroupModalArr([]);
    setErrorMsgVanMaster(vErrorMsgVanMasterInit);
  };
  const fNewSaleGroupModal = () => {
    fClearSalesGroupSearch();
    GetVANMastItemList();
  };
  const fValidationVanMasterSalesGroup = () => {
    let iRes = true;
    if (sSalesGroupModalObj.SrNo === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        SrNo: "SrNo should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.Type === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        Type: "Type should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.EmployeeID === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        EmployeeID: "EmployeeID should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.EmployeeName === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        EmployeeID: "EmployeeName should not be empty",
      }));
      iRes = false;
    }
    if (sSalesGroupModalObj.Active === "") {
      setErrorMsgVanMaster((obj) => ({
        ...obj,
        Active: "Active should not be empty",
      }));
      iRes = false;
    }
    return iRes;
  };
  const fSaveSaleGroupModal = async () => {
    setErrorMsgVanMaster(vErrorMsgVanMasterInit);
    if (fValidationVanMasterSalesGroup()) {
      GetVANMastItemSave();
    }
  };
  const fDeleteSaleGroupModal = async () => {
    if (sSalesGroupModalObj.SrNo > 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              GetVANMastItemDelete();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  // Employee Modal
  const [sSalesGroupEmployeeModal, setSalesGroupEmployeeModal] =
    useState(false);
  const [sEmployeeSearchResultArr, setEmployeeSearchResultArr] = useState([]);
  const [sSalesGroupEmployeeModelObj, setSalesGroupEmployeeModelObj] = useState(
    {
      AnyData: "",
      FirstName: "",
      MiddleName: "",
      LastName: "",
    }
  );
  const fClearEmployeeSearch = () => {
    setSalesGroupEmployeeModelObj((obj) => ({
      ...obj,
      AnyData: "",
      FirstName: "",
      MiddleName: "",
      LastName: "",
    }));
    setEmployeeSearchResultArr([]);
  };
  const fOpenSalesGroupEmployeeModal = () => {
    fClearEmployeeSearch();
    setTimeout(() => {
      document.getElementsByName("AnyData")[0]?.focus();
    }, 100);
    setSalesGroupEmployeeModal(true);
  };
  const fCloseSalesGroupEmployeeModal = (e) => {
    setSalesGroupEmployeeModal(false);
    setTimeout(() => {
      document.getElementsByName("EmployeeName")[0]?.focus();
    }, 100);
  };

  //API FillVanMaster_GETROW
  const GetFillVanMaster = async () => {
    let vFillVanMasterObj = {
      VocTyp: vRdxWmsHead.A_VocTyp,
      VocNo: vRdxWmsHead.A_VocNo,
      SalesGroup: vRdxWmsHead.salesGroup,
      Flag: "N",
    };
    const vFillVanMaster = await fExecuteAPI(
      "WMINV03VANMASTFill_GETROW",
      vFillVanMasterObj
    );
    console.log(vFillVanMaster);
    if (vFillVanMaster.Type == "SUCCESS") {
      return vFillVanMaster.Type;
    } else if (vFillVanMaster.Type == "FAILED") {
      fAlertToast("FAILED", vFillVanMaster.Message);
      return vFillVanMaster.Type;
    } else if (
      vFillVanMaster.response.status == 500 ||
      vFillVanMaster.response.status == 400
    ) {
      fAlertToast("FAILED", vFillVanMaster.response.data.Status);
      return vFillVanMaster.Type;
    } else {
      fAlertToast("FAILED", "Error in loading FillVanMaster");
      return vFillVanMaster.Type;
    }
  };

  //API WMINV08VANMastItemList_GETROW
  const GetVANMastItemList = async () => {
    let vVANMastItemListObj = {
      VocTyp: vRdxWmsHead.A_VocTyp,
      VocNo: vRdxWmsHead.A_VocNo,
      UID: vRdxWmsHead.salesGroup,
    };
    const vVANMastItemList = await fExecuteAPI(
      "WMINV03VANMASTDetail_GETROW",
      vVANMastItemListObj
    );
    if (vVANMastItemList.Type == "SUCCESS") {
      let GridID = vVANMastItemList.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSalesGroupModalArr(GridID);
    } else if (vVANMastItemList.Type == "FAILED") {
      fAlertToast("FAILED", vVANMastItemList.Message);
    } else if (
      vVANMastItemList.response.status == 500 ||
      vVANMastItemList.response.status == 400
    ) {
      fAlertToast("FAILED", vVANMastItemList.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading VANMastItemList");
    }
  };

  //API WMINV08VANMastItemSave_GETROW
  const GetVANMastItemSave = async () => {
    let vSaveSaleGroupModalObj = {
      VocTyp: vRdxWmsHead.A_VocTyp,
      VocNo: vRdxWmsHead.A_VocNo,
      UId: vRdxWmsHead.salesGroup,
      SrNo: sSalesGroupModalObj.SrNo,
      Typ: sSalesGroupModalObj.Type,
      EMPID: sSalesGroupModalObj.EmployeeID,
      UserCd: vRdxuserInfo.UserID,
      Ip: vRdxuserInfo.IP,
      Active: sSalesGroupModalObj.Active,
    };
    const vSaveSaleGroupModal = await fExecuteAPI(
      "WMINV03VANMASTSave_GETROW",
      vSaveSaleGroupModalObj
    );
    if (vSaveSaleGroupModal.Type?.toUpperCase() == "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Saved");
      fNewSaleGroupModal();
    } else if (vSaveSaleGroupModal.Type?.toUpperCase() == "FAILED") {
      fAlertToast("FAILED", vSaveSaleGroupModal.Message);
    } else if (
      vSaveSaleGroupModal.response.status == 500 ||
      vSaveSaleGroupModal.response.status == 400
    ) {
      fAlertToast("FAILED", vSaveSaleGroupModal.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading SaveSaleGroupModal");
    }
  };

  //API EmployeeSearchVanGroup_GETROW
  const GetEmployeeSearchVanGroup = async (xAnyData) => {
    let vEmployeeSearchVanGroupObj = {
      v_AnyData: xAnyData,
      v_FName: sSalesGroupEmployeeModelObj.FirstName,
      v_LName: sSalesGroupEmployeeModelObj.LastName,
      v_MName: sSalesGroupEmployeeModelObj.MiddleName,
      v_UserCd: vRdxuserInfo.UserID,
    };
    const vEmployeeSearchVanGroup = await fExecuteAPI(
      "EmployeeSearchVanGroup_GETROW",
      vEmployeeSearchVanGroupObj
    );
    if (vEmployeeSearchVanGroup.Type == "SUCCESS") {
      let GridID = vEmployeeSearchVanGroup.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setEmployeeSearchResultArr(GridID);
    } else if (vEmployeeSearchVanGroup.Type == "FAILED") {
      fAlertToast("FAILED", vEmployeeSearchVanGroup.Message);
    } else if (
      vEmployeeSearchVanGroup.response.status == 500 ||
      vEmployeeSearchVanGroup.response.status == 400
    ) {
      fAlertToast("FAILED", vEmployeeSearchVanGroup.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading EmployeeSearchVanGroup");
    }
  };

  //API WMINV08VANMastItemDelete_GETROW
  const GetVANMastItemDelete = async () => {
    let vDeleteSaleGroupModalObj = {
      VocTyp: vRdxWmsHead.A_VocTyp,
      VocNo: vRdxWmsHead.A_VocNo,
      UId: vRdxWmsHead.salesGroup,
      SrNo: sSalesGroupModalObj.SrNo,
    };
    const vDeleteSaleGroupModal = await fExecuteAPI(
      "WMINV03VANMASTDelete_GETROW",
      vDeleteSaleGroupModalObj
    );
    if (vDeleteSaleGroupModal.Type?.toUpperCase() == "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Deleted");
      fNewSaleGroupModal();
    } else if (vDeleteSaleGroupModal.Type?.toUpperCase() == "FAILED") {
      fAlertToast("FAILED", vDeleteSaleGroupModal.Message);
    } else if (
      vDeleteSaleGroupModal.response.status == 500 ||
      vDeleteSaleGroupModal.response.status == 400
    ) {
      fAlertToast("FAILED", vDeleteSaleGroupModal.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading DeleteSaleGroupModal");
    }
  };

  //GCEmployeeSearch
  const fEmployeeSearchEnter = (e) => {
    if (e.key == "Enter") {
      GetEmployeeSearchVanGroup(sSalesGroupEmployeeModelObj.AnyData);
    }

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      setTimeout(() => {
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-6");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }, 200);
    }
  };
  const fonChangeInputEmployeeModal = (event) => {
    setSalesGroupEmployeeModelObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
  };

  //GCEmployeeSearch
  const fEmployeeRowClick = (e, x) => {
    setSalesGroupModalObj((obj) => ({
      ...obj,
      EmployeeID: e?.row?.EMPID,
      EmployeeName: e?.row?.SName,
      Active: e?.row?.InActive,
    }));
    fCloseSalesGroupEmployeeModal();
  };

  //GCEmployeeSearch
  const fEmployeeRowCellClick = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fEmployeeRowClick(newSelectionModel);
    }
  };

  const ExactSearchRefNoV2 = async (RefVocTyp, RefVocNo = "", RefNo = "") => {
    let srcDocNoArr = await GetdRefNoV2(
      RefVocTyp,
      RefVocNo,
      RefNo,
      setRefDocModalArr
    );

    let vExactSearchValue = srcDocNoArr[0];

    // call new API (VocTyp,VocNo,SrNo)

    if (!!vExactSearchValue) {
      dispatch(
        Wms_HeadObject_RefNo_ExactSearch_Set({
          A_RefDocTyp: vExactSearchValue.VocTyp, //
          A_RefDocTypName: vExactSearchValue.VocName, //
          A_RefDocNo: vExactSearchValue.VocNo, //
          A_Party: vExactSearchValue.Vendor,
          A_PartyName: vExactSearchValue.PartyName,
          // InboundType: vExactSearchValue.Source,
          UnloadingBay: vExactSearchValue.LDPay,
          UnloadingBayName: vExactSearchValue.LDPayName,
          A_PostDt: vExactSearchValue.GRNDate,
          A_RefNo: vExactSearchValue.RefNo,
          A_RefDt: vExactSearchValue.RefDate,
          // VendorInvAmount: vExactSearchValue.InvAmt,
          A_RefDocVer: vExactSearchValue.SrNo, //
        })
      );
      clearLoactionState();
      return vExactSearchValue;
    } else {
      return false;
    }
    //afer loading,if we press arrow left then refresh location state should remove
  };
  //esc keyZ close item dropdown
  const escFunction = useCallback(
    (event) => {
      if (event.key === "Escape") {
        setItemToggleDropdown(false);
        setGC_Toggle_Head_Customer_ToggleDropDowm(false);
      }
    },
    [setItemToggleDropdown]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onload = useCallback(async () => {
    
    if (vRdxDBKernObj.DIGIT_ROUNDING) {
      setRoundingVal(Number(vRdxDBKernObj.DIGIT_ROUNDING?.Val));
    }
        
    let xAutobatchVal = "N";
    if (vRdxDBKernObj.WMS_AUTO_BATCH?.Val == "Y") {
      xAutobatchVal = "Y";
      setxMS_AUTO_BATCH("Y");
    }

    let iAttributeResp = await GetAttributes(
      setObjectRights,
      setUser_Doc_Arr,
      setDocLoading,
      setVirtualBin,
      setUnloading,
      setCurrency,
      setPalletType,
      setTeleUser, 
      setVehicleType,
      setVehicleCapacity
    );

    let vCheckboxRightsArr = iAttributeResp?.CheckboxUserRights;
    if (vCheckboxRightsArr.length > 0) {
      SetCheckboxRights((obj) => ({
        ...obj,
        A_PutAway: vCheckboxRightsArr[0].BypassPutAway == "Y" ? false : true,
        A_AutoBatch: vCheckboxRightsArr[0].AutoBatch == "Y" ? false : true,
      }));
    }
    if (vRdxDBKernObj.WMS_AUTO_BATCH?.Val == "Y") {
      SetCheckboxRights((obj) => ({
        ...obj,
        A_AutoBatch: false,
      }));
    }
    let icurrentDocLoading = {
      VocTyp: "",
      VocName: "",
    };
    let vDocLoadingArr = iAttributeResp?.DocLoading;

    if (vDocLoadingArr.length > 0) {
      icurrentDocLoading = vDocLoadingArr[0];
    }

    let icurrentVirtualBin = {
      UId: "",
      Name1: "",
    };

    // let vVirtualBinArr = iAttributeResp?.VirtualBin;

    // if (vVirtualBinArr.length > 0) {
    //   icurrentVirtualBin = vVirtualBinArr[0];
    // }

    let icurrentUnloadingBayValue = {
      UId: "",
      Name1: "",
    };
    let vUnloadingBayArr = iAttributeResp?.UnloadingBayV2;
    if (vUnloadingBayArr.length > 0) {
      icurrentUnloadingBayValue = vUnloadingBayArr[0];
    }

    var iPalletTypeArr = {
      UId: "",
    };
    let vPalletTypeArr = iAttributeResp?.PalletType;
    if (vPalletTypeArr.length > 0) {
      iPalletTypeArr.UId = vPalletTypeArr[0]?.UId;
    }
    var iCurrencyArr = {
      Uid: "",
      Name1: "",
      Rate: 0,
    };
    let vCurrencyArr = iAttributeResp?.Currency;
    if (vCurrencyArr.length > 0) {
      setCurrency(vCurrencyArr);
      iCurrencyArr.Uid = vCurrencyArr[0]?.Uid;
      iCurrencyArr.Name1 = vCurrencyArr[0]?.Name1;
      iCurrencyArr.Rate = vCurrencyArr[0]?.Rate;
    }

    let iSalesGroupId = "";

    const vSalesGroup = await GetSalesGroups(
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? vRdxDBLocation[0].UID
        : vRdxWmsHead.A_Loc
    );

    if (vSalesGroup.length > 0) {
      iSalesGroupId = vSalesGroup[0].UId;
      setSalesGroupData(vSalesGroup);
    }

    let vDefaultTaxType = "INTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? vRdxDBLocation[0].UID
        : vRdxWmsHead.A_Loc,
      vRdxWmsHead.A_Party,
      dispatch
    );

    if (Object.keys(iDefaultTaxType).length != 0) {
      vDefaultTaxType = iDefaultTaxType?.TaxType;
    }

    // Object.keys(obj).length === 0
    let { currentPayMode, PaymodeEnable } = fDefaultPayload(
      vDocLoadingArr[0]?.Paymode,
      dispatch
    );

    setPaymodeEnable(PaymodeEnable);

    dispatch(
      Set_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocTyp
            : vRdxWmsHead.A_VocTyp,
        A_VocTypName:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocName
            : vRdxWmsHead.A_VocTypName,
        UnloadingBay:
          vRdxWmsHead.UnloadingBay == "" ||
          vRdxWmsHead.UnloadingBay === null ||
          vRdxWmsHead.UnloadingBay === undefined
            ? icurrentUnloadingBayValue.UId
            : vRdxWmsHead.UnloadingBay,
        UnloadingBayName:
          vRdxWmsHead.UnloadingBayName == "" ||
          vRdxWmsHead.UnloadingBayName === null ||
          vRdxWmsHead.UnloadingBayName === undefined
            ? icurrentUnloadingBayValue.Name1
            : vRdxWmsHead.UnloadingBayName,
        A_Curr:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? iCurrencyArr?.Uid
            : vRdxWmsHead?.A_Curr,
        A_Currname:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? iCurrencyArr?.Name1
            : vRdxWmsHead.A_Currname,
        A_ExRate:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? iCurrencyArr?.Rate
            : vRdxWmsHead.A_ExRate,

        TaxType:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? vDefaultTaxType
            : vRdxWmsHead.TaxType,
        A_Loc:
          vRdxWmsHead.A_Loc == "" ||
          vRdxWmsHead.A_Loc === null ||
          vRdxWmsHead.A_Loc === undefined
            ? vRdxDBLocation[0].UID
            : vRdxWmsHead.A_Loc,
        salesGroup:
          vRdxWmsHead.salesGroup == "" ||
          vRdxWmsHead.salesGroup === null ||
          vRdxWmsHead.salesGroup === undefined
            ? iSalesGroupId
            : vRdxWmsHead.salesGroup,
        // virtualBin:
        //   vRdxWmsHead.A_Curr == "" ||
        //   vRdxWmsHead.A_Curr === null ||
        //   vRdxWmsHead.A_Curr === undefined
        //     ? icurrentVirtualBin?.UId
        //     : vRdxWmsHead?.virtualBin,
        A_AutoBatch:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? xAutobatchVal
            : vRdxWmsHead?.A_AutoBatch,
      })
    );

    fLoad_Grid(
      vRdxWmsHead.A_VocNo, //0
      0, //srno
      vRdxWmsHead.A_Rounding,
      setDetailGridData,
      setFooterObj,
      vRdxWmsHead?.A_VocTyp == "" ||
        vRdxWmsHead.A_VocTyp === null ||
        vRdxWmsHead.A_VocTyp === undefined
        ? icurrentDocLoading.VocTyp
        : vRdxWmsHead.A_VocTyp
    );

    GetDefaultDrCrAccount(
      vRdxWmsHead.A_VocTyp == "" ||
        vRdxWmsHead.A_VocTyp === null ||
        vRdxWmsHead.A_VocTyp === undefined
        ? vDocLoadingArr[0]?.VocTyp
        : vRdxWmsHead.A_VocTyp,
      "CREDIT",
      vRdxWmsHead.A_Party, //vRdxWmsHead.A_Party on load empty
      dispatch
    );
    //on load inbound type= vendor but while refresh rdx value will not change
    fBuyer_or_SalesMan(
      vRdxWmsHead.InboundType,
      setBuyer,
      dispatch,
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? vRdxDBLocation[0]?.UID
        : vRdxWmsHead?.A_Loc,
      vRdxWmsHead.A_VocTyp == "" ||
        vRdxWmsHead.A_VocTyp === null ||
        vRdxWmsHead.A_VocTyp === undefined
        ? vDocLoadingArr[0]?.VocTyp
        : vRdxWmsHead.A_VocTyp,
      vRdxWmsHead.A_VocNo
    );
    GetDefcustomersetting(
      vRdxWmsHead.Party,
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? vRdxDBLocation[0].UID
        : vRdxWmsHead.A_Loc,
      vRdxWmsHead.InboundType,
      dispatch
    );
    let iInterCompanyDependency = {
      B_TaxPerc: vRdxGRNtax1[0].Perc,
      B_TaxPerc2: vRdxGRNtax2[0].Perc,
    };
    //if inter.comp then tax group should be 0
    if (iDefaultTaxType == "INTRN002" || iDefaultTaxType == "INTRN003") {
      InterCompanyDependency(vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val, vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val);
    }

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      0, //sBufferObj.B_Qty,
      0, //sBufferObj.B_PackQty,
      vRdxWmsHead.A_Curr == "" ||
        vRdxWmsHead.A_Curr === null ||
        vRdxWmsHead.A_Curr === undefined
        ? iCurrencyArr?.Rate
        : vRdxWmsHead.A_ExRate, //exchangeRate
      0, //sBufferObj.B_URateFc,
      0, //sBufferObj.B_LDiscPerc,
      vRdxWmsHead?.A_DiscPerc, //sBufferObj.B_TDiscPerc, // initial state A_DiscPerc 0 if refresh then current value
      "N", //sBufferObj.B_FocFlag,
      0, //sBufferObj.B_ExciseTaxAmt,
      iInterCompanyDependency.B_TaxPerc, //tax1%
      iInterCompanyDependency.B_TaxPerc2, //tax%2
      0, //sBufferObj.AddCess,
      0, //Rounding
      0 //SplDiscPer
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      B_TDiscPerc: vRdxWmsHead?.A_DiscPerc,
      SplDiscAmt,
      PalletType: iPalletTypeArr?.UId,
    }));

    if (GRNDocTyp !== "" && GrnDocNo !== "") {
      setTimeout(() => {
        fDisplay(GRNDocTyp, GrnDocNo, dispatch, fNewDetail, setBuyer);

        clearLoactionState();
      }, 100);
    } else if (RefVocNo !== "") {
      let vExactSearchValue = await ExactSearchRefNoV2(
        RefVocTyp,
        RefVocNo,
        RefNo
      );
      if (!!vExactSearchValue) {
        fReset_Linewise_Rebate(setBufferObj);
        fBuyer_or_SalesMan(
          vExactSearchValue.Source,
          setBuyer,
          dispatch,
          vRdxDBLocation[0].UID,
          icurrentDocLoading.VocTyp,
          0
        );
        GetDefaultDrCrAccount(
          icurrentDocLoading.VocTyp,
          currentPayMode,
          vExactSearchValue.Vendor,
          dispatch
        );
        GetDefcustomersetting(
          vExactSearchValue.Vendor,
          vRdxDBLocation[0].UID,
          vExactSearchValue.Source,
          dispatch
        );
        fDiscFlagDependency(vExactSearchValue.Source, dispatch);
        let vDefaultTaxType = "INTRN001";
        //
        let iDefaultTaxType = await GetTransTaxType(
          vRdxWmsHead.A_Loc == "" ||
            vRdxWmsHead.A_Loc === null ||
            vRdxWmsHead.A_Loc === undefined
            ? vRdxDBLocation[0].UID
            : vRdxWmsHead.A_Loc,
          vExactSearchValue.Vendor,
          dispatch
        );
        if (Object.keys(iDefaultTaxType).length != 0) {
          vDefaultTaxType = iDefaultTaxType?.TaxType;
        }

        //if inter.comp then tax group should be 0
        if (vDefaultTaxType == "INTRN002" || vDefaultTaxType == "INTRN003") {
          InterCompanyDependency(vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val, vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val);
        }

        dispatch(
          Set_HeadObject_TaxType({
            TaxType: vDefaultTaxType,
          })
        );
        clearLoactionState();
      }
    }
  }, [dispatch, vRdxDBLocation, vRdxGRNtax1, vRdxGRNtax2]);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsHead.A_DocStat,
      vRdxWmsHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
    console.log("resultObj", resultObj);
  }, [vRdxWmsHead.A_DocStat, vRdxWmsHead.A_VocTyp, sObjectRights]);
  useEffect(() => {
    GetReason(setReason);
  }, []);

  useEffect(() => {
    // Your code goes here
    fBuyer_or_SalesMan_Arr(
      vRdxWmsHead.InboundType,
      setBuyer,
      dispatch,
      vRdxWmsHead.A_Loc,
      vRdxWmsHead.A_VocTyp,
      vRdxWmsHead.A_VocNo
    );
  }, [
    vRdxWmsHead.InboundType,
    setBuyer,
    dispatch,
    vRdxWmsHead.A_Loc,
    vRdxWmsHead.A_VocTyp,
    vRdxWmsHead.A_VocNo,
  ]);

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      const toggleElement = event.target.closest(".toggleSearch");
      if (!toggleElement) {
        setItemToggleDropdown(false);
        setGC_Toggle_Head_Customer_ToggleDropDowm(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);
  const fkeyup = useCallback((e) => {
    if (e.key === "Enter") {
      let lastChild = document?.getElementById("Content");

      let TagArr = !!lastChild
        ? lastChild?.querySelectorAll(".lastkeyDetect")
        : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";

      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1]?.getElementsByTagName("input")[0]?.name ==
            e.target.name &&
          document?.getElementById("WMSDocStatID")?.innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: () => {
                  document.getElementById("IdSave")?.click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    onload();
  }, [onload]);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "P";
      FShortCutKey(
        e,
        "IdNew",
        "IdSave",
        "IdApprove",
        "IdSearch",
        "IdDelete",
        "IdAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );

  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);

  useEffect(() => {
    FocusOnLoad.current.focus();
  }, []);

  useEffect(() => {
    if (
      vRdxWmsHead.A_DocStat !== "ENTER" ||
      vRdxWmsHead.A_RefDocNo === "" ||
      vRdxWmsHead.A_RefDocNo === null ||
      vRdxWmsHead.A_RefDocNo === undefined ||
      sBufferObj.B_Srno === "" ||
      sBufferObj.B_Itmcd === "" ||
      sBufferObj.B_Qty === "" ||
      sBufferObj.B_Unit === ""
    ) {
      return;
    } else {
      getQtyViewDetails(
        dispatch,
        setStockObj,
        sBufferObj.B_Srno,
        sBufferObj.B_Itmcd,
        sBufferObj.B_Qty,
        sBufferObj.B_Unit
      );
    }
  }, [
    dispatch,
    sBufferObj.B_Srno,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Qty,
    sBufferObj.B_Unit,
    vRdxWmsHead.InboundType,
    vRdxWmsHead.A_RefDocNo,
    vRdxWmsHead.A_DocStat,
  ]);

  useEffect(() => {
    if (
      vRdxWmsHead.A_DocStat !== "ENTER" ||
      vRdxWmsHead.A_Loc === null ||
      vRdxWmsHead.A_Loc === undefined ||
      vRdxWmsHead.A_Loc === "" ||
      sBufferObj.B_Itmcd === "" ||
      sBufferObj.B_Unit === ""
    ) {
      setTransItemStockObj({
        RPStock: 0,
        MSP: 0,
        CostPr: 0,
        LPRate: 0,
      });
      return;
    } else {
      getTransItemStockUOM(
        setTransItemStockObj,
        sBufferObj.B_Itmcd,
        sBufferObj.B_Unit,
        vRdxWmsHead.A_Loc
      );
    }
  }, [
    dispatch,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Unit,
    vRdxWmsHead.A_Loc,
    vRdxWmsHead.A_DocStat,
  ]);

  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "B_Srno", headerName: "Sr.No", width: 50, hide: false },
    { field: "B_Itmcd", headerName: "Item.Code", width: 110, hide: false },
    { field: "ItmName", headerName: "Item.Name", width: 370, hide: false },
    { field: "B_VocTyp", headerName: "Barcode", width: 150, hide: false },
    { field: "B_Qty", headerName: "Qty", width: 80, hide: false },
    { field: "UnitName", headerName: "Unit", width: 80, hide: false },
    { field: "B_BaseQty", headerName: "BaseQty", width: 70, hide: false },
    { field: "B_URateFc", headerName: "Unit.Rate", width: 80, hide: false },
    { field: "B_TDiscAmt", headerName: "TDisc.Amt", width: 100, hide: false },
    { field: "B_LDiscAmt", headerName: "LDisc.Amt", width: 100, hide: false },
    { field: "B_FocFlag", headerName: "Foc", width: 40, hide: false },
    {
      field: "B_ExciseTaxNetAmt",
      headerName: "Excise",
      width: 100,
      hide: true,
    },
    { field: "B_NetAmt", headerName: "Net.Amt", width: 100, hide: false },
    { field: "Cost", headerName: "Cost", width: 100, hide: false },
    { field: "CostVariance", headerName: "Cost.Var", width: 100, hide: false },
    { field: "BaseRSP", headerName: "BaseRSP", width: 100, hide: false },
    { field: "GP", headerName: "GP", width: 100, hide: false },
    { field: "B_TaxPerc", headerName: "Tax.Perc", width: 100, hide: true },
    { field: "B_TaxAmt", headerName: "Tax.Amt", width: 100, hide: true },
    { field: "B_TaxPerc2", headerName: "Tax.Perc2", width: 100, hide: true },
    { field: "B_TaxAmt2", headerName: "Tax.Amt2", width: 100, hide: true },
    {
      field: "B_ExciseTaxPerc",
      headerName: "Excise.Tax.Perc",
      width: 100,
      hide: true,
    },
    {
      field: "B_ExciseTaxAmt",
      headerName: "Excise.Tax.Amt",
      width: 100,
      hide: true,
    },
    { field: "B_TaxDept", headerName: "Tax.Dept", width: 100, hide: true },
    { field: "SplDiscAmt1", headerName: "Spl.Disc", width: 100, hide: true },
    { field: "B_TDiscPerc", headerName: "TDisc.Perc", width: 100, hide: true },
    { field: "B_TaxDept2", headerName: "Tax.Dept2", width: 100, hide: true },
    { field: "AddCess", headerName: "AddCess", width: 100, hide: true },
    {
      field: "B_NetAddCess",
      headerName: "NetAddCess",
      width: 100,
      hide: true,
    },
    { field: "B_FocFlag", headerName: "Foc.Amt", width: 100, hide: true },
    { field: "RebateType", headerName: "Type", width: 100, hide: false },
    { field: "ReduceCost", headerName: "ReduceCost", width: 100, hide: false },
    { field: "SplDiscPerc", headerName: "Disc %", width: 100, hide: false },
    { field: "B_IncGroup", headerName: "B_IncGroup", width: 100, hide: true },
    { field: "B_SuprvPerc", headerName: "B_SuprvPerc", width: 100, hide: true },
    {
      field: "B_OthersPerc",
      headerName: "B_OthersPerc",
      width: 100,
      hide: true,
    },
    { field: "B_SLANSuprv", headerName: "B_SLANSuprv", width: 100, hide: true },
    {
      field: "B_SlabAmtSuprv",
      headerName: "B_SlabAmtSuprv",
      width: 100,
      hide: true,
    },
    { field: "B_SLANOther", headerName: "B_SLANOther", width: 100, hide: true },
    {
      field: "B_SlabAmtOther",
      headerName: "B_SlabAmtOther",
      width: 100,
      hide: true,
    },
    {
      field: "B_Ad_CessAmt",
      headerName: "B_Ad_CessAmt",
      width: 100,
      hide: true,
    },
    { field: "B_URateLc", headerName: "URateLc", width: 100, hide: true },
    { field: "B_RefDocTyp", headerName: "RefDocTyp", width: 100, hide: true },
    { field: "RefVocName", headerName: "RefVocName", width: 100, hide: true },
    { field: "B_RefDocNo", headerName: "RefDocNo", width: 100, hide: true },
    { field: "SuppRefNo1", headerName: "RefNo", width: 100, hide: true },
    { field: "SplDiscAmt", headerName: "Disc Amt", width: 100, hide: true },
    { field: "B_Reason", headerName: "Reason", width: 150, hide: true },
    { field: "B_ReasonName", headerName: "Reason", width: 150, hide: false },
    { field: "B_Unit", headerName: "Unit", width: 100, hide: true },
    { field: "B_GrossAmt", headerName: "Gross.Amt", width: 100, hide: true },
    { field: "B_LDiscPerc", headerName: "LDisc.%", width: 100, hide: true },
    { field: "B_FocAmt", headerName: "Foc.Amt", width: 100, hide: true },
  ]);
  //GCSearch
  const [GridDataColumnsSearch, setGridDataColumnsSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "VocName", headerName: "Doc.Name", width: 250 },
    { field: "A_VocNo", headerName: "Doc.No", width: 150 },
    {
      field: "A_PostDt",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "A_RefNo", headerName: "Ref.No", width: 90 },
    { field: "PartyName", headerName: "Vendor", width: 250 },
    { field: "LocName", headerName: "Location", width: 130 },
    { field: "NetAmt", headerName: "NetAmt", width: 90 },
    { field: "SalesGroup", headerName: "Sales Group", width: 130 },
    { field: "A_DocStat", headerName: "A_DocStat", width: 90, hide: true },
    { field: "A_VocTyp", headerName: "A_VocTyp", width: 90, hide: true },
  ]);
  const [GridDataAuditColumns, setGridDataAuditColumns] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    {
      field: "User",
      headerName: "User Name",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Date",
      headerName: "Date",
      width: 100,
      headerClassName: "grid-header-row",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Time",
      headerName: "Time",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "IP Address",
      headerName: "IP Address",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Old Value",
      headerName: "Old Value",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "New Value",
      headerName: "New Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 250,
      headerClassName: "grid-header-row",
    },
  ]);
  const [GridDataColumnsRefDocSearch, setGridDataColumnsRefDocSearch] =
    useState([
      { field: "id", headerName: "id", hide: true },
      { field: "VocNo", headerName: "Doc.No", width: 110 },
      { field: "PartyName", headerName: "Party Name", width: 350 },
      { field: "Source", headerName: "Source", width: 110 },
      { field: "PDTUserName", headerName: "PDT User", width: 110 },
      { field: "LDPayName", headerName: "Bay", width: 110 },
      { field: "ExpcTimeStart", headerName: "Starting Time", width: 180 },
      {
        field: "GRNDate",
        type: "date",
        headerName: "GRNDate",
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
        width: 180,
      },
      { field: "GrnDocTyp", headerName: "GrnDocTyp", width: 90 },
      { field: "GrnDocNo", headerName: "GrnDocNo", width: 110 },
      { field: "RefNo", headerName: "Ref.No", width: 70 },
      {
        field: "RefDate",
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
        headerName: "Ref.Date",
        width: 180,
      },
    ]);
  const [GridDataColumnsItemSearch, setGridDataColumnsItemSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "ItmCd", width: 90 },
    { field: "Name1", headerName: "Name1", width: 450 },
    { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
    { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
    { field: "Model", headerName: "Model", width: 90 },
    { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
    { field: "BarCode", headerName: "BarCode", width: 90 },
    { field: "NameFL", headerName: "NameFL", width: 90 },
  ]);
  const [GridDataColumnsSalesGroupModal, setGridDataColumnsSalesGroupModal] =
    useState([
      { field: "id", headerName: "id", hide: true },
      { field: "UId", headerName: "Code" },
      { field: "Srno", headerName: "SrNo", width: 90 },
      { field: "EMPID", headerName: "Employee ID", width: 120 },
      { field: "EMPNAME", headerName: "Employee Name", width: 350 },
      { field: "Typ", headerName: "Type", width: 100 },
      { field: "Active", headerName: "Active", width: 100 },
    ]);
  const [GridDataColumnsEmployeeModal, setGridDataColumnsEmployeeModal] =
    useState([
      { field: "id", headerName: "id", hide: true },
      { field: "SrNo", headerName: "SrNo", width: 50 },
      { field: "EMPID", headerName: "Employee ID", width: 120 },
      { field: "SName", headerName: "Name", width: 300 },
      { field: "FName", headerName: "First Name", width: 150, hide: true },
      { field: "LName", headerName: "Last Name", width: 180, hide: true },
      { field: "MName", headerName: "Middle Name", width: 100, hide: true },
      { field: "InActive", headerName: "InActive", width: 60 },
      { field: "JOBTITLE", headerName: "Job Title", width: 80 },
      { field: "Gender", headerName: "Gender", width: 60 },
      {
        field: "DOB",
        headerName: "DOB",
        width: 100,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      { field: "Country", headerName: "Country", width: 120 },
      { field: "Maritial", headerName: "Maritial", width: 60 },
      { field: "Mobile", headerName: "Mobile", width: 120 },
      { field: "Dept", headerName: "Dept", width: 50 },
      { field: "Br", headerName: "Br", width: 50 },
      { field: "Loc", headerName: "Loc", width: 50 },
      {
        field: "EmployementDt",
        headerName: "EmployementDt",
        width: 180,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      {
        field: "DOJ",
        headerName: "DOJ",
        width: 190,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      { field: "Phone", headerName: "Phone", width: 90 },
      { field: "EMail", headerName: "EMail", width: 150 },
      { field: "CompEMail", headerName: "CompEMail", width: 90 },
      { field: "CompPhone", headerName: "CompPhone", width: 90 },
      { field: "CompExt", headerName: "CompExt", width: 90 },
      { field: "CompMobile", headerName: "CompMobile", width: 120 },
      {
        field: "TerminationDt",
        headerName: "TerminationDt",
        width: 90,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
    ]);
  const [GridDataColumnsBatch, setGridDataColumnsBatch] = useState([
    { field: "id", headerName: "id", hide: true },
    { field: "C_VocTyp", headerName: "VocTyp", hide: true },
    { field: "C_VocNo", headerName: "VocNo", hide: true },
    { field: "C_RowId", headerName: "SrNo" },
    { field: "C_SrNo", headerName: "SrNoHead", hide: true },
    { field: "C_ItmCd", headerName: "Item Code", width: 90, hide: true },
    { field: "ItemName", headerName: "Item Name", width: 250, hide: true },
    { field: "C_BatchNo", headerName: "Batch No" },
    { field: "C_BatchDt", headerName: "Batch Date" },
    { field: "C_ExpDt", headerName: "Exp Date" },
    { field: "C_Qty", headerName: "Qty" },
    { field: "C_Unit", headerName: "Unit", hide: true },
    { field: "C_BaseQty", headerName: "BaseQty" },
    { field: "UnitName", headerName: "Unit" },
    { field: "C_Narr", headerName: "C_Narr", hide: true },
    { field: "C_PTyp1", headerName: "C_PTyp1", hide: true },
    { field: "C_PTyp2", headerName: "C_PTyp2", hide: true },
    { field: "C_PTyp3", headerName: "C_PTyp3", hide: true },
    { field: "C_PTyp4", headerName: "C_PTyp4", hide: true },
    { field: "C_PTyp5", headerName: "C_PTyp5", hide: true },
    { field: "C_PTyp1", headerName: "C_PTyp1", hide: true },
    { field: "C_PTyp6", headerName: "C_PTyp6", hide: true },
  ]);

  //GCcustomer
  const [
    xGC_Toggle_Head_Customer_GridColumns,
    setxGC_Toggle_Head_Customer_GridColumns,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 90 },
    { field: "Name2", headerName: "Name2", width: 450 },
    { field: "Name1", headerName: "Name1", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);

  const [
    xGCSearchBtn_Columns_DropdownSearch,
    setxGCSearchBtn_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name2", headerName: "Name2", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);
  const [
    xLoaded_Cost_Freight_Columns_DropdownSearch,
    setxLoaded_Cost_Freight_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name1", headerName: "Name", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);
  const [
    xLoaded_Cost_Customs_Columns_DropdownSearch,
    setxLoaded_Cost_Customs_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name1", headerName: "Name", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);
  const [
    xLoaded_Cost_Discount_Columns_DropdownSearch,
    setxLoaded_Cost_Discount_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name1", headerName: "Name", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);
  const [
    xLoaded_Cost_SplDiscount_Columns_DropdownSearch,
    setxLoaded_Cost_SplDiscount_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name1", headerName: "Name", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);
  useEffect(() => {
    GetGitterColumns(
      setGridDataColumnsWmsSiDetail,
      "INBOUND_GRN_OUTLET",
      GridDataColumnsWmsSiDetail
    );
    // GetGitterColumns(
    //   setGridDataColumnsSearch,
    //   "INBOUND_GRN_SEARCH",
    //   GridDataColumnsSearch
    // );
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      GridDataAuditColumns
    );
    GetGitterColumns(
      setGridDataColumnsRefDocSearch,
      "INBOUND_GRN_REF_DOC",
      GridDataColumnsRefDocSearch
    );
    GetGitterColumns(
      setGridDataColumnsItemSearch,
      "INBOUND_GRN_ITEM_SEARCH",
      GridDataColumnsItemSearch
    );
    GetGitterColumns(
      setGridDataColumnsSalesGroupModal,
      "INBOUND_GRN_SALES_GRP",
      GridDataColumnsSalesGroupModal
    );
    GetGitterColumns(
      setGridDataColumnsEmployeeModal,
      "INBOUND_GRN_SALES_GRP_EMP",
      GridDataColumnsEmployeeModal
    );
    GetGitterColumns(
      setGridDataColumnsBatch,
      "INBOUND_GRN_BATCH",
      GridDataColumnsBatch
    );
    GetGitterColumns(
      setxGC_Toggle_Head_Customer_GridColumns,
      "INBOUND_GRN_CUST",
      xGC_Toggle_Head_Customer_GridColumns
    );
    GetGitterColumns(
      setxGCSearchBtn_Columns_DropdownSearch,
      "INBOUND_GRN_GCSearchBtn",
      xGCSearchBtn_Columns_DropdownSearch
    );
    GetGitterColumns(
      setxLoaded_Cost_Freight_Columns_DropdownSearch,
      "INBOUND_GRN_Freight",
      xLoaded_Cost_Freight_Columns_DropdownSearch
    );
    GetGitterColumns(
      setxLoaded_Cost_Customs_Columns_DropdownSearch,
      "INBOUND_GRN_Customs",
      xLoaded_Cost_Customs_Columns_DropdownSearch
    );
    GetGitterColumns(
      setxLoaded_Cost_Discount_Columns_DropdownSearch,
      "INBOUND_GRN_Discount",
      xLoaded_Cost_Discount_Columns_DropdownSearch
    );
    GetGitterColumns(
      setxLoaded_Cost_SplDiscount_Columns_DropdownSearch,
      "INBOUND_GRN_SplDiscount",
      xLoaded_Cost_SplDiscount_Columns_DropdownSearch
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataMSPUpdateColumns,
      "GRNITEMSMSP001",
      sGridDataMSPUpdateColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container-fluid">
       {/* mobile Screen nav  */}
            <GCNAV
              fNew={fNew}
              xDisableNew={sObjRights.RNew == "N"}
              fSave={fSave}
              xDisableSave={sObjRights.RSave == "N"}
              sRightClick={sRigntClick}
              xRightClick={(e) => {
                fLeftClick(e);
                setShowMore(false);
                setRigntClick(false);
                setTimeout(() => {
                  document.getElementsByName("A_PostDt")[0]?.focus();
                }, 100);
              }}
              xLeftClick={(e) => {
                fRightClick(e);
                setShowMore(false);
                setRigntClick(true);
                setTimeout(() => {
                  document.getElementsByName("B_ItmName")[0]?.focus();
                }, 100);
              }}
              setShowMore={setShowMore}
              sShowMore={sShowMore}
              fDelete={fDelete}
              xDisableDelete={
                vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
                  ? false
                  : sObjRights.RDelete == "N"
                  ? true
                  : false
              }
              isBtnDraft={sObjRights.RApprove == "N" && false}
              fDraft={() => {
                fApprove("DRAFT");
              }}
              xDisableDraft={
                vRdxWmsHead.A_DocStat != "ENTER" ? true : false
              }
              fApprove={() => {
                fApprove("POST");
              }}
              xDisableApprove={
                vRdxWmsHead.A_DocStat == "ENTER" ||
                        vRdxWmsHead.A_DocStat == "DRAFT"
                          ? sObjRights.RApprove == "N"
                          : true
              }
              fView={() => {
                fView();
              }}
              fSummary={() => {
                fSummary();
              }}
              fSearch={() => {
                fSearch();
              }}
              GCMenuBtn={ 
              <GCMenuBtn
                //  xvariant="outlined"
                menuLabel={<PendingIcon fontSize={"small"} />}
                menuItems={[
                  // { label: "Account Detail", onClick: fAccountDetail },
                  // { label: "Item MSP", onClick: fMSPUpdate },
                  { label: "Pending Po", onClick: fPendingPo },
                  { label: "Pallet", onClick: fPallet },
                  { label: "Receiving Post", onClick: ReceivingPost },
                  // { label: "Link Document", onClick: fLinkDocument },
                  {
                    label: "Update Current RSP",
                    onClick: fUpdateCurrentRSP,
                  },
                  { label: "Reference Update", onClick: fRefUpdate },
                  { label: "List All Item", onClick: fListAllItem },
                  { label: "Add", onClick: fTaxAdd },
                  { label: "Remove", onClick: fTaxRemove },
                  { label: "TaxConvertUpdate", onClick: fTaxConvertUpdate },
                  { label: "Load Po", onClick: floadFromPo },
                ]}
              />}
            />
              <div style={{ paddingTop: vMediaQuery ? "50px" : "" }}>
              <div className="row" style={{ padding: "0px" }}>
              <div className="col-12" style={{ padding: "0px" }}>
          <></>
          <div className="Wms-inbound-grn">
            <Grid
              container
              spacing={0}
              className="my-2 Wms-inbound-grn-nav-sm-hide"
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: "center" }}
            >
              <Grid item xs={1} sm={2} md={1} lg={1}>
                <CmpButton
                  xbtnName="New"
                  xOnClick={(e) => fNew(0)}
                  xVariant="text"
                  xDisabled={sObjRights.RNew == "N"}
                  xSize="small"
                  xId={"IdNew"}
                  xSendIcon={<AddBoxRoundedIcon />}
                />
              </Grid>
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Save"
                  xOnClick={fSave}
                  xVariant="text"
                  xDisabled={sObjRights.RSave == "N"}
                  xSize="small"
                  xId={"IdSave"}
                  xSendIcon={<SaveRoundedIcon />}
                />
              </Grid>
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                {sObjRights.RApprove == "N" && false ? (
                  <CmpButton
                    xbtnName="Draft"
                    xOnClick={() => {
                      fApprove("DRAFT");
                    }}
                    xVariant="text"
                    // xDisabled={sObjRights.RApprove == "N" ? true : false}
                    xDisabled={vRdxWmsHead.A_DocStat != "ENTER" ? true : false}
                    xSize="small"
                    xId={sObjRights.RApprove == "N" ? "IdApprove" : ""}
                    xSendIcon={<CheckCircleOutlineRoundedIcon />}
                  />
                ) : (
                  <CmpButton
                    xbtnName="Approve"
                    xOnClick={() => {
                      fApprove("POST");
                    }}
                    xVariant="text"
                    // xDisabled={sObjRights.RApprove == "N" ? true : false}
                    xDisabled={
                      vRdxWmsHead.A_DocStat == "ENTER" ||
                      vRdxWmsHead.A_DocStat == "DRAFT"
                        ? sObjRights.RApprove == "N"
                        : true
                    }
                    xSize="small"
                    xId={sObjRights.RApprove == "Y" ? "IdApprove" : ""}
                    xSendIcon={<CheckCircleOutlineRoundedIcon />}
                  />
                )}
              </Grid>
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Search"
                  xOnClick={() => {
                    fSearch();
                  }}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xId={"IdSearch"}
                  xSendIcon={<SearchRoundedIcon />}
                />
              </Grid>
              <Grid item xs={1} sm={2.5} md={1} lg={1}>
                <CmpButton
                  xbtnName="Delete"
                  xOnClick={()=>{
                    fDelete()
                  }}
                  xVariant="text"
                  xDisabled={
                    vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
                      ? false
                      : sObjRights.RDelete == "N"
                      ? true
                      : false
                  }
                  xSize="small"
                  xId="IdDelete"
                  xSendIcon={<DeleteRoundedIcon />}
                />
              </Grid>
              <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                <CmpButtonKIcon
                  xOnClick={fMove_First}
                  xDisabled={false}
                  xIcon={<FirstPageIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid
                item
                xs={1}
                sm={2}
                md={0.5}
                lg={0.5}
                className="text-center"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Previouse}
                  xDisabled={false}
                  xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                {sNavDocValue} of {sUser_Doc_Arr.length}
              </Grid>
              <Grid
                item
                xs={1}
                sm={2}
                md={0.5}
                lg={0.5}
                className="text-center"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Next}
                  xDisabled={false}
                  xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid
                item
                xs={1}
                sm={2}
                md={0.5}
                lg={0.5}
                className="text-center"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Last}
                  xDisabled={false}
                  xIcon={<LastPageIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid item xs={1} sm={2} md={1} lg={1}>
                <DropdownButton
                  id="dropdown-basic-button"
                  title="Print"
                  variant="outlined"
                  size="sm"
                  disabled={sObjRights.RPrint == "N" ? true : false}
                >
                  <Dropdown.Item
                    id="PrintId"
                    onClick={(e) => {
                      fPrint("IBO");
                    }}
                  >
                    Venodr copy
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("NR");
                    }}
                  >
                    Reason
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("G");
                    }}
                  >
                    Cooperate copy
                  </Dropdown.Item>
                  {/* <Dropdown.Item
                    onClick={(e) => {
                      fPrint("A");
                    }}
                  >
                    Document
                  </Dropdown.Item> */}

                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("A");
                    }}
                  >
                    Vendor copy alias
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("PC");
                    }}
                  >
                    {" "}
                    Price change
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("S");
                    }}
                  >
                    SPLDiscount
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={(e) => {
                      fPrint("V");
                    }}
                  >
                    Trsanfer vs receipt
                  </Dropdown.Item>
                </DropdownButton>
              </Grid>
              <Grid item xs={1} sm={2} md={1} lg={1}>
                <CmpButton
                  xbtnName="Audit"
                  xOnClick={fAudit}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xId="IdAudit"
                  xSendIcon={<SendIcon />}
                />
              </Grid>
              {/* <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <CmpButton
                  xbtnName="Account Detail"
                  xOnClick={fAccountDetail}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<AccountBalanceOutlinedIcon />}
                />
              </Grid> */}

              <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <GCMenuBtn
                  menuLabel="More"
                  menuItems={[
                    { label: "Account Detail", onClick: fAccountDetail },
                    // { label: "Item MSP", onClick: fMSPUpdate },
                    // { label: "Pending Po", onClick: fPendingPo },
                    { label: "Pallet", onClick: fPallet },
                    { label: "Receiving Post", onClick: ReceivingPost },
                    // { label: "Link Document", onClick: fLinkDocument },
                    { label: "Update Current RSP", onClick: fUpdateCurrentRSP },
                    { label: "Reference Update", onClick: fRefUpdate },
                    { label: "List All Item", onClick: fListAllItem },
                    { label: "Add", onClick: fTaxAdd },
                    { label: "Remove", onClick: fTaxRemove },
                    { label: "TaxConvertUpdate", onClick: fTaxConvertUpdate },
                    // { label: "Load Po", onClick: floadFromPo },
                    { label: "DMS", onClick: fDMS },
                  ]}
                />
              </Grid>
            </Grid>
           
            <>
              <div id="wms-salese-invoice-id">
                <div className=" wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                  <GCHead
                    fonChangeInputHead={(event) => {
                      dispatch(
                        Set_HeadObject_Set({
                          ...vRdxWmsHead,
                          [event.target.name]: event.target.value,
                        })
                      );
                    }}
                    sVehicleCapacity={sVehicleCapacity}
                    sVehicleType={sVehicleType}
                    sTeleUser={sTeleUser}
                    fTeleUser={(e) => {
                      dispatch(
                        Set_HeadObject_Set({
                          ...vRdxWmsHead,
                          TeleUser: e.target.value,
                        })
                      );
                    }}
                    sTransItemStockObj={sTransItemStockObj}
                    xTransItemStockShow={
                      vRdxuserInfo?.UserRights?.ViewCost?.toUpperCase() == "Y"
                    }
                    sVirtualBin={sVirtualBin}
                    xCheckboxRights={sCheckboxRights}
                    xDisableBasedOnGridDataLength={sDetailGridData.length > 0}
                    xPaymodeEnable={sPaymodeEnable}
                    xErrorMsg={sErrorMsg}
                    vRdxuserLoc={vRdxDBLocation}
                    xKey={fKey}
                    vRdxWmsHead={vRdxWmsHead}
                    sArr={sArr}
                    fonSelectedGrnType={fGrnType}
                    sDocLoadingGrnType={sDocLoading}
                    sFrom={sFrom}
                    sPaymode={sPaymode}
                    sUnloading={sUnloading}
                    sCurrency={sCurrency}
                    sTax={sTax}
                    fGrnDate={fGrnDate}
                    fInvNo={fInvNo}
                    fInvDate={fInvDate}
                    fForm={fForm}
                    fPaymode={fPaymode}
                    fSelectedUnloading={fUnloading}
                    fInvAmt={fInvAmt}
                    fSelectedCurrency={fCurrency}
                    fvirtualBin={fvirtualBin}
                    fTax={fTax}
                    fAutoBatch={fAutoBatch}
                    fSourceDocNo={fSourceDocNo}
                    fOpenHeadCustomerSearchModalKey={fRefDocSearchModalKey}
                    fLocation={fLocation}
                    xFocusInput={fFocusInput}
                    //customer

                    xGC_Toggle_Head_Customer_DropDown_Arr={
                      xGC_Toggle_Head_Customer_DropDown_Arr
                    } //sub input arr
                    xfGC_Toggle_Head_Customer_Name={
                      xfGC_Toggle_Head_Customer_Name
                    } //onchange main input
                    xGC_Toggle_Head_Customer_Toggle={
                      sGC_Toggle_Head_Customer_ToggleDropDowm
                    } //boolean true  false
                    xGC_Toggle_Head_Customer_onKeyUp={
                      fGC_Toggle_Head_Customer_onKeyUp
                    } //main input enter
                    xGC_Toggle_Head_Customer_SearchDropdownObj={
                      sGC_Toggle_Head_Customer_SearchDropdownObj
                    } //sub input obj
                    xGC_Toggle_Head_Customer_Dropdown_onChange={
                      fGC_Toggle_Head_Customer_Dropdown_onChange
                    } //sub input onchange
                    xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load={
                      fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
                    } //sub input load
                    xGC_Toggle_Head_Customer_GridColumns={
                      xGC_Toggle_Head_Customer_GridColumns
                    } //sub input col
                    xGC_Toggle_Head_Customer_GridData={
                      sGC_Toggle_Head_Customer_GridData
                    } //sub input grid
                    xfGC_Toggle_Head_Customer_OnCellKeyDown={
                      fGC_Toggle_Head_Customer_OnCellKeyDown
                    } //sub input row enter
                    xfGC_Toggle_Head_Customer_OnRowClick={
                      fGC_Toggle_Head_Customer_OnRowClick
                    } //sub input row click
                    //customer ed

                    inputFocus={FocusOnLoad}
                  />
                </div>
                <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                  <div className="wms-incoice-sales-m">
                    <GCContent
                      ReceivingPost={ReceivingPost}
                      sPalletType={sPalletType}
                      fPalletType={fPalletType}
                      sReason={sReason}
                      Reason={Reason}
                      fonChangeInputLDiscAmt={fonChangeInputLDiscAmt}
                      fGrossAmt={fGrossAmt}
                      xStockObj={sStockObj}
                      xContent_Focus={fContent_Focus}
                      xContent_Blur={fContent_Blur}
                      xErrorMsgDetail={sErrorMsgDetail}
                      vRdxWmsHead={vRdxWmsHead}
             
                      xsIncentiveGroupsData={sIncentiveGroups}
                      OtherSlabs={sOtherSlabs}
                      xSupervisorSlab={sSupervisorSlabs}
                      fOnChangeSelectSupervisorSlab={fSupervisorSlab}
                      fonChangeInputOtherAmtSc={fonChangeInputOtherAmtSc}
                      fOnChangeSelectOtherSlab={fOnChangeSelectOtherSlab}
                      fOnChangeSelectIncGroup={fIncGroup}
                      xKey={fKeyContent}
                      xFocusInput={fFocusInput}
                      xBufferObj={sBufferObj}
                      sUnit={sUnit}
                      sFocFlagArr={sFocFlagArr}
                      sTypeArr={TypeArr}
                      vRdxGRNtax1={vRdxGRNtax1}
                      vRdxGRNtax2={vRdxGRNtax2}
                      fUnit={fUnit}
                      fUnitRate={fUnitRate}
                      fUnitRateSave_onKeyUp={fUnitRateSave_onKeyUp}
                      fFoc={fFoc}
                      fFocFlag={fFocFlag}
                      fExcise={fExcise}
                      fNetExcise={fNetExcise}
                      fTaxGroup={fTaxGroup}
                      fCessGroup={fCessGroup}
                      fType={fType}
                      fReduceCost={fReduceCost}
                      fNarration={fNarration}
                      fNetAmt={fNetAmt}
                      fDiscPer={fDiscPer}
                      fDiscAmt={fDiscAmt}
                      fLDiscPer={fLDiscPer}
                      fOpenContentItemSearchModalKey={fItemSearchKey}
                      fQty={fQty}
                      fB_CI={fB_CI}
                      //GC toggle
                      fItemName={fItemName} //onchange main input
                      xMediaQuery={vMediaQuery} //mobile screen
                      xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                      xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                      xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                      xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                      xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                      xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                      xData={ItemSearchData} // GCToggleSearch-select-tag arr
                      xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                      xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                      xOnKeyUpDropdownInput={fOnKeyUpItem} //GCToggleSearch-
                    />
                    {/* {vMediaQuery && (
                      <InboundDetailTblCard
                        data={sDetailGridData}
                        onClick={fDetail_Grid_onRowClick}
                      />
                    )} */}
                    {vMediaQuery && (
                      <DetailTblCard
                        data={sDetailGridData}
                        onClick={fDetail_Grid_onRowClick}
                        onDoubleClick={fDetail_Grid_DoubleClick}
                        fDelete={fDelete}
                           
                 xDisableDelete={
                  vRdxWmsHead.A_DocStat == "ENTER"  
                  ? false
                  : sObjRights.RDelete == "N"
                  ? true
                  : false
                }
                      />
                    )}
                  </div>
                  <div className="wms-sales-content-grid xs-screen-hide">
                    <div style={{ height: "35vh", width: "100%" }}>
                      <DataGrid
                        rowHeight={25}
                        headerHeight={25}
                        getRowClassName={(params) => {

                          const { B_FocFlag, B_BaseQty, BatchQty } = params.row;
                          const isFoc = B_FocFlag?.trim() === "Y";
                          const isEven = params.indexRelativeToCurrentPage % 2 === 0;
                          const isMismatch = B_BaseQty != BatchQty;
                        
                          let baseClass = "";
                        
                          if (isFoc) {
                            baseClass = "mui-high-light-row";
                          } 
                          else {
                            baseClass = isEven ? "mui-even-row" : "mui-odd-row";
                          }
                        
                          return isMismatch ? `${baseClass} mui-forecolor-row` : baseClass;
                        }}
                        sx={{
                          border: 1,
                          borderColor: "primary.light",
                          "& .MuiDataGrid-toolbarContainer": {
                            minHeight: "25px", // Adjust height as needed
                            maxHeight: "25px",
                            padding: "1px", // Adjust padding if needed
                          },
                        }}
                        rows={sDetailGridData}
                        columns={GridDataColumnsWmsSiDetail}
                        onRowClick={fDetail_Grid_onRowClick}
                        onRowDoubleClick={fDetail_Grid_DoubleClick}
                        hideFooter={sDetailGridData.length < 100}
                        // components={{
                        //   Toolbar: GridToolbar,
                        // }}
                      />
                    </div>
                  </div>
                </div>
                <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                  <Footer
                    xErrorMsg={sErrorMsg}
                    xFooterObj={sFooterObj}
                    fFocusRounding={fFooter_Rounding_Focus}
                    fBlurRounding={fFooter_Rounding_Blur}
                    fOpenDiscountPercentageModal={fOpenDiscountPercentageModal}
                    xBuyer={sBuyer}
                    xKey={fKey}
                    vRdxWmsHead={vRdxWmsHead}
                    sArr={sArr}
                    fBuyer={fBuyer}
                    fHeadNarration={fHeadNarration}
                    fRounding={fRounding}
                    fDiscFlag={fDiscFlag} 
                    xfSalesGroup={fSalesGroup}
                    xSalesGroupData={sSalesGroupData}
                    xfOpenSalesGroupModal={fOpenSalesGroupModal}
                    fFreight={fFreight}
                    fCustomer={fCustomer}
                    fLoadedCost={fLoadedCost}
                    fFreight_xonFocus={fFreight_onFocus}
                    fFreight_xonBlur={fFreight_onBlur}
                    fCustomer_xonFocus={fCustomer_onFocus}
                    fCustomer_xonBlur={fCustomer_onBlur}
                    sDetailGridData={sDetailGridData}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
              </div>
             
      {/* modal */}
      {/* simple search ref doc  */}
      <GCSimpleSearch
        open={sRefDocSearchModal}
        xCloseSearchModal={(e) => {
          fCloseRefDocSearchModal(
            setRefDocSearchModal,
            fRefDocClearSimpleSearch,
            setRefDocModalArr,
            setRefDocModelObj
          );
        }}
        xTitle={"RefDocInbound"}
        xAnyData={vRdxWmsHead.A_PartyName}
        xModelObj={sRefDocModelObj}
        xSearchEnter={fRefDocSearchEnter}
        xonChangeInputModal={fonChangeRefDocModal}
        xGridArr={sRefInboundGridData}
        xGridDataColumnsSearch={GridDataColumnsRefDocSearch}
        xRowClick={(e) => {
          fRefDocRowClick(
            e,
            dispatch,
            vRdxWmsHead,
            setRefDocSearchModal,
            fRefDocClearSimpleSearch,
            setRefDocModalArr,
            setRefDocModelObj,
            setBufferObj,
            setBuyer
          );
        }}
        xClearSimpleSearch={fRefDocClearSimpleSearch}
        xMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
      />
      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"View"} onClose={fCloseViewModal} />

          <div className="py-3">
            <div style={{ height: "70vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) => {

                  const { B_FocFlag, B_BaseQty, BatchQty } = params.row;
                  const isFoc = B_FocFlag?.trim() === "Y";
                  const isEven = params.indexRelativeToCurrentPage % 2 === 0;
                  const isMismatch = B_BaseQty != BatchQty;
                
                  let baseClass = "";
                
                  if (isFoc) {
                    baseClass = "mui-high-light-row";
                  } 
                  else {
                    baseClass = isEven ? "mui-even-row" : "mui-odd-row";
                  }
                
                  return isMismatch ? `${baseClass} mui-forecolor-row` : baseClass;
                }}
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetailGridData}
                columns={GridDataColumnsWmsSiDetail}
                onRowClick={fDetail_Grid_onRowClick}
                onRowDoubleClick={fDetail_Grid_DoubleClick}
                hideFooter={sDetailGridData.length < 100}
                // components={{
                //   Toolbar: GridToolbar,
                // }}
              />
            </div>
          </div>
        </Box>
      </Modal>
      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary"} onClose={fCloseSummaryModal} />
          {/* <div className="d-flex justify-content-end close-icon-sm">
            <CloseIcon onClick={fCloseSummaryModal} />
          </div> */}
          <div className="py-3">
            <Footer
              xErrorMsg={sErrorMsg}
              xFooterObj={sFooterObj}
              fFocusRounding={fFooter_Rounding_Focus}
              fBlurRounding={fFooter_Rounding_Blur}
              fOpenDiscountPercentageModal={fOpenDiscountPercentageModal}
              xBuyer={sBuyer}
              xKey={fKey}
              vRdxWmsHead={vRdxWmsHead}
              sArr={sArr}
              fBuyer={fBuyer}
              fHeadNarration={fHeadNarration}
              fRounding={fRounding}
              fDiscFlag={fDiscFlag} 
              xfSalesGroup={fSalesGroup}
              xSalesGroupData={sSalesGroupData}
              xfOpenSalesGroupModal={fOpenSalesGroupModal}
              fFreight={fFreight}
              fCustomer={fCustomer}
              fLoadedCost={fLoadedCost}
              fFreight_xonFocus={fFreight_onFocus}
              fFreight_xonBlur={fFreight_onBlur}
              fCustomer_xonFocus={fCustomer_onFocus}
              fCustomer_xonBlur={fCustomer_onBlur}
              sDetailGridData={sDetailGridData}
            />
          </div>
        </Box>
      </Modal>
      {/* Reverse Modal */}
      <GCReverse
        open={sReverseTransactionModal}
        fCloseReverseTransactionModal={(e) => {
          fCloseReverseTransactionModal(setReverseTransactionModal);
        }}
        sRevNarr={sRevNarr}
        setRevNarr={setRevNarr}
        fReverse={(e) => {
          fReverse(fSave, setRevNarr, setReverseTransactionModal);
        }}
      />
      {/* Search  */}
      <GCSearchBtn
        open={sSearchModal}
        xStatusArr={sStatusArr}
        xLocationArr={sSearchLoactionArr}
        // xSupplierArr={sTransParty}
        xSalesGroup={sGCSeachSalesGroupSearch}
        // xSearchModalObj={sSearchModalObj}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangePartyModal={fonChangePartyModal}
        fonChangeLocModal={fonChangeLocModal}
        fonChangeRefNoModal={fonChangeRefNoModal}
        fonChangeSalesGroupModal={fonChangeSalesGroupModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={GridDataColumnsSearch}
        xOnCellKeyDownSearch={fTrans_Search_Grid_KeyDown}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"Inbound Outlet - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
        xRefNoVal={sSearchModalObj.RefNo}
        xSalesGroupVal={sSearchModalObj.SalesGroup}
        xPartyVal={sSearchModalObj.Party}
        xPartyNameVal={sSearchModalObj.PartyName}
        //new Search lookUp
        xfGCSearchBtn_Name={xfGCSearchBtn_Name}
        xGCSearchBtn_Toggle={sGCSearchBtn_Toggle_ToggleDropDowm}
        xGCSearchBtn_onKeyUp={fGCSearchBtn_onKeyUp_onKeyUp}
        xGCSearchBtn_SearchDropdownObj={
          sGCSearchBtn_SearchDropdownObj_SearchDropdownObj
        }
        xGCSearchBtn_Dropdown_onChange={xGCSearchBtn_Dropdown_onChange}
        xGCSearchBtn_Dropdown_OnKeyUp_Load={fGCSearchBtn__Dropdown_OnKeyUp_Load}
        xGCSearchBtn_Columns_DropdownSearch={
          xGCSearchBtn_Columns_DropdownSearch
        }
        xGCSearchBtn_GridData={sGCSearchBtn_GridData}
        xfGCSearchBtn_OnRowClick={fGCSearchBtn_OnRowClick}
        xfGCSearchBtn_OnCellKeyDown={fGCSearchBtn_OnCellKeyDown}
      />
      {/* Audit  */}
      {/* <GCAudit
        xOpen={sAuditModal}
        xTitle={"AUDIT"}
        fCloseAuditModal={fCloseAuditModal}
        sAuditSelectArr={sAuditSelectArr}
        GridDataAuditColumns={GridDataAuditColumns}
        GridDataAuditRows={sGridDataAuditRows}
        xAuditId={xAuditId}
        fonChangeAuditSelect={fonChangeAuditSelect}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
      /> */}
      <GCAuditTblCard
        xOpen={sAuditModal}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
        fCloseAuditModal={setAuditModal}
        trnTyp={sTrnTyp}
        vocTyp={vRdxWmsHead.A_VocTyp}
        vocNo={vRdxWmsHead.A_VocNo}
      />

      {/* DiscountPercentage  */}
      <GCDiscountPercentage
        sDiscountPercentageModal={sDiscountPercentageModal}
        fCloseDiscountPercentageModal={fCloseDiscountPercentageModal}
        xGrossAmount={sFooterObj.A_GrossAmt}
        xLDiscAmount={sFooterObj.A_LDiscAmt}
        xTDiscAmount={sDiscPerModelObj.A_TDiscAmt}
        xTDiscPer={sDiscPerModelObj.A_DiscPerc}
        fonChangeInputDiscountModal={fonChangeInputDiscountModal}
        fOnChangeTDiscAmtModal={fOnChangeTDiscAmtModal}
        GetApplyTDiscount={GetApplyTDiscount}
        xErrorMsg_DiscPerc={sErrorMsgDiscountModal.A_DiscPerc}
        xErrorMsg_TDiscAmt={sErrorMsgDiscountModal.A_TDiscAmt}
        xRdx_DocStatus={vRdxWmsHead.A_DocStat !== "ENTER"}
        onFocus={(e) => {
          if (
            sDiscPerModelObj.A_DiscPerc == 0 &&
            e.target.name == "xTDiscAmount"
          ) {
            setDiscPerModelObj((obj) => ({
              ...obj,
              A_TDiscAmt: "",
            }));
          } else if (
            sDiscPerModelObj.A_DiscPerc == 0 &&
            e.target.name == "xTDiscPer"
          ) {
            setDiscPerModelObj((obj) => ({
              ...obj,
              A_DiscPerc: "",
            }));
          }
        }}
        onBlur={(e) => {
          if (
            sDiscPerModelObj.A_DiscPerc == "" &&
            e.target.name == "xTDiscAmount"
          ) {
            setDiscPerModelObj((obj) => ({
              ...obj,
              A_TDiscAmt: 0,
            }));
          } else if (
            sDiscPerModelObj.A_DiscPerc == "" &&
            e.target.name == "xTDiscPer"
          ) {
            setDiscPerModelObj((obj) => ({
              ...obj,
              A_DiscPerc: 0,
            }));
          }
        }}
      />
      {/* Batch  */}
      <GCBatch
        xOpen={sBatchModal && vRdxWmsHead?.A_AutoBatch === "N"} //lutfi
        xErrorMsg={sBatchDetailErrorMsg}
        GridDataBatchRows={sBatch_Load_GridData}
        GridDataBatchColumns={GridDataColumnsBatch}
        xOnRowClick={fBatch_RowClick_Load_Grid}
        xBatchUnit={sBatchUnit}
        xTitle="Batch setup"
        xHeadSrNo={sBatchObj.SrNo}
        xHeadItemCode={sBatchObj.ItemCode}
        xHeadItemName={sBatchObj.ItemName}
        xHeadQty={sBatchObj.Qty}
        xHeadUnit={sBatchObj.Unit}
        xHeadBaseQty={sBatchObj.BaseQty}
        xDetailSrNo={sBatchDetailObj.BatchDetail_SrNo}
        xDetailBatchNo={sBatchDetailObj.BatchDetail_BatchNo}
        xDetailMFDate={sBatchDetailObj.BatchDetail_MFDate}
        xDetailExpDate={sBatchDetailObj.BatchDetail_ExpDate}
        xDetailQty={sBatchDetailObj.BatchDetail_Qty}
        xDetailUnit={sBatchDetailObj.BatchDetail_Unit}
        xDetailBaseQty={sBatchDetailObj.BatchDetail_BaseQty}
        xDetailBalanceQty={sBatchDetailObj.BatchDetail_BalanceQty}
        xBatch_fSrNo={""}
        xBatch_fBatchNo={fBatch_BatchNo}
        xBatch_fMFDate={fBatch_MFDate}
        xBatch_fExpDate={fBatch_ExpDate}
        xBatch_fQty={fBatch_Qty}
        xfBatch_Focus_Qty={fBatch_Focus_Qty}
        xfBatch_Blur_Qty={fBatch_Blur_Qty}
        xBatch_fUnit={fBatch_Unit}
        xBatch_fBaseQty={""}
        xfBatch_Close={fBatch_CloseModal}
        xfBatch_New={fBatch_New}
        xfBatch_Delete={fBatch_Delete}
        xfBatch_Save={fBatch_Save}
        xBtnDisable={vRdxWmsHead.A_DocStat != "ENTER"}
        xTotalQty={sBatch_Total_Qty}
      />
      {/* //Sales Group Modal  */}
      <GCVanMaster
        open={sSalesGroupModal}
        xDocStatus={vRdxWmsHead.A_DocStat == "POST"}
        xVocNo={vRdxWmsHead.A_VocNo}
        xVocType={vRdxWmsHead.A_VocTyp}
        xVocTypeName={vRdxWmsHead.A_VocTypName}
        fCloseSalesGroupModal={fCloseSalesGroupModal}
        xSalesGroup={sSalesGroupData}
        xSaleGroupTypeArr={sSaleGroupTypeArr}
        xVanMasterModalObj={sSalesGroupModalObj}
        xMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xGetVanMasterSearchEnter={fGetVanMasterSearchEnter}
        xfOnVanMasterSrNoModal={fOnVanMasterSrNoModal}
        xfOnVanMasterEmployeeModal={fOnVanMasterEmployeeModal}
        xfOnVanMasterActiveModal={fOnVanMasterActiveModal}
        xfNewSaleGroup={fNewSaleGroupModal}
        xfSaveSaleGroup={fSaveSaleGroupModal}
        xfDeleteSaleGroup={fDeleteSaleGroupModal}
        xfOnVanMasterTypModal={fOnVanMasterTypModal}
        xrows={sSalesGroupModalArr}
        xcolumns={GridDataColumnsSalesGroupModal}
        xRowClick={fVanMasterRowClick}
        xRowCellClick={fVanMasterRowCellClick}
        xErrorMsg={sErrorMsgVanMaster}
      />
      {/* //GCEmployee */}
      <GCEmployee
        open={sSalesGroupEmployeeModal}
        xCloseSearchModal={fCloseSalesGroupEmployeeModal}
        xTitle={"Employee"}
        xAnyData={""}
        xModelObj={sSalesGroupEmployeeModelObj}
        xSearchEnter={fEmployeeSearchEnter}
        xonChangeInputModal={fonChangeInputEmployeeModal}
        xGridArr={sEmployeeSearchResultArr}
        xGridDataColumnsSearch={GridDataColumnsEmployeeModal}
        xRowClick={fEmployeeRowClick}
        xRowCellClick={fEmployeeRowCellClick}
        xClearSimpleSearch={fClearEmployeeSearch}
        xMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
      />
      <Modal
        open={false}
        // open={sDocumentModal}
        onClose={fCloseDocumentModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-popup">
          <div className="text-end">
            <CloseIcon
              style={{ color: "#ffff" }}
              onClick={fCloseDocumentModal}
            />
          </div>
          <div className="text-center px-3">
            <h1>Any Desk</h1>
          </div>
          <div className="container">
            <div className="row text-center py-4 my-4">
              <div className="col-6">
                <h4>
                  Do you believe that you <br></br> are{" "}
                  <span style={{ color: "#ef433a" }}>wrongly identified</span>
                  <br></br> as a professional user?
                </h4>
              </div>
              <div className="col-6">
                <h4>
                  You <span style={{ color: "#ef433a" }}> already have a </span>
                  <br></br> <span style={{ color: "#ef433a" }}>license</span>{" "}
                  but still receive<br></br> notification
                </h4>
              </div>
            </div>
            <div className="row text-center py-4 my-4">
              <div className="col-6">
                <button type="button" class="modal-popup-btn">
                  Take Action
                </button>
              </div>
              <div className="col-6">
                <button type="button" class="modal-popup-btn">
                  Resolve Issue
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      {/* GCLoadedCost */}
      <GCLandedCost
        fCustomer={fCustomer}
        fFreight={fFreight}
        open={sLandedCostModal}
        onClose={fCloseLandedCostModal}
        xTitle={"Freight & charges account"}
        xClose={fCloseLandedCostModal}
        xSave={fLoaded_Cost_Save}
        xLoaded_Cost_GRNType={vRdxWmsHead.A_VocTyp}
        xLoaded_Cost_GRNNo={vRdxWmsHead.A_VocNo}
        //input
        xLoaded_Cost_Freight={vRdxWmsHead.A_LC}
        xLoaded_Cost_Customs={vRdxWmsHead.A_Charges1}
        xLoaded_Cost_Discount={
          vRdxWmsHead.A_DiscFlag == "Y" ? 0 : sFooterObj.A_TDiscAmt
        }
        xLoaded_Cost_DiscAmt={sLandedCostDiscAmt}
        //Loaded_Cost
        xLoaded_Cost_AccountArr={sLoadedCostAccountArr}
        xLoaded_Cost_Obj={sLandedCostObjModal}
        xLandedCostObjError={sLandedCostObjError}
        xLoaded_Cost_ToggleArr={sLoadedCostToggleData}
        //freightAcc
        xfLoaded_Cost_Freight_Acc={xfLoaded_Cost_Freight_Acc}
        xfLoaded_Cost_Freight_Name={xfLoaded_Cost_Freight_Name}
        xLoaded_Cost_Freight_Toggle={sLoaded_Cost_Freight_ToggleDropDowm}
        xLoaded_Cost_Freight_onKeyUp={fLoaded_Cost_Freight_onKeyUp}
        xLoaded_Cost_Freight_SearchDropdownObj={
          sLoaded_Cost_Freight_SearchDropdownObj
        }
        xLoaded_Cost_Freight_Dropdown_onChange={
          fLoaded_Cost_Freight_Dropdown_onChange
        }
        xLoaded_Cost_Freight_Dropdown_OnKeyUp_Load={
          fLoaded_Cost_Freight_Dropdown_OnKeyUp_Load
        }
        xLoaded_Cost_Freight_Columns_DropdownSearch={
          xLoaded_Cost_Freight_Columns_DropdownSearch
        }
        xLoaded_Cost_Freight_GridData={sLoaded_Cost_Freight_GridData}
        xfLoaded_Cost_Freight_OnCellKeyDown={fLoaded_Cost_Freight_OnCellKeyDown}
        xfLoaded_Cost_Freight__OnRowClick={fLoaded_Cost_Freight_OnRowClick}
        //Customs

        xfLoaded_Cost_Customs_Acc={xfLoaded_Cost_Customs_Acc}
        xfLoaded_Cost_Customs_Name={xfLoaded_Cost_Customs_Name}
        xLoaded_Cost_Customs_Toggle={sLoaded_Cost_Customs_ToggleDropDowm}
        xLoaded_Cost_Customs_onKeyUp={fLoaded_Cost_Customs_onKeyUp}
        xLoaded_Cost_Customs_SearchDropdownObj={
          sLoaded_Cost_Customs_SearchDropdownObj
        }
        xLoaded_Cost_Customs_Dropdown_onChange={
          fLoaded_Cost_Customs_Dropdown_onChange
        }
        xLoaded_Cost_Customs_Dropdown_OnKeyUp_Load={
          fLoaded_Cost_Customs_Dropdown_OnKeyUp_Load
        }
        xLoaded_Cost_Customs_Columns_DropdownSearch={
          xLoaded_Cost_Customs_Columns_DropdownSearch
        }
        xLoaded_Cost_Customs_GridData={sLoaded_Cost_Customs_GridData}
        xfLoaded_Cost_Customs_OnCellKeyDown={fLoaded_Cost_Customs_OnCellKeyDown}
        xfLoaded_Cost_Customs__OnRowClick={fLoaded_Cost_Customs_OnRowClick}
        //Discount
        xfLoaded_Cost_Discount_Name={xfLoaded_Cost_Discount_Name}
        xLoaded_Cost_Discount_Toggle={sLoaded_Cost_Discount_ToggleDropDowm}
        xLoaded_Cost_Discount_onKeyUp={fLoaded_Cost_Discount_onKeyUp}
        xLoaded_Cost_Discount_SearchDropdownObj={
          sLoaded_Cost_Discount_SearchDropdownObj
        }
        xLoaded_Cost_Discount_Dropdown_onChange={
          fLoaded_Cost_Discount_Dropdown_onChange
        }
        xLoaded_Cost_Discount_Dropdown_OnKeyUp_Load={
          fLoaded_Cost_Discount_Dropdown_OnKeyUp_Load
        }
        xLoaded_Cost_Discount_Columns_DropdownSearch={
          xLoaded_Cost_Discount_Columns_DropdownSearch
        }
        xLoaded_Cost_Discount_GridData={sLoaded_Cost_Discount_GridData}
        xfLoaded_Cost_Discount_OnCellKeyDown={
          fLoaded_Cost_Discount_OnCellKeyDown
        }
        xfLoaded_Cost_Discount__OnRowClick={fLoaded_Cost_Discount_OnRowClick}
        //SplDiscount
        xfLoaded_Cost_SplDiscount_Name={xfLoaded_Cost_SplDiscount_Name}
        xLoaded_Cost_SplDiscount_Toggle={
          sLoaded_Cost_SplDiscount_ToggleDropDowm
        }
        xLoaded_Cost_SplDiscount_onKeyUp={fLoaded_Cost_SplDiscount_onKeyUp}
        xLoaded_Cost_SplDiscount_SearchDropdownObj={
          sLoaded_Cost_SplDiscount_SearchDropdownObj
        }
        xLoaded_Cost_SplDiscount_Dropdown_onChange={
          fLoaded_Cost_SplDiscount_Dropdown_onChange
        }
        xLoaded_Cost_SplDiscount_Dropdown_OnKeyUp_Load={
          fLoaded_Cost_SplDiscount_Dropdown_OnKeyUp_Load
        }
        xLoaded_Cost_SplDiscount_Columns_DropdownSearch={
          xLoaded_Cost_SplDiscount_Columns_DropdownSearch
        }
        xLoaded_Cost_SplDiscount_GridData={sLoaded_Cost_SplDiscount_GridData}
        xfLoaded_Cost_SplDiscount_OnCellKeyDown={
          fLoaded_Cost_SplDiscount_OnCellKeyDown
        }
        xfLoaded_Cost_SplDiscount__OnRowClick={
          fLoaded_Cost_SplDiscount_OnRowClick
        }
      />
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />

      <GCMSPUpdate
        xOpen={sMSPUpdateModal}
        fCloseDetailModal={fCloseMSPUpdateModal}
        GridDataMSPUpdateColumns={sGridDataMSPUpdateColumns}
        GridDataMSPUpdateRows={sGridDataMSPUpdateRows}
        xTitle={"Item RSP ,MSP & OverHead Setting - GRN"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
        setGridDataMSPUpdateRows={setGridDataMSPUpdateRows}
        MSPUpdateSaveBtn={
          sGridDataMSPUpdateRows.length === 0
          //  ||   vRdxWmsHead?.A_DocStat?.toUpperCase() === "POST"
        }
        fMSP_SAVE={async () => {
          if (vRdxWmsHead?.A_DocStat?.toUpperCase() == "DELETE") {
            fAlertToast(
              "FAILED",
              "Not Allowed to save in " + vRdxWmsHead?.A_DocStat + "mode"
            );
            return;
          } else {
            // let itemWithMSP = sGridDataMSPUpdateRows.find(
            //   (item) =>
            //     Number(item.MSPGPPerc) !=
            //     Number(
            //       (
            //         ((Number(item.MSP) - Number(item.CostPr)) /
            //           Number(item.MSP)) *
            //         100
            //       ).toFixed(2)
            //     )
            // );
            // if (itemWithMSP) {
            //   fAlertToast(
            //     "FAILED",
            //     "Invalid MSPGPPerc calculation MSPGPPerc=" +
            //       itemWithMSP.MSPGPPerc +
            //       " but MSPGPPerc should be" +
            //       ((Number(itemWithMSP.MSP) - Number(itemWithMSP.CostPr)) /
            //         Number(itemWithMSP.MSP)) *
            //         100
            //   );
            //   return;
            // }

            const LineItemsArray = sGridDataMSPUpdateRows.map((item) => ({
              ItmCd: item.ItmCd,
              B_unit: item.B_unit,
              SellPr1: item.SellPr1,
              CostPr: item.CostPr,
              GPPerc: item.GPPerc,
              MSP: item.MSP,
              MSPGPPerc: item.MSPGPPerc,
              TSROH: item.TSROH,
            }));

            let iObj = {
              v_VocTyp: vRdxWmsHead.A_VocTyp,
              v_VocNo: vRdxWmsHead.A_VocNo,
              UserCd: vRdxuserInfo.UserID,
              IP: vRdxuserInfo.IP,
              Loc: vRdxWmsHead.A_Loc,
              LineItems: LineItemsArray,
            };
            let vRespi = await WMSIInbound_WMINV03MSPSave_API(iObj);
            if (vRespi?.status === 200) {
              fNewDetail(
                vRdxWmsHead.A_VocNo,
                vRdxWmsHead.A_Rounding,
                vRdxWmsHead.A_VocTyp,
                vRdxWmsHead.TaxType
              );
              fLoad_Grid(
                vRdxWmsHead.A_VocNo, //0
                0, //srno
                vRdxWmsHead.A_Rounding,
                setDetailGridData,
                setFooterObj,
                vRdxWmsHead?.A_VocTyp
              );
              fCloseMSPUpdateModal();
            }
          }
        }}
      />

      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />

      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />

      <GCPendingStock
        xOpen={sPendingPoModal}
        fCloseDetailModal={fClosePendingPoModal}
        sPendingPoData={sPendingPoData}
        xTitle={"Pending Po Detail"}
      />
      <GCPallet
        xOpen={sPalletModal}
        fCloseDetailModal={fClosePalletModal}
        Data={sPalletData}
        // Data={[]}
        xTitle={"Pallet Detail"}
      />
      <GcReferenceUpdate
        xOpen={refUpdate}
        fCloseDetailModal={() => {
          setRefUpdate(false);
        }}
        xTitle={"Reference Update"}
        vRdxWmsHead={vRdxWmsHead}
        fNewDetail={fNewDetail}
      />
      <GCLoadFromPo
        xOpen={sLoadPoModal}
        fCloseLoadPoModal={fCloseLoadPoModal}
        xTitle={"Load Po Detail"}
        fNewDetail={fNewDetail}
      />
    </div>
  );
}
